import { deepMerge } from './merge';
import { getShellUiOverlay } from '../data/shellUiTranslations';
import { getScreenUiOverlay } from '../data/screenUiTranslations';
import { phaseMyPageDashboardKo } from './partials/i18nPhaseMyPageDashboard';
import { phaseE1Ko } from './partials/i18nPhaseE1DashboardTabs';
import { phaseE2Ko } from './partials/i18nPhaseE2BookingTab';
import { phaseE3Ko } from './partials/i18nPhaseE3ManageBookingPanels';
import { phaseE4Ko } from './partials/i18nPhaseE4OverviewSectionLabels';
import { phaseGroupsCreateKo } from './partials/i18nPhaseGroupsCreate';
import { phaseGroupsListDetailKo } from './partials/i18nPhaseGroupsListDetail';
import { phaseGroupCategoriesKo } from './partials/i18nPhaseGroupCategories';
import { phaseTradeChatKo } from './partials/i18nPhaseTradeChat';
import { phaseHandleH0Ko } from './partials/i18nPhaseHandleH0';
import { phaseP0DashKo } from './partials/i18nPhaseP0DashboardPlanAds';
import { phaseManageWidgetsKo } from './partials/i18nPhaseManageFormWidgets';
import { phaseP0CatalogKo } from './partials/i18nPhaseP0CatalogForms';
import { phaseFoodOrderFlowKo } from './partials/i18nPhaseFoodOrderFlow';
import { phaseUserAddressBookKo } from './partials/i18nPhaseUserAddressBook';
import { phaseHomeWeatherHourlyKo } from './partials/i18nPhaseHomeWeatherHourly';
import { phaseLostFoundResolveKo } from './partials/i18nPhaseLostFoundResolve';
import { phaseBrandCatalogKo } from './partials/i18nPhaseBrandCatalog';
import { phaseMenuFeedKo } from './partials/i18nPhaseMenuFeed';
import { phaseBrandPageKo } from './partials/i18nPhaseBrandPage';
import { phaseLocationSetupKo } from './partials/i18nPhaseLocationSetup';
import { phaseAdminCoreKo } from './partials/i18nPhaseAdminCore';
import { phaseBusinessRegInquiryKo } from './partials/i18nPhaseBusinessRegInquiry';
import { phaseJobsHireGateKo } from './partials/i18nPhaseJobsHireGate';
import { phaseSearchSurfaceKo } from './partials/i18nPhaseSearchSurface';
import { phaseHubEmptyKo } from './partials/i18nPhaseHubEmpty';
import { phaseBizNotifKo } from './partials/i18nPhaseBusinessNotifications';
import { phaseCatalogBookingKo } from './partials/i18nPhaseCatalogDetailBooking';
import { phaseCreatorCommissionKo } from './partials/i18nPhaseCreatorCommission';
import { phaseTravelerFormKo } from './partials/i18nPhaseTravelerForm';
import { phaseRestaurantRegisterKo } from './partials/i18nPhaseRestaurantRegister';
import { phaseLocalRegisterChipsKo } from './partials/i18nPhaseLocalRegisterChips';
import { phaseMentorBusinessRegisterKo } from './partials/i18nPhaseMentorBusinessRegister';
import { phaseLocalRegisterChips2Ko } from './partials/i18nPhaseLocalRegisterChips2';
import { phaseWriteChipsKo } from './partials/i18nPhaseWriteChips';
import { phaseLiveHangulKo } from './partials/i18nPhaseLiveHangul';

const ko = {
  common: {
    appName: '밍고',
    tabBar: '메인 메뉴',
    preparing: '준비중입니다.',
    report: '신고',
    done: '완료',
    cancel: '취소',
    confirm: '확인',
    save: '저장',
    back: '뒤로',
    close: '닫기',
    more: '더보기',
    loadingLabel: '로딩 중…',
    uploading: '업로드 중…',
    viewAll: '전체 보기',
    share: '공유',
    loadMore: '더 보기',
    search: '검색',
    all: '전체',
  },
  settings: {
    messengerTitle: '알림 메신저 연결',
    messengerDesc: '원하는 메신저로 밍고 알림을 받으세요',
    messengerConnect: '연결',
    messengerConnected: '연결됨',
    messengerSaved: '메신저가 연결됐습니다',
    messengerVnBadge: '🇻🇳 베트남',
    messengerChannels: {
      kakao: '카카오톡',
      zalo: '잘로',
      telegram: '텔레그램',
      whatsapp: '왓츠앱',
      sms: 'SMS',
    },
    resetLocation: '위치 초기화',
    resetLocationConfirm: '설정한 위치 정보가 초기화됩니다. 계속할까요?',
  },
  about: {
    title: '서비스 소개',
  },
  privacy: {
    title: '개인정보처리방침',
    section1Title: '수집하는 개인정보',
    section1Body:
      '밍고는 서비스 제공을 위해 다음 정보를 수집합니다.\n- 이름, 닉네임\n- 이메일 주소\n- 거주 국가 및 도시\n- 서비스 이용 기록\n- 기기 정보 (앱 푸시 알림용)',
    section2Title: '개인정보 이용 목적',
    section2Body:
      '수집한 정보는 다음 목적으로만 사용됩니다.\n- 서비스 제공 및 개선\n- 알림 발송\n- 고객 지원\n- 부정 이용 방지',
    section3Title: '개인정보 보관 기간',
    section3Body:
      '회원 탈퇴 시 모든 개인정보는 즉시 삭제됩니다.\n단, 관련 법령에 따라 일정 기간 보관이 필요한 정보는 예외로 합니다.',
    section4Title: '개인정보 제3자 제공',
    section4Body:
      '밍고는 유저의 동의 없이 개인정보를 제3자에게 제공하지 않습니다.\n법령에 의한 요청이 있는 경우는 예외입니다.',
    section5Title: '문의처',
    section5Body: '개인정보 관련 문의는 앱 내 고객지원 채널을 이용해주세요.',
    updated: '최종 업데이트',
  },
  terms: {
    title: '이용약관',
    section1Title: '서비스 소개',
    section1Body:
      '밍고(Mingo)는 해외 교민을 위한 커뮤니티 플랫폼입니다.\n본 약관은 밍고 서비스 이용에 관한 기본 사항을 규정합니다.',
    section2Title: '이용 규칙',
    section2Body:
      '다음 행위는 금지됩니다.\n- 타인 사칭 또는 허위 정보 등록\n- 스팸, 광고성 게시물 도배\n- 불법 거래 또는 사기 행위\n- 타인의 개인정보 무단 수집\n- 서비스 운영 방해 행위',
    section3Title: '콘텐츠 책임',
    section3Body:
      '유저가 작성한 게시물의 책임은 작성자에게 있습니다.\n밍고는 유저 간 거래에서 발생하는 분쟁에 대해 책임지지 않습니다.',
    section4Title: '서비스 변경 및 중단',
    section4Body:
      '밍고는 서비스 내용을 변경하거나 중단할 수 있습니다.\n중요한 변경 사항은 사전에 공지합니다.',
    section5Title: '준거법',
    section5Body: '본 약관은 대한민국 법률을 준거법으로 합니다.',
    updated: '최종 업데이트',
  },
  refund: {
    title: '환불정책',
    updated: '최종 업데이트',
  },
  register: {
    goToDashboard: '프로필로 이동',
  },
  status: {
    all: '전체',
    approved: '승인',
    pending: '심사중',
    pending_review: '심사 대기',
    limited: '제한됨',
    shadow_blocked: '스팸 의심',
    paused: '일시중지',
    draft: '임시저장',
    rejected: '반려',
    suspended: '정지',
    rejectedReason: '사유',
    reRegister: '다시 등록',
  },
  admin: {
    adBotSettings: {
      title: '광고 AI 상담챗봇 설정',
      loading: '불러오는 중...',
      loadFailed: '불러오기 실패',
      saveFailed: '저장 실패',
      desc: '여기 입력한 값만 챗봇이 그대로 안내합니다. 비워두면 챗봇은 "확인 후 안내드리겠다"고만 답합니다. 가격/계좌는 절대 AI가 지어내지 않도록 설계되어 있으니, 실제 고객에게 안내할 값만 입력하세요.',
      noSettingsRow: '설정 행을 찾을 수 없습니다. DB 마이그레이션이 적용되었는지 확인해주세요.',
      pricingTitle: '광고 요금 (스코프별)',
      scopeNeighborhood: '동네',
      scopeCity: '도시',
      scopeCountry: '국가',
      scopeGlobal: '전체',
      amountPlaceholder: '금액',
      currencyPlaceholder: '통화',
      periodPlaceholder: '주기 (예: month)',
      bankTitle: '입금 계좌 (챗봇이 고객에게 그대로 안내)',
      bankNamePlaceholder: '은행명',
      bankHolderPlaceholder: '예금주',
      bankNumberPlaceholder: '계좌번호',
      paymentNotesTitle: '결제 관련 참고사항',
      paymentNotesPlaceholder: '예: 입금 후 스크린샷을 이 채팅방에 보내주시면 확인 후 광고를 게재해드립니다.',
      faqTitle: '자주 묻는 질문 (FAQ) — 챗봇 참고용',
      faqPlaceholder: '자유 형식으로 입력. 예: Q. 광고는 며칠 안에 노출되나요? A. 입금 확인 후 1영업일 이내 노출됩니다.',
      extraTitle: '추가 지침 (선택)',
      extraHint: '챗봇의 말투나 추가 규칙을 자유롭게 입력하세요. (예: "존댓말만 사용", "할인 문의는 항상 사람이 확인한다고 답할 것")',
      savedAt: '저장되었습니다 ({time})',
      saving: '저장 중...',
      save: '저장',
    },
    summaryTitle: '전체 현황 요약',
    summaryHint: 'businesses.moderation_status · report_logs(리뷰 신고) · no_show_records 기준입니다.',
    summaryRefresh: '요약 새로고침',
    summary: {
      pending: '승인대기',
      todayNew: '오늘 신규',
      reportedReviews: '신고된 리뷰',
      totalApproved: '승인완료 업체',
      noShowPending: '노쇼 처리대기',
      shortsPending: '쇼츠 대기',
      chargeRequestsPending: '충전 요청 대기',
      subscriptionsActive: '활성 구독',
    },
    businessesTitle: '업체 관리',
    reviewsTitle: '리뷰 신고 처리',
    reviewsHint: 'target_type=review 이고 status=pending 인 신고만 표시합니다.',
    empty: '데이터가 없습니다.',
    approve: '승인',
    reject: '반려',
    suspend: '정지',
    restore: '복구',
    rejectReasonPrompt: '반려 사유 (선택)',
    suspendReasonPrompt: '정지 사유 (선택)',
    reportReason: '신고 사유',
    deleteReview: '리뷰 삭제',
    keepReview: '신고 기각',
    noShow: '노쇼 관리',
    noShowHint: 'no_show_records 중 pending 만 표시합니다.',
    noShowConfirm: '노쇼 확정',
    noShowDismiss: '기각',
    bookings: '예약 관리',
    bookingsHint: '전체 예약(booking_ledger)을 상태별로 조회합니다.',
    bookingsPackageFallback: '상품명 없음',
    bookingsParty: '{n}명',
    bookingsCreatedAt: '신청일 {date}',
    bookingsSearchPlaceholder: '업체명, 상품명, 닉네임 검색',
    bookingsSearchBtn: '검색',
    bookingStatus: {
      all: '전체',
      pending: '대기중',
      holding: '보류중',
      confirmed: '확정',
      in_progress: '진행중',
      completed: '완료',
      cancelled: '취소됨',
      failed: '실패',
    },
    settlements: {
      pageTitle: '정산 관리',
      pageDesc: '업체별 정산대기 금액을 확인하고 송금 후 정산완료 처리를 합니다.',
      empty: '정산 대기 내역이 없습니다.',
      pendingCount: '정산대기 {n}건',
      noAccount: '정산 계좌 미등록',
      showDetail: '내역 보기',
      hideDetail: '내역 숨기기',
      markPaidBtn: '정산완료 처리',
      confirmMarkPaid: '{name}에 {amount} 정산완료 처리할까요? 실제 송금을 먼저 완료한 뒤 눌러주세요.',
      errMarkPaidFailed: '정산완료 처리에 실패했습니다.',
      feeLabel: '수수료 {fee}',
      status: {
        holding: '정산대기',
        payable: '정산대기',
        paid: '정산완료',
        disputed: '분쟁중',
        refunded: '환불됨',
      },
    },
    medicines: '약품 관리',
    activate: '활성화',
    deactivate: '비활성화',
    actions: '액션',
    stats: {
      title: '통계',
      domainChart: '도메인별 등록 현황',
      dailyNew: '일별 신규 등록 (7일)',
      approvalRate: '승인률',
    },
    domain: {
      all: '전체 도메인',
      hospital: '병원',
      restaurant: '맛집',
      rental: '렌트',
      academy: '학원',
      hotel: '호텔',
      visa_service: '비자/행정',
      property: '부동산',
      guide: '가이드',
    },
    businessRow: {
      optionEdit: '옵션수정',
      recommendOn: '추천ON',
      recommendOff: '추천OFF',
      singlePortionOn: '1인ON',
      singlePortionOff: '1인OFF',
      deliveryFeePrefix: '배달비',
      freeDeliverySuffix: ' · 무료배달',
      noServiceOptions: '서비스 옵션 없음',
      approveFailScope: '승인 실패(담당 국가/도시 범위를 벗어난 업체일 수 있습니다)',
      rejectFailScope: '거절 실패(담당 국가/도시 범위를 벗어난 업체일 수 있습니다)',
      suspendFailScope: '정지 실패(담당 국가/도시 범위를 벗어난 업체일 수 있습니다)',
      restoreFailScope: '복구 실패(담당 국가/도시 범위를 벗어난 업체일 수 있습니다)',
      serviceOptionsHint: '허용 옵션: {list}',
      serviceOptionsPrompt: '콤마로 입력하세요. 비우면 옵션 제거됩니다.',
      foodUnclassifiedFilter: '미분류만 ({count})',
      foodUnclassifiedHint: '음식/카페 대분류(food_menu_category)가 없는 업체만 봅니다',
      foodUnclassifiedTag: '미분류',
      foodMenuCategoryEdit: '대분류 설정',
      foodMenuCategoryPrompt: '대분류 key를 입력하세요 (비우면 미분류로 초기화):',
      foodMenuCategoryInvalid: '허용되지 않는 대분류 key입니다',
      commissionLabel: '수수료 {rate}%',
      commissionEdit: '수수료 수정',
      commissionPrompt: '수수료율(%)을 입력하세요 (0~100):',
      commissionInvalid: '올바른 숫자(0~100)를 입력하세요',
    },
    nav: {
      scamContacts: '취업피해검색 관리',
      reports: '신고 관리',
    },
    common: {
      colType: '유형',
      colDate: '등록일',
      colStatus: '상태',
      colActions: '액션',
      languageAll: '전체',
    },
    scamContacts: {
      title: '취업피해검색 관리',
      filterAll: '전체',
      statusPending: '검토대기',
      statusVerified: '공개(검증됨)',
      statusRejected: '반려',
      colContact: '연락처',
      colCompany: '회사명',
      colDescription: '내용',
      colDate: '등록일',
      colStatus: '상태',
      colActions: '액션',
      loading: '불러오는 중…',
      verify: '검증(공개)',
      reject: '반려',
      updateFailed: '상태 변경에 실패했습니다.',
    },
    reports: {
      colTarget: '대상 ID',
      colReporter: '신고자 ID',
      statusPending: '대기',
      statusReviewing: '검토중',
      statusResolved: '처리완료',
      statusDismissed: '반려',
      actionWarn: '경고 발송',
      actionDeletePost: '게시물 삭제',
      actionDeactivateJob: '공고 비활성화',
      actionSanctionUser: '유저 제재',
      actionDismiss: '반려',
      jobActionFailed: '공고 비활성화에 실패했습니다.',
      actionFailed: '처리에 실패했습니다.',
    },
  },
  adminUi: {
    "dashboard": {
      "chartAria": "일별 가입자 (최근 14일)",
      "title": "대시보드",
      "intro": "Supabase RPC 통계와 브라우저에 저장된 샘플 지표를 함께 표시합니다. 원격 통계는 마이그레이션 적용 및 RPC 배포 후 갱신됩니다.",
      "refreshLoading": "불러오는 중…",
      "refreshReady": "원격 통계 새로고침",
      "remoteErrPrefix": "원격:",
      "supabaseSummary": "Supabase 요약",
      "cityStatsNote": "도시 범위 통계 (region = {scope})",
      "totalUsersDb": "총 유저 (DB)",
      "publicUsers": "public.users",
      "adCtr": "광고 CTR",
      "adCtrSub": "ad_stats 클릭 / 노출",
      "usersByCountry": "국가별 유저 (residence_country)",
      "usersByLang": "언어별 유저",
      "productsByCategory": "카테고리별 상품 수",
      "signups14": "일별 가입자 (최근 14일)",
      "topLocations": "인기 지역 (상품 location)",
      "noData": "데이터 없음",
      "propertiesSection": "부동산 매물",
      "propTotal": "전체 매물 수",
      "propToday": "오늘 신규 매물",
      "propReported": "신고된 매물(미처리)",
      "topWishlist": "찜하기 많은 매물 TOP 5 (property_wishlist)",
      "wishlistEmptyNote": "데이터 없음 (위시리스트 미연동 또는 RLS)",
      "opsSection": "운영 통계",
      "totalUsers": "전체 유저 수",
      "todaySignups": "오늘 가입자",
      "totalBusinesses": "전체 업체 수",
      "pendingBusinesses": "승인 대기 업체 수",
      "runningAds": "진행중인 광고 수",
      "pendingAds": "승인 대기 광고 수",
      "todaySos": "오늘 SOS 요청 수",
      "unresolvedReports": "미해결 신고 수",
      "totalPointsIssued": "총 밍고 포인트 발행량"
    },
    "system": {
      "saved": "저장되었습니다.",
      "title": "시스템 설정",
      "intro": "로컬스토리지에 저장되며 앱의 광고 간격·수수료 계산에 반영됩니다.",
      "tablistAria": "시스템 / 포인트",
      "tabSystem": "시스템",
      "tabPoints": "💰 포인트 관리",
      "tabErrors": "🔴 에러 로그",
      "newErrorsBadge": "새 에러 발생!",
      "cityAdminTitle": "City Admin 계정",
      "cityAdminBody": "기존 가입 사용자에게 도시 관리자 권한을 부여하거나, 신규 계정을 만들고 권한을 붙입니다. 신규 생성 시 이메일 인증이 켜져 있으면 확인 후 프로필 갱신이 필요할 수 있습니다.",
      "emailLabel": "대상 이메일",
      "cityLabel": "담당 도시 (region_key)",
      "promoteOk": "기존 사용자에게 City Admin 권한을 부여했습니다.",
      "promoteFail": "실패: {msg}",
      "promoteBtn": "기존 계정에 권한 부여",
      "newAccountHeading": "신규 계정 + 임시 비밀번호",
      "newAccountBody": "슈퍼 관리자 비밀번호를 입력해야 세션을 복구합니다. 생성된 임시 비밀번호를 안전하게 전달하세요.",
      "tempPwdLabel": "임시 비밀번호 (자동 생성)",
      "tempPwdPh": "생성 버튼 클릭",
      "generateBtn": "생성",
      "superPwdLabel": "슈퍼 관리자 비밀번호 (재로그인용)",
      "superNotFound": "세션에서 슈퍼 이메일을 찾지 못했습니다.",
      "createOk": "신규 City Admin 계정을 준비했습니다.",
      "createFail": "실패: {msg}",
      "createBtn": "신규 계정 생성 후 권한 부여",
      "confirmOpenRegion": "이 지역을 오픈하고 대기자 전체에 알림을 보낼까요?",
      "wlActionOpen": "오픈 + 알림 처리",
      "confirmNotifyOnly": "이 지역의 대기자 전체(오픈 여부 무관)에게 알림만 보낼까요?",
      "wlActionNotify": "알림 {n}건",
      "commissionTitle": "수수료",
      "commissionOn": "수수료 활성화",
      "announcementLabel": "안내 문구",
      "tradeRate": "중고거래 수수료율 (%)",
      "rentRate": "렌트 수수료율 (%)",
      "jobFixed": "구인구직 고정 ($)",
      "jobPremTitle": "구인구직 프리미엄",
      "jobPremOn": "구인구직 수수료(프리미엄) ON — 목록에 단가 안내 표시",
      "jobPremHint": "기본 OFF. 옵션 결제는 준비 중이며, 단가만 앱에 표시됩니다.",
      "pinUsd": "상단 노출 ($/주)",
      "urgentUsd": "급구 배지 ($)",
      "resumeUsd": "이력서 열람 ($)",
      "adSlotsTitle": "광고 슬롯",
      "feedInterval": "피드 광고 간격 (N개마다)",
      "commInterval": "커뮤니티 광고 간격",
      "adPriceTitle": "광고 단가 ($/월)",
      "tierLocal": "동네",
      "tierCity": "도시",
      "tierNational": "국가",
      "tierGlobal": "글로벌",
      "stripeTitle": "Stripe 결제",
      "stripeOn": "결제 시스템 ON (앱에서 카드 결제 시도 허용)",
      "stripeBody": "기본 OFF. 켜려면 .env에 REACT_APP_PAYMENT_ENABLED=true, 유효한 REACT_APP_STRIPE_PUBLISHABLE_KEY(pk_test… 또는 pk_live…), 그리고 PaymentIntent 발급용 REACT_APP_STRIPE_PAYMENT_API_URL(Edge Function 등 POST 엔드포인트)가 필요합니다. 영수증 이메일은 추후 연동 예정입니다.",
      "stripeDash": "Stripe 대시보드:",
      "paymentTotalLabel": "완료 결제 합계 (USD)",
      "thWhen": "일시",
      "thType": "유형",
      "thAmount": "금액",
      "thStatus": "상태",
      "paymentEmpty": "내역 없음",
      "appBannerTitle": "앱 공지 배너",
      "bannerLabel": "배너 텍스트",
      "bannerPh": "예: 안전거래 베타 오픈 예정",
      "bannerOn": "배너 활성화",
      "featureFlagsHint": "Supabase `feature_flags` — `users.is_admin` 계정만 DB에 반영됩니다. 실패 시 메시지를 확인하세요.",
      "flagsSaveBtn": "기능 설정 저장",
      "flagsLoadFail": "플래그를 불러오지 못했습니다.",
      "thKey": "키",
      "thOn": "ON",
      "saveBtn": "저장"
    },
    "posts": {
      "pageTitle": "게시글·신고 관리",
      "reportList": "신고 목록",
      "deselectAll": "전체 해제",
      "selectAll": "전체 선택",
      "bulkHide": "선택 숨기기",
      "bulkRestore": "선택 복구",
      "bulkDelete": "선택 영구삭제",
      "thTitle": "제목",
      "thAuthor": "작성자",
      "thReports": "신고수",
      "thDate": "날짜",
      "thStatus": "상태",
      "thActions": "작업",
      "selectAria": "선택",
      "hide": "숨기기",
      "warnAuthor": "작성자 경고",
      "blockAuthor": "작성자 차단",
      "permanentDelete": "영구삭제",
      "hiddenSection": "자동 숨김된 글 (상태: 숨김)",
      "hiddenHint": "신고 3회 이상으로 숨김 처리된 항목입니다.",
      "emptyHidden": "자동/수동 숨김 글이 없습니다.",
      "restore": "복구",
      "mediaSection": "자동 숨김 이미지 (미디어 신고 3회+)",
      "thUrl": "URL",
      "thCount": "누적 신고",
      "thTime": "시간",
      "thAct": "작업",
      "restoreClear": "복구·신고초기화",
      "emptyMedia": "항목이 없습니다.",
      "statusOpen": "처리중",
      "statusHidden": "숨김",
      "statusRestored": "복구됨"
    },
    "properties": {
      "title": "매물 관리",
      "cityScope": "도시 범위:",
      "stats": "통계",
      "total": "전체 매물",
      "active": "활성(active)",
      "reserved": "예약중",
      "todayNew": "오늘 신규",
      "reportedPending": "신고 접수(미처리)",
      "filters": "필터",
      "searchPh": "제목·주소 검색",
      "refresh": "새로고침",
      "listTitle": "매물 목록 ({n})",
      "loading": "불러오는 중…",
      "thImage": "이미지",
      "thTitleAddr": "제목 / 주소",
      "thTx": "거래",
      "thPrice": "가격",
      "thOwner": "등록자",
      "thCreated": "등록일",
      "thViews": "조회",
      "thStatus": "상태",
      "thActions": "작업",
      "approveShow": "승인(노출)",
      "hide": "숨김",
      "detail": "상세",
      "publicPage": "공개페이지",
      "delete": "삭제",
      "reportsBtn": "신고 ({n})",
      "detailTitle": "매물 상세",
      "landlord": "임대인",
      "reportList": "신고 내역",
      "resolve": "처리완료",
      "dismiss": "기각",
      "noLinkedReports": "연결된 신고 없음 (target_type=property 등록 시 표시)",
      "close": "닫기",
      "reportModalTitle": "신고 내역 — {title}",
      "noReports": "신고 없음",
      "confirmDelete": "이 매물을 삭제할까요? 되돌릴 수 없습니다.",
      "type": {
        "all": "전체 유형",
        "long_stay": "장기",
        "short_stay": "단기",
        "sale": "매매"
      },
      "tx": {
        "all": "전체 거래",
        "monthly_no_deposit": "월세(무보증)",
        "monthly_with_deposit": "월세(보증)",
        "sale": "매매",
        "short_rent": "단기임대",
        "long_rent": "장기임대"
      },
      "txMap": {
        "monthly_no_deposit": "월세(무보증)",
        "monthly_with_deposit": "월세(보증)",
        "sale": "매매",
        "short_rent": "단기임대",
        "long_rent": "장기임대",
        "monthly": "월세",
        "jeonse": "전세"
      },
      "typeSale": "매매",
      "typeShort": "단기",
      "categoryMonthly": "월세",
      "categoryJeonse": "전세",
      "fallbackTx": "{type}/{category}",
      "suffixMonth": "/월",
      "suffixNight": "/박",
      "status": {
        "all": "전체 상태",
        "active": "active",
        "reserved": "예약중",
        "hidden": "hidden"
      },
      "region": {
        "all": "전체 지역",
        "danang": "다낭",
        "hoian": "호이안",
        "hcmc": "HCMC",
        "other": "기타"
      }
    }
  },
  /** 앱 전역·레이아웃용(탭/헤더와 맞춤 확장) */
  nav: {
    home: '홈',
    trade: '거래',
    community: '커뮤니티',
    localInfo: '생활정보',
    mypage: '내정보',
    chat: '채팅',
    search: '검색',
    notification: '알림',
    back: '뒤로가기',
    allServices: '전체서비스',
    appHome: 'Mingo 홈',
  },
  /** 공통 버튼/액션 라벨(화면별 `write.*` 등과 병행) */
  btn: {
    save: '저장',
    cancel: '취소',
    confirm: '확인',
    close: '닫기',
    delete: '삭제',
    edit: '수정',
    report: '신고',
    block: '차단',
    share: '공유',
    copy: '복사',
    more: '더보기',
    write: '글쓰기',
    submit: '등록하기',
    submitting: '등록 중...',
    login: '로그인',
    signup: '회원가입',
    logout: '로그아웃',
    chat: '채팅하기',
    like: '좋아요',
    comment: '댓글달기',
    translate: '번역하기',
    original: '원문보기',
    call: '전화하기',
    map: '지도보기',
    apply: '신청하기',
    complete: '완료',
    next: '다음',
    prev: '이전',
    retry: '다시시도',
  },
  expiry: {
    title: '기간 만료 관리',
    menuLabel: '기간 만료 알림',
    addItem: '+ 항목 추가',
    formTitle: '새 항목 등록',
    labelCategory: '항목 유형',
    labelTitle: '항목명',
    titlePlaceholder: '예: E-7 비자, 아파트 계약',
    labelExpiryDate: '만료일',
    labelAlertDays: '알림 단계 선택',
    labelMemo: '메모 (선택)',
    memoPlaceholder: '추가 메모를 입력하세요',
    expiryDate: '만료일',
    renewalGuide: '갱신 방법 보기',
    expired: '만료됨',
    today: 'D-Day',
    empty: '등록된 항목이 없습니다',
    categoryVisa: '비자',
    categoryResidence: '거주 등록',
    categoryLease: '임대 계약',
    categoryLicense: '국제면허증',
    categoryInsurance: '보험',
    categoryPassport: '여권',
    categoryBusiness: '사업자 등록',
    categoryHealth: '건강검진',
    categoryOther: '기타',
    labelReminderKind: '유형',
    kindExpiry: '만료일 기준',
    kindMonthly: '매월 같은 날',
    hintExpiry: '만료일까지 남은 일수(D-day)에 맞춰 알림을 받습니다.',
    hintMonthly: '매달 같은 날짜에 알림을 받습니다. (월말·짧은 달은 해당 월 마지막 날에 알림)',
    labelMonthlyDay: '매월 알림 받을 일',
    hintMonthlyDom: '1~31 중 선택. 31일로 두면 2월 등 짧은 달은 그 달 마지막 날에 알림됩니다.',
    monthlyShort: '매월 {day}일',
    monthlyLine: '매월 {day}일에 동일하게 알림',
    addCustomDday: '추가',
    customDdayPlaceholder: '예: 45',
    customDdayHint: '프리셋에 없는 날(D-120 등)은 숫자를 입력한 뒤 추가하세요. 탭하면 해제됩니다.',
    customDdayInvalid: '1~999 사이 숫자를 입력하세요.',
    needExpiryAndAlerts: '만료일과 알림 단계를 선택해 주세요.',
    needMonthlyDay: '매월 받을 날(1~31)을 입력해 주세요.',
  },
  lostFound: {
    title: '분실물 찾기',
    tabLost: '분실 신고',
    tabFound: '습득 신고',
    tabMissing: '실종자 찾기',
    reportLost: '분실 신고하기',
    reportFound: '습득 신고하기',
    formTitleLost: '분실물 신고',
    formTitleFound: '습득물 신고',
    labelUrgent: '긴급 여부',
    urgentYes: '긴급',
    urgentNo: '일반',
    labelMissingPhoto: '사진 (필수)',
    missingPhotoHint: '얼굴이 잘 보이는 최근 사진을 올려주세요',
    labelMissingName: '이름',
    missingNamePlaceholder: '실명 또는 별명',
    labelAge: '나이',
    agePlaceholder: '예: 35',
    ageUnit: '세',
    labelGender: '성별',
    genderSelect: '선택',
    genderMale: '남성',
    genderFemale: '여성',
    genderUnknown: '불명',
    labelLastSeen: '마지막 목격 장소',
    lastSeenPlaceholder: '예: 다낭 한시장 근처',
    labelLastSeenTime: '마지막 목격 시간',
    labelFeatures: '외모 특징',
    featuresPlaceholder: '키·체형·옷차림·언어 등',
    labelPhoto: '사진 (선택)',
    photoHint: '최대 3장',
    labelItemType: '물건 종류',
    labelTitle: '제목',
    titlePlaceholder: '예: 검정 지갑 분실',
    labelLocation: '분실/습득 장소',
    locationPlaceholder: '예: 다낭 미케해변 근처',
    labelDate: '날짜',
    labelContact: '연락처',
    contactPlaceholder: '전화번호 또는 카카오톡 ID',
    labelDesc: '상세 설명',
    descPlaceholder: '특징·색상·브랜드 등 자세히',
    empty: '게시글이 없습니다',
    urgentBadge: '긴급',
    statusActive: '찾는중',
    statusUrgent: '긴급',
    statusResolved: '찾음',
    typeWallet: '지갑',
    typePhone: '휴대폰',
    typeKey: '열쇠',
    typePassport: '여권',
    typeBag: '가방',
    typeOther: '기타',
  },
  /** SafePath·거래/커뮤니티 태그용 공통 카테고리 키 */
  category: {
    all: '전체',
    trade: '중고거래',
    rent: '렌트',
    jobs: '구인구직',
    question: '질문',
    info: '정보',
    meetup: '모임',
    lost: '분실',
    free: '자유',
    electronics: '전자기기',
    furniture: '가구',
    clothing: '의류',
    motorbike: '오토바이',
    car: '자동차',
    household: '생활용품',
    sports: '스포츠',
    food: '식품',
    other: '기타',
    groupBuy: '공동구매',
    realEstate: '부동산',
    restaurant: '맛집',
    academy: '학원',
    hotel: '숙소',
    hospital: '병원',
    visa_service: '비자/행정',
    property: '부동산',
    guide: '가이드',
    rental: '렌트',
    delivery: '배달',
    business: '업체',
  },
  error: {
    network: '네트워크 오류가 발생했습니다',
    saveFailed: '저장에 실패했습니다',
    loginRequired: '로그인이 필요합니다',
    noPermission: '권한이 없습니다',
    tryAgain: '잠시 후 다시 시도해주세요',
    notFound: '찾을 수 없습니다',
    serverError: '서버 오류가 발생했습니다',
    imageUploadFailed: '이미지 업로드에 실패했습니다',
  },
  notification: {
    noShowWarning: '노쇼 {count}회 누적되었습니다. 5회 시 이용이 정지됩니다',
  },
  toast: {
    saved: '저장됐습니다',
    deleted: '삭제됐습니다',
    copied: '복사됐습니다',
    reported: '신고됐습니다',
    blocked: '차단됐습니다',
    linkCopied: '링크가 복사됐습니다',
    pointEarned: '포인트가 적립됐습니다',
    liked: '좋아요를 눌렀습니다',
    unliked: '좋아요를 취소했습니다',
    commentAdded: '댓글이 등록됐습니다',
    applied: '신청됐습니다',
  },
  waitlist: {
    nowOpen: '지금 열린 지역',
    preparing: '서비스 준비 중',
    countLine: '현재 {n}명이 대기 중이에요',
    openAt: '{n}명이 모이면 오픈돼요',
    cta: '대기 신청하기',
    joined: '오픈되면 알림을 보내드릴게요!',
    joinedDup: '이미 대기자로 등록되어 있어요',
    loginToJoin: '대기 신청은 로그인이 필요해요',
    backEdit: '뒤로(지역 다시 선택)',
    startDanang: '다낭에서 먼저 쓰기',
    openBadge: '이용 가능',
    soonBadge: '오픈 대기',
    regionTitle: '오픈 지역 & 대기',
    benefitTitle: '초기 멤버 특별 혜택',
    benefitPremium: '오픈 시 프리미엄 1개월 무료',
    benefitBadge: '초기 멤버 배지',
    benefitAd: '광고 1개월 무료',
    noNetwork: '지역 정보를 불러오지 못했어요. 연결을 확인하거나 잠시 후 다시 시도하세요.',
    notifHint: '오픈되면 푸시(앱 알림)로 안내해 드려요',
    title: '준비중인 지역입니다',
    current: '현재 대기자',
    threshold: '명이 되면 오픈됩니다',
    apply: '대기 신청하기',
    applied: '대기 신청됐습니다',
    benefit: '초기 멤버 혜택',
    useDanang: '다낭에서 먼저 사용하기',
  },
  adminRegions: {
    title: '지역·대기자',
    hint: 'Staff 관리자 로그인 후 지역 오픈·대기자 알림을 실행할 수 있습니다.',
    secretMissing: '관리자 권한이 필요합니다. Staff 계정으로 다시 로그인해 주세요.',
    refresh: '다시 불러오기',
    colRegion: '지역',
    colState: '상태',
    colCount: '대기자',
    colThreshold: '오픈 조건(명)',
    openBtn: '수동 오픈 + 알림',
    notifyBtn: '대기자 전체 알림(오픈 아님)',
    loadFail: '불러오지 못했어요(권한·마이그레이션 점검).',
  },
  adminExchange: {
    blockTitle: 'P2P 환전 (관리)',
    listTitle: '최근 게시글',
    reportTitle: '신고됨 (report_count > 0)',
    reportedCount: '신고 건이 있는 글: {count}개',
    reportEmpty: '불러온 범위에 신고된 글이 없습니다.',
    partnersTitle: '제휴 파트너',
    revenueTitle: '제휴·수익(참고)',
    revenueBody: '수수료율은 파트너별로 DB에 저장됩니다. 클릭·전환은 이후 분석에서 추적할 수 있습니다.',
    empty: '없음',
    thTitle: '제목',
    thStatus: '상태',
    thPrem: '프리미엄',
    thViews: '조회',
    thReports: '신고',
  },
  productCard: {
    chatCountAria: '채팅 {n}건',
    metaLine: '{flag}{nickname} · {location} · {time}',
  },
  tabs: {
    home: '홈',
    trade: '거래',
    story: '스토리',
    services: '검색·서비스',
    events: '이벤트',
    life: '생활정보',
    community: '커뮤니티',
    chat: '채팅',
    profile: '내정보',
  },
  userFab: {
    create: '만들기',
    close: '닫기',
    sheetTitle: '무엇을 할까요?',
    propertyWrite: '매물 등록',
    myProperties: '내 매물',
    communityWrite: '글쓰기',
    myCommunityPosts: '내가 쓴 글',
    groupCreate: '모임 만들기',
    myGroups: '내 모임',
    searchGroups: '모임 검색',
    storyWrite: '스토리 올리기',
    businessRegister: '업체 등록',
    myBusinesses: '내 업체',
    productWrite: '중고 등록',
    myTrades: '내 물품·거래현황',
    search: '검색',
    hubRegister: '등록',
    hubMyRegister: '내 등록',
  },
  splash: {
    slogan: '어디서나, 동네처럼',
    welcomeSlogan: 'Your neighborhood, anywhere',
    start: '시작하기',
    haveAccount: '이미 계정이 있어요',
    browseGuest: '둘러보기',
  },
  errors: {
    offlineBanner: '오프라인 상태입니다',
    offline: '인터넷 연결을 확인해주세요.',
    generic: '요청에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    tryAgain: '잠시 후 다시 시도해주세요',
    retry: '다시 시도',
  },
  feature: {
    waitlistRegistered: '알림 신청이 완료되었습니다.',
    comingSoonToast: '준비 중인 서비스입니다.',
    preparing: '준비중',
    notifyMe: '알림 신청',
    adminDbError: 'DB 오류가 발생했습니다.',
    adminSaved: '저장되었습니다.',
    adminNotifyStub: '알림이 발송되었습니다.',
  },
  chatBlocked: {
    chatBlocked: '차단된 사용자입니다.',
  },
  detailPages: {
    loading: '불러오는 중…',
    error: '불러오지 못했습니다.',
    retry: '다시 시도',
    notFound: '이 페이지를 사용할 수 없습니다.',
    translate: '번역',
    original: '원문',
    translateFail: '번역에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    translatedBlock: '번역된 내용',
    report: '신고',
    userProfile: '프로필',
    manner: '매너온도',
    followers: '팔로워',
    following: '팔로잉',
    follow: '팔로우',
    followingBtn: '팔로잉 중',
    followSaved: '저장됐습니다.',
    message: '메시지',
    chat: '채팅',
    anonymous: '익명',
    block: '차단',
    blocked: '사용자를 차단했습니다.',
    profileEmpty: '아직 표시할 콘텐츠가 없어요.',
    profileTab: { sell: '판매', reviews: '리뷰', activity: '활동' },
    back: '뒤로',
    share: '공유',
    more: '더보기',
    review: '리뷰',
    writeReview: '리뷰 작성',
    noReviews: '리뷰가 없습니다.',
    bookNow: '예약하기',
    visitBooking: '방문예약',
    contactUs: '문의하기',
    callNow: '전화하기',
    chatNow: '채팅하기',
    directions: '길찾기',
    hours: '영업시간',
    location: '위치',
    description: '소개',
    menu: '메뉴',
    price: '가격',
    included: '포함사항',
    excluded: '불포함사항',
    reviews: '리뷰',
    similarAcademy: '비슷한 학원',
    joinToast: '참여했어요.',
  },
  revenueSvc: {
    title: '수익 서비스',
    description: '설명',
    price: '가격',
    book: '예약',
  },
  mentor: {
    title: '멘토링',
    specialty: '전문분야',
    experience: '경력',
    price: '가격/시간',
    book: '상담 신청',
    noMentors: '등록된 멘토가 없습니다.',
    heroTitle: '교민 전문가 멘토링',
    heroDesc: '창업·마케팅·부동산·언어\n베트남 현지 전문가에게 직접 배우세요',
    registerBtn: '멘토 등록',
    sortRating: '별점순',
    sortReviews: '리뷰순',
    sortPrice: '가격순',
    registerTitle: '멘토 등록',
    stepCategory: '전문 분야를 선택해주세요',
    stepCategoryDesc: '복수 선택 가능합니다',
    expertise: '세부 전문성',
    stepProfile: '멘토 프로필',
    name: '이름',
    namePlaceholder: '예: 김민준',
    mentorTitle: '멘토 타이틀',
    titlePlaceholder: '예: 베트남 창업 전문 멘토',
    bio: '자기소개',
    bioPlaceholder: '경력, 전문성, 멘토링 방식을 소개해주세요',
    experienceYears: '경력 연수',
    years: '년',
    pricePerHour: '시간당 가격',
    hour: '시간',
    sessionDuration: '기본 세션 시간',
    minutes: '분',
    stepConsultation: '상담 방식 및 언어',
    consultationType: '상담 방식',
    languages: '상담 가능 언어',
    maxMentees: '최대 멘티 수',
    people: '명',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    contactZalo: 'Zalo',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '승인 후 멘토링 목록에 노출됩니다',
    registerNotice3: '허위 정보 등록 시 계정이 제한됩니다',
    registerSuccess: '멘토 등록이 완료됐습니다. 검토 후 승인됩니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '멘토 등록하기',
  },
  photo: {
    heroTitle: '사진/영상 전문가',
    heroDesc: '웨딩·제품·프로필·영상편집\n다낭 현지 전문가',
    registerDesc: '사진/영상 작가이신가요?',
    registerBtn: '작가 등록하기',
    registerTitle: '사진/영상 서비스 등록',
    stepType: '어떤 촬영을 하시나요?',
    styles: '촬영 스타일',
    stepBasic: '서비스 정보',
    serviceName: '서비스명',
    serviceNamePlaceholder: '예: 다낭 웨딩 스냅 전문 작가',
    desc: '서비스 소개',
    descPlaceholder: '경력, 특기, 장비 등을 소개해주세요',
    priceRange: '가격 범위',
    duration: '촬영 시간',
    includes: '포함 사항',
    languages: '소통 가능 언어',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    contactZalo: 'Zalo',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '승인 후 사진/영상 목록에 노출됩니다',
    registerSuccess: '서비스가 등록됐습니다. 검토 후 승인됩니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
  },
  digital: {
    heroTitle: 'IT/디지털 전문가',
    heroDesc: '웹개발·앱·디자인·SNS 마케팅\n교민 업체 전문 IT 서비스',
    registerDesc: 'IT/디지털 서비스를 제공하시나요?',
    registerBtn: '서비스 등록하기',
    registerTitle: 'IT/디지털 서비스 등록',
    stepCategory: '어떤 서비스인가요?',
    stepService: '서비스 정보',
    serviceTitle: '서비스 제목',
    titlePlaceholder: '예: 반응형 웹사이트 제작',
    desc: '서비스 소개',
    descPlaceholder: '기술 스택, 경력, 포트폴리오를 소개해주세요',
    priceType: '가격 유형',
    price: '가격',
    deliveryDays: '납기일',
    includes: '포함 사항',
    languages: '소통 가능 언어',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '승인 후 IT/디지털 목록에 노출됩니다',
    registerSuccess: '서비스가 등록됐습니다. 검토 후 승인됩니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
  },
  coworking: {
    heroTitle: '코워킹 스페이스',
    heroDesc: '다낭·호이안 코워킹 스페이스\n한국어 지원 · 빠른 WiFi · 회의실',
    registerBtn: '공간 등록',
    sortRating: '별점순',
    sortPrice: '가격순',
    sortNewest: '최신순',
    registerTitle: '코워킹 스페이스 등록',
    stepType: '어떤 공간인가요?',
    amenities: '편의시설',
    stepBasic: '공간 기본 정보',
    spaceName: '공간명',
    spaceNamePlaceholder: '예: 다낭 코리아 코워킹',
    desc: '공간 소개',
    descPlaceholder: '공간 특징, 분위기, 주변 환경을 소개해주세요',
    address: '주소/위치',
    addressPlaceholder: '예: 다낭 미케비치 근처',
    capacity: '수용 인원',
    openingHours: '운영 시간',
    wifiSpeed: 'WiFi 속도',
    pricing: '이용 요금 (USD)',
    perHour: '시간',
    perDay: '일',
    perMonth: '월',
    languages: '지원 언어',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    contactZalo: 'Zalo',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '승인 후 코워킹 목록에 노출됩니다',
    registerSuccess: '코워킹 스페이스가 등록됐습니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
  },
  insurance: {
    heroTitle: '교민 보험 서비스',
    heroDesc: '건강·여행·생명·자동차보험\n한국어 상담 가능',
    registerDesc: '보험 상품을 등록하시겠어요?',
    registerBtn: '보험 상품 등록',
    registerTitle: '보험 상품 등록',
    stepType: '어떤 보험인가요?',
    coverage: '보장 항목',
    stepBasic: '상품 정보',
    provider: '보험사명',
    providerPlaceholder: '예: AIA 베트남',
    productName: '상품명',
    productNamePlaceholder: '예: 교민 건강보험 플랜',
    desc: '상품 소개',
    descPlaceholder: '보험 상품의 특징과 혜택을 소개해주세요',
    priceRange: '보험료 범위',
    duration: '보험 기간',
    languages: '상담 가능 언어',
    affiliateLink: '가입 링크 (선택)',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '허위 정보 등록 시 계정이 제한됩니다',
    registerNotice3: '보험 상품 판매는 관련 법규를 준수해야 합니다',
    registerSuccess: '보험 상품이 등록됐습니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
  },
  wedding: {
    title: '웨딩',
    package: '패키지',
    price: '가격',
    book: '상담 예약',
    noWedding: '등록된 업체가 없습니다.',
    heroTitle: '다낭 웨딩 서비스',
    heroDesc: '웨딩홀·스냅·드레스·메이크업\n교민 특화 웨딩 서비스',
    registerDesc: '웨딩 서비스를 운영하시나요?',
    registerBtn: '웨딩 서비스 등록',
    registerTitle: '웨딩 서비스 등록',
    stepType: '어떤 웨딩 서비스인가요?',
    stepBasic: '서비스 기본 정보',
    bizName: '업체명/서비스명',
    bizNamePlaceholder: '예: 다낭 오션뷰 웨딩홀',
    desc: '서비스 소개',
    descPlaceholder: '서비스 내용, 특징, 경력을 소개해주세요',
    priceRange: '가격 범위',
    priceFrom: '최소 가격',
    priceTo: '최대 가격',
    capacity: '최대 수용 인원',
    includes: '포함 사항',
    stepLocation: '위치 및 언어',
    address: '주소/위치',
    addressPlaceholder: '예: 다낭 미케비치 근처',
    languages: '상담 가능 언어',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    contactZalo: 'Zalo',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '승인 후 웨딩 서비스 목록에 노출됩니다',
    registerNotice3: '허위 정보 등록 시 계정이 제한됩니다',
    registerSuccess: '웨딩 서비스가 등록됐습니다. 검토 후 승인됩니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
  },
  news: {
    title: '뉴스/정보',
    readMore: '더 읽기',
    noNews: '뉴스가 없습니다.',
    latest: '최신',
    trending: '인기',
  },
  koreanShop: {
    title: '한국마트',
    products: '상품',
    order: '주문하기',
    noShops: '등록된 업체가 없습니다.',
  },
  vehicle: {
    title: '중고차',
    brand: '브랜드',
    year: '연식',
    mileage: '주행거리',
    price: '가격',
    contact: '문의하기',
    noVehicles: '등록된 차량이 없습니다.',
  },
  survey: {
    title: '설문조사',
    participate: '참여하기',
    reward: '보상',
    noSurveys: '진행중인 설문이 없습니다.',
    completed: '완료',
  },
  advertiser: {
    title: '광고 문의',
    inquiry: '광고 문의하기',
    type: '광고 유형',
    budget: '예산',
    submit: '문의 제출',
  },
  hospitalBook: {
    title: '병원 예약',
    selectDate: '날짜 선택',
    selectTime: '시간 선택',
    symptoms: '증상',
    confirm: '예약 확인',
    cancel: '예약 취소',
    noSlots: '예약 가능한 시간이 없습니다.',
  },
  hospital: {
    title: '병원/약국',
    tabAll: '전체',
    searchPlaceholder: '병원명, 진료과목 검색',
    favoritesOnly: '즐겨찾기',
    favorite: '찜하기',
    verified: '인증',
    demoBadge: '데모',
    demoFavorite: '데모 병원은 찜할 수 없어요.',
    notFound: '병원을 찾을 수 없어요.',
    reviewCount: '리뷰 {n}건',
    openNow: '영업중',
    closedNow: '마감',
    open24Badge: '24시간',
    registerCta: '병원 등록',
    noHospitals: '등록된 병원이 없어요',
    myBookings: '내 예약',
    bookingConfirmed: '예약이 확정되었습니다!',
    bookingCancelled: '예약이 취소되었습니다',
    needBookingFields: '진료과·날짜·시간을 확인해 주세요.',
    typeGeneral: '종합병원',
    typeClinic: '의원/클리닉',
    typePharmacy: '약국',
    typeDental: '치과',
    typeKoreanMed: '한방병원',
    typeEmergency: '응급센터',
    type_general: '종합병원',
    type_clinic: '의원/클리닉',
    type_pharmacy: '약국',
    type_dental: '치과',
    type_korean_medicine: '한방병원',
    type_emergency_center: '응급센터',
    type_other: '기타',
    specialtyInternal: '내과',
    specialtySurgery: '외과',
    specialtyOrthopedic: '정형외과',
    specialtyPlastic: '성형외과',
    specialtyDermatology: '피부과',
    specialtyDental: '치과',
    specialtyEye: '안과',
    specialtyENT: '이비인후과',
    specialtyOBGYN: '산부인과',
    specialtyPediatric: '소아과',
    specialtyNeuro: '신경과',
    specialtyPsych: '정신건강의학과',
    specialtyCardio: '심장내과',
    specialtyUrology: '비뇨기과',
    specialtyRehab: '재활의학과',
    specialtyFamily: '가정의학과',
    specialtyEmergency: '응급의학과',
    specialtyKoreanMed: '한의학',
    specialtyCheckup: '건강검진',
    specialtyVaccine: '예방접종',
    specialtyLasik: '라식/라섹',
    specialtyAesthetic: '미용시술',
    specialtyPhysical: '물리치료',
    specialty_internal: '내과',
    specialty_surgery: '외과',
    specialty_orthopedic: '정형외과',
    specialty_plastic: '성형외과',
    specialty_dermatology: '피부과',
    specialty_dental: '치과',
    specialty_eye: '안과',
    specialty_ent: '이비인후과',
    specialty_obgyn: '산부인과',
    specialty_pediatric: '소아과',
    specialty_neuro: '신경과',
    specialty_psych: '정신건강의학과',
    specialty_cardio: '심장내과',
    specialty_urology: '비뇨기과',
    specialty_rehab: '재활의학과',
    specialty_family: '가정의학과',
    specialty_emergency: '응급의학과',
    specialty_korean_med: '한의학',
    specialty_checkup: '건강검진',
    specialty_vaccine: '예방접종',
    specialty_lasik: '라식/라섹',
    specialty_aesthetic: '미용시술',
    specialty_physical: '물리치료',
    specialty_orthopedics: '정형외과',
    specialty_neurology: '신경과',
    specialty_cardiology: '심장내과',
    specialty_ophthalmology: '안과',
    specialty_obstetrics: '산부인과',
    specialty_pediatrics: '소아과',
    specialty_psychiatry: '정신건강의학과',
    specialty_general_dental: '일반진료',
    specialty_orthodontics: '교정',
    specialty_implant: '임플란트',
    specialty_whitening: '미백',
    specialty_oral_surgery: '구강외과',
    specialty_acupuncture: '침술',
    specialty_herbal: '한약',
    specialty_chiropractic: '추나요법',
    specialty_cupping: '부항',
    specialty_prescription: '처방전',
    specialty_otc: '일반의약품',
    specialty_health_supplement: '건강보조식품',
    specialty_misc: '기타',
    koreanFriendly: '한국어 가능',
    emergency: '응급실',
    open24h: '24시간',
    bookingAvailable: '예약가능',
    selectSpecialty: '진료과목 선택',
    selectDoctor: '의사 선택',
    anyDoctor: '상관없음',
    selectDateTime: '날짜/시간 선택',
    selectTime: '시간 선택',
    symptoms: '증상',
    symptomsPlaceholder: '어떤 증상으로 오시나요?',
    interpreterNeeded: '한국어 통역 필요',
    insuranceKorean: '한국 보험',
    insuranceInternational: '국제 보험',
    insuranceTravel: '여행자 보험',
    insuranceTitle: '적용 보험',
    insuranceNone: '표시된 보험 정보가 없어요',
    ratingStaff: '의료진 친절도',
    ratingFacility: '시설 청결도',
    ratingComm: '언어 소통',
    ratingValue: '가격 적정성',
    bookNow: '예약하기',
    callNow: '전화하기',
    specialtiesTitle: '진료과목',
    hoursTitle: '운영시간',
    weekday: '평일',
    weekendSat: '토요일',
    weekendSun: '일요일',
    todayNote: '※ 오늘 영업 여부는 방문 전 전화 확인을 권장해요.',
    doctorsTitle: '의료진',
    noDoctors: '등록된 의사 정보가 없어요.',
    locationTitle: '위치',
    openMap: '지도에서 보기',
    distanceKm: '약 {n} km',
    reviewsTitle: '리뷰',
    noReviews: '아직 리뷰가 없어요.',
    hospitalReply: '병원 답변',
    nextStep: '다음',
    prevStep: '이전',
    confirmBooking: '예약 확정',
    adminTitle: '병원 관리',
    adminTotal: '전체 병원',
    adminKorean: '한국어 가능',
    adminEmergency: '응급실 보유',
    adminReported: '신고됨',
    adminToday: '오늘 신규',
    adminBookings: '예약수',
    adminHost: '담당',
    adminApprove: '승인',
    adminHide: '숨김',
    adminDelete: '삭제',
    adminStatus: '상태',
    businessTab: '🏥 병원예약',
    bookingSymptomPreview: '증상',
    interpreterBadge: '통역',
    statusPending: '대기',
    statusConfirmed: '확정',
    statusCancelled: '취소',
    actionConfirm: '확정',
    actionCancel: '취소',
    registerTitle: '병원 등록',
    registerStep1: '업체 유형',
    registerStep2: '진료과목',
    registerStep3: '기본정보·위치',
    registerStep4: '연락처',
    registerStep5: '진료시간',
    registerStep6: '언어지원',
    registerStep7: '보험·요금',
    registerStep8: '시설사진',
    registerStep9: '의료진',
    registerStep10: '노출',
    registerSubmit: '등록하기',
    registerDone: '등록됐어요. 검토 후 노출돼요.',
    registerLabelNameKo: '병원명 (KO)',
    registerLabelNameLocal: '병원명 (현지)',
    registerLabelIntro: '소개',
    registerLabelCountry: '국가',
    registerLabelCity: '도시',
    registerLabelAddress: '주소',
    registerLabelPhoneRequired: '전화 (필수)',
    registerLabelEmergencyPhone: '응급전화',
    registerLabelWebsite: '웹사이트',
    registerLabelKakao: '카카오톡',
    registerLabel24h: '24시간',
    registerLabelEmergencyDept: '응급실',
    registerLabelWeekdayStart: '평일 시작',
    registerLabelWeekdayEnd: '평일 종료',
    registerLabelSatRange: '토 시작/종료',
    registerLabelSunRange: '일 시작/종료',
    registerInsKorean: '🇰🇷 한국 보험',
    registerInsIntl: '🌍 국제 보험',
    registerInsTravel: '✈️ 여행자 보험',
    registerPriceMin: '진료비 최소',
    registerPriceMax: '진료비 최대',
    registerLabelCurrency: '통화',
    registerAcceptsBooking: '예약 가능',
    registerPhotoExterior: '외관 (필수)',
    registerPhotoLobby: '내부/대기실 (필수)',
    registerPhotoRoom: '진료실',
    registerPhotoEquipment: '장비',
    registerDoctorName: '의사 이름',
    registerDoctorSpecialty: '전문과목',
    registerAddDoctor: '+ 의사 추가',
    register: {
      typeGeneral: '종합병원',
      typeClinic: '의원/클리닉',
      typeDental: '치과',
      typeOriental: '한의원',
      typePharmacy: '약국',
      typeOther: '기타',
      typeSurgery: '외과',
      stepBasicInfo: '기본정보',
      stepLocation: '위치',
      stepDepartments: '진료과목',
      stepHours: '진료시간',
      stepDoctors: '의료진',
      stepPhotos: '시설사진',
      stepBooking: '예약방법',
      stepLanguage: '언어지원',
      stepConfirm: '최종확인',
      specialty: {
        internal: '내과',
        surgery: '외과',
        orthopedics: '정형외과',
        neurology: '신경과',
        cardiology: '심장내과',
        dermatology: '피부과',
        ophthalmology: '안과',
        ent: '이비인후과',
        obstetrics: '산부인과',
        pediatrics: '소아과',
        urology: '비뇨기과',
        psychiatry: '정신건강의학과',
        general_dental: '일반진료',
        orthodontics: '교정',
        implant: '임플란트',
        whitening: '미백',
        oral_surgery: '구강외과',
        acupuncture: '침술',
        herbal: '한약',
        chiropractic: '추나요법',
        cupping: '부항',
        prescription: '처방전',
        otc: '일반의약품',
        health_supplement: '건강보조식품',
        misc: '기타',
      },
    },
  },
  visaService: {
    title: '비자/행정',
    typeVisa: '비자대행',
    typeTranslation: '서류번역',
    typeNotary: '공증',
    typeTax: '세무/회계',
    typeLegal: '법률상담',
    typeInsurance: '보험',
    typeImmigration: '이민상담',
    typeOther: '기타행정',
    visaTourist: '관광비자',
    visaWork: '취업비자',
    visaStudent: '학생비자',
    visaInvestment: '투자비자',
    visaRetirement: '은퇴비자',
    visaMarriage: '결혼비자',
    visaFamily: '가족비자',
    visaExtension: '비자연장',
    visaOther: '기타',
    processingTime: '처리기간',
    processingNormal: '일반처리',
    processingExpress: '급행처리',
    processingDays: '{min}~{max}일',
    processingPriceTitle: '처리·가격',
    requiredDocs: '필요서류',
    onlineAvailable: '온라인 가능',
    koreanFriendly: '한국어 가능',
    reviewCount: '리뷰 {n}건',
    verified: '인증',
    docPassportCopy: '여권 사본',
    docIdPhoto: '증명사진',
    inquiryType: '문의종류',
    nationality: '국적',
    contactMethod: '연락방법',
    contactApp: '앱 채팅',
    contactKakao: '카카오톡',
    contactPhone: '전화',
    ratingSpeed: '처리속도',
    ratingPrice: '가격적정성',
    ratingComm: '소통편의',
    registerCta: '업체 등록',
    noServices: '등록된 업체가 없어요',
    inquiry: '문의하기',
    bookNow: '상담신청',
    searchPlaceholder: '업체명, 비자종류 검색',
    infoGuideDesc: '비자 정보가 필요하세요?',
    infoGuideLink: '비자 가이드 보기',
    demoFavorite: '데모 업체는 찜할 수 없어요.',
    fastProcessing: '빠른처리',
    priceRange: '가격',
    notFound: '업체를 찾을 수 없어요.',
    inquirySent: '문의가 접수되었어요.',
    inquiryNeedMessage: '문의 내용을 3자 이상 입력해 주세요.',
    visaKindsTitle: '비자 종류',
    adminServicesTitle: '행정 서비스',
    admin_translation: '서류번역',
    admin_notary: '공증',
    admin_tax_filing: '세무신고',
    admin_accounting: '회계',
    admin_legal: '법률상담',
    admin_insurance: '보험',
    admin_immigration: '이민상담',
    admin_property_reg: '부동산등기',
    daysUnit: '일',
    onlineConsultOk: '온라인 상담 가능',
    onlineConsultNo: '방문 상담 위주',
    registerTitle: '비자/행정 업체 등록',
    registerStep1: '서비스 유형',
    registerStep2: '취급 비자',
    registerStep2Translation: '번역 설정',
    registerStep2Tax: '세무 서비스',
    registerStep2Legal: '법률 분야',
    registerStep2OtherAdmin: '서비스 내용',
    registerStep2Extra: '서비스 안내',
    branchTranslationPair: '번역 언어쌍',
    branchFromLang: '원문 언어',
    branchToLang: '번역 언어',
    branchTranslationFields: '번역 분야',
    transField_general: '일반·생활 서류',
    transField_legal: '법률·계약',
    transField_medical: '의료',
    transField_business: '사업·재무',
    transField_academic: '학력·성적',
    branchTaxKinds: '세무 서비스 종류',
    taxKind_tax_filing: '세무신고',
    taxKind_accounting: '회계·장부',
    taxKind_payroll: '급여·4대보험',
    taxKind_vat: '부가세·세금계산서',
    taxKind_bookkeeping: '기장·정리',
    branchLegalKinds: '법률 분야',
    legalKind_labor: '노동·고용',
    legalKind_contract: '계약·거래',
    legalKind_immigration: '출입국·비자',
    legalKind_family: '가족·이혼',
    legalKind_corporate: '법인·M&A',
    branchOtherNote: '제공 서비스 내용',
    branchOtherPlaceholder: '어떤 행정·대행 업무를 제공하는지 구체적으로 적어 주세요.',
    branchServiceNote: '서비스 소개',
    branchServiceNotePh: '취급 범위·강점을 간단히 적어 주세요.',
    registerStep3: '기본정보',
    registerStep4: '처리기간·요금안내',
    registerStep5: '필요서류',
    registerStep6: '연락처',
    registerStep7: '지원언어',
    registerStep8: '포트폴리오 사진',
    registerStep9: '노출 설정',
    register: {
      typeTranslation: '서류번역',
      typeTax: '세무',
      typeLegal: '법률',
      stepServiceDetail: '서비스 상세',
      stepCertification: '자격증',
      stepPricing: '요금안내',
      pricingFixed: '고정요금',
      pricingQuote: '견적상담',
      requiredPassport: '여권 사본',
      requiredPhoto: '증명사진',
    },
    registerSubmit: '등록하기',
    registerDone: '등록됐어요. 검토 후 노출돼요.',
    fieldName: '업체명',
    fieldIntro: '소개',
    fieldCountry: '국가',
    fieldCity: '도시',
    fieldAddress: '주소',
    fieldPhone: '전화번호',
    fieldKakao: '카카오톡 ID',
    fieldWebsite: '웹사이트',
    procMinMax: '일반처리 기간 (최소~최대 일)',
    priceMinMax: '일반처리 가격 (최소~최대)',
    currency: '통화',
    expressToggle: '급행처리 가능',
    expressDays: '급행처리 기간 (일)',
    expressPrice: '급행처리 가격',
    addDoc: '+ 서류 추가',
    photoExterior: '사무실 외관',
    photoInterior: '내부',
    photoCert: '인증서/허가증',
    inquiryOpt_tourist: '관광비자',
    inquiryOpt_work: '취업비자',
    inquiryOpt_student: '학생비자',
    inquiryOpt_investment: '투자비자',
    inquiryOpt_extension: '비자연장',
    inquiryOpt_translation: '서류번역',
    inquiryOpt_notary: '공증',
    inquiryOpt_tax: '세무/회계',
    inquiryOpt_legal: '법률',
    inquiryOpt_insurance: '보험',
    inquiryOpt_immigration: '이민',
    inquiryOpt_other: '기타',
    bannerTitle: '🛂 비자/행정 전문가',
    bannerSubtitle: '한국어 가능한 현지 전문가를\n찾아드립니다',
    statExperts: '전문가 {n}명',
    statAvgRating: '평균 {n}',
    statVerified: '인증업체',
    quickCat_visa: '비자대행',
    quickCat_translation: '서류번역',
    quickCat_notary: '공증',
    quickCat_tax: '세무회계',
    quickCat_legal: '법률상담',
    quickCat_insurance: '보험',
    quickCat_immigration: '이민상담',
    quickCat_other: '기타행정',
    filterAll: '전체',
    filterTabKorean: '🇰🇷 한국어',
    filterTabOnline: '💻 온라인',
    filterTabVerified: '✅ 인증',
    filterTabFast: '⚡ 빠른처리',
    cardInquiry: '💬 문의하기',
    processTitle: '처리 프로세스',
    timelineStep1: '서류 접수',
    timelineStep2: '서류 검토',
    timelineStep3: '비자 신청',
    timelineStep4: '결과 통보',
    servicesTitle: '서비스 안내',
    pkgApply: '신청하기',
    expressSectionTitle: '급행처리',
    expressAvailableBadge: '⚡ 급행처리 가능',
    expressNormalLine: '일반: {days} · {range}',
    expressExpressLine: '급행: {days} · {range}',
    successStoriesTitle: '성공사례 · 후기',
    reviewVisaLine: '{visa} · 처리 {days}일',
    expertTitle: '전문가 정보',
    expertSuccess: '처리 성공률',
    expertResponse: '평균 응답',
    expertCerts: '경력 · 자격',
    docPassport: '여권 사본',
    docPhotos: '증명사진 2매',
    docFinance: '재정증명서',
    docHotel: '숙소예약증',
    docPassportOrig: '여권 원본',
    docApplication: '신청서',
    docContract: '관련 계약서',
    docBizReg: '사업자등록',
    docSales: '매출 자료',
    docBank: '은행 거래내역',
    expertResponse15: '평균 응답 ~15분',
    expertResponse30: '평균 응답 ~30분',
    expertResponseSameDay: '당일 내 답변',
  },
  errorBoundary: {
    title: '일시적인 오류가 발생했습니다',
    offline: '인터넷 연결을 확인해주세요.',
    generic: '앱을 새로고침하거나 잠시 후 다시 시도해 주세요.',
    reload: '새로고침',
  },
  auth: {
    tagline: '교민·여행자를 위한 동네 플랫폼',
    tabLogin: '로그인',
    tabSignup: '회원가입',
    email: '이메일',
    password: '비밀번호',
    passwordConfirm: '비밀번호 확인',
    nickname: '닉네임',
    signup: '회원가입',
    emailPlaceholder: '이메일을 입력하세요',
    passwordPlaceholder: '비밀번호를 입력하세요',
    alreadyHaveAccount: '이미 계정이 있으신가요?',
    dontHaveAccount: '계정이 없으신가요?',
    login: '로그인',
    signupSubmit: '가입하기',
    browse: '둘러보기',
    kakaoContinue: '카카오로 시작하기',
    googleContinue: 'Google로 계속하기',
    appleContinue: 'Apple로 계속하기',
    oauthDivider: '다른 계정으로 로그인',
    oauthGroupAria: '소셜 로그인',
    placeholderEmail: '이메일을 입력하세요',
    placeholderPassword: '비밀번호',
    placeholderPasswordConfirm: '비밀번호를 다시 입력하세요',
    placeholderNickname: '닉네임을 입력하세요',
    passwordMismatch: '비밀번호가 일치하지 않습니다.',
    checkEmail: '이메일로 보낸 인증 링크를 확인한 뒤 로그인해 주세요.',
    referralOptional: '추천인 코드 (선택)',
    referralPlaceholder: '예: MG-A3K9',
    forgotPassword: '비밀번호를 잊으셨나요?',
    forgot: {
      title: '비밀번호 찾기',
      tabEmail: '이메일로 찾기',
      tabPhone: '전화번호로 찾기',
      sendResetLink: '재설정 링크 보내기',
      checkEmail: '이메일을 확인해주세요',
      getOtp: '인증번호 받기',
      otpLabel: '인증번호',
      otpPlaceholder: '6자리 인증번호',
      verify: '확인',
      phone: '전화번호',
      countryCode: '국가코드',
      backLogin: '로그인으로 돌아가기',
      otpSent: '인증번호를 발송했습니다',
      phoneInvalid: '전화번호를 확인해 주세요',
      otpInvalid: '인증번호 6자리를 입력해 주세요',
      dialKR: '한국',
      dialVN: '베트남',
      dialJP: '일본',
      dialUSCA: '미국/캐나다',
      dialGB: '영국',
      dialAU: '호주',
      dialSG: '싱가포르',
      dialMY: '말레이시아',
      dialTH: '태국',
      dialPH: '필리핀',
      dialID: '인도네시아',
      dialCN: '중국',
      dialRU: '러시아',
      dialDE: '독일',
      dialFR: '프랑스',
    },
    reset: {
      title: '새 비밀번호 설정',
      newPassword: '새 비밀번호',
      confirmPassword: '비밀번호 확인',
      submit: '비밀번호 변경',
      success: '비밀번호가 변경됐습니다 ✅',
      needSession: '세션이 만료됐습니다. 비밀번호 찾기를 다시 시도해 주세요.',
      mismatch: '비밀번호가 일치하지 않습니다',
    },
    loginSuccess: '로그인됐습니다',
    logoutSuccess: '로그아웃됐습니다',
    signupSuccess: '회원가입이 완료됐습니다',
    errors: {
      generic: '요청을 처리할 수 없습니다. 잠시 후 다시 시도해 주세요.',
      invalidCredentials: '이메일 또는 비밀번호가 올바르지 않습니다.',
      emailTaken: '이미 사용중인 이메일입니다.',
      emailNotConfirmed: '이메일 인증이 완료되지 않았습니다. 메일함을 확인해 주세요.',
      weakPassword: '비밀번호가 너무 짧거나 규칙에 맞지 않습니다.',
      network: '네트워크 오류입니다. 연결을 확인해 주세요.',
      providerDisabled: '이 로그인 방식은 아직 준비 중입니다. 이메일 로그인을 이용해 주세요.',
    },
    needLegalConsents: '이용약관·개인정보 처리방침에 각각 동의하고, 생년월일을 입력해 주세요.',
    legalConsentTitle: '서비스 이용을 위해 동의가 필요해요',
    legalConsentSubmit: '동의하고 시작하기',
    legalReconsentTitle: '약관이 업데이트되었어요. 다시 동의해 주세요',
    legalReconsentSubmit: '동의하고 계속하기',
    agreeTerms: '이용약관에 동의합니다(필수)',
    agreePrivacy: '개인정보 수집·이용에 동의합니다(필수)',
    agreeMarketing: '마케팅 정보 수신에 동의합니다(선택)',
    agreeLocation: '위치 관련 기능에 동의합니다(선택, 해당 시)',
    agreeAge14: '만 14세 이상입니다(필수)',
    birthDateLabel: '생년월일(필수)',
    needBirthDate: '생년월일을 입력해 주세요.',
    underAgeBlocked: '만 14세 미만은 가입할 수 없습니다.',
    viewTerms: '보기',
    viewPrivacy: '보기',
  },
  onboarding: {
    languageTitle: '어떤 언어를 사용하세요?',
    languageSubtitle: '앱에서 사용할 언어를 선택하세요',
    languageListAria: '언어 목록',
    next: '다음',
    selectLanguage: '언어를 선택해주세요',
    selectRegion: '지역을 선택해주세요',
    start: '시작하기',
    browse: '둘러보기',
    later: '나중에',
    welcome: '환영합니다',
    slogan: 'Your neighborhood, anywhere',
    haveAccount: '이미 계정이 있어요',
    locationConfirmTitle: '내 동네 확인',
    locationLoading: '위치를 확인하는 중입니다...',
    locationError: '위치를 가져올 수 없어요.',
    locationQuestion: '📍 {place}에 사시나요?',
    yesStart: '네, 시작하기',
    pickManually: '직접 선택할게요',
    locationSelectTitle: '도시를 선택하세요',
    countryLabel: '나라',
    cityHint: '도시는 최대 2개까지 선택',
    maxHint: '최대 2개까지 선택할 수 있어요.',
    maxToast: '최대 2개까지 선택 가능합니다',
    locationManualToast: '위치를 찾을 수 없어 직접 선택해주세요',
    done: '완료',
    nationalityTitle: '국적을 선택해주세요',
    nationalityDesc: '대사관·영사관 등 맞춤 정보를 제공해드립니다',
    interestTitle: '관심 있는 분야를 선택해주세요',
    interestSubtitle: '맞춤 정보를 제공해드려요',
    nationalityKR: '한국',
    nationalityRU: '러시아',
    nationalityEN: '영어권',
    nationalityJP: '일본',
    nationalityCN: '중국',
    nationalityVN: '베트남',
    nationalityOther: '기타',
    selectType: '어떤 분이세요?',
    typeExpat: '교민',
    typeExpatDesc: '해외에 거주하는\n한국인',
    typeTourist: '여행자',
    typeTouristDesc: '여행 중이거나\n여행 계획 중',
    typeNomad: '디지털 노마드',
    typeNomadDesc: '여러 나라를\n이동하며 일해요',
    typeBusiness: '비즈니스',
    typeBusinessDesc: '업체 운영 또는\n비즈니스 목적',
    selectInterests: '관심사를 선택해주세요',
    selectInterestsDesc: '맞춤 정보를 보여드려요 (복수 선택)',
  },
  guest: {
    loginRequiredTitle: '로그인이 필요합니다',
    loginRequiredMessage: '이 기능은 로그인 후 이용할 수 있어요.',
    login: '로그인',
    cancel: '취소',
  },
  location: {
    selectRegion: '지역을 선택해주세요',
    addRegion: '지역 추가',
    primaryRegion: '주요 지역',
    secondaryRegion: '관심 지역',
    gpsAutoDetected: '자동 감지된 위치',
    activeBasis: '기준: {region}',
    switchedTo: '{region} 기준으로 전환',
    editRegion: '변경',
    saveButton: '저장하기',
    saved: '저장됐습니다',
    currentViewing: '현재 보고 있는 지역',
    none: '선택된 지역 없음',
    pickOne: '최소 1개 이상의 지역을 선택해주세요',
    emptySelection: '지역을 선택해주세요',
    gpsUnmapped: '현재 위치를 확인할 수 없어요. 지역을 선택해주세요',
    gpsManualPickHint: 'GPS로 위치를 확인할 수 없습니다. 도시를 직접 선택해 주세요.',
    summary: '메인: {main} | 보조: {sub}',
    summaryMainOnly: '메인: {main}',
    badgeMain: '메인',
    badgeSub: '보조',
    pickCountryTitle: '국가를 선택하세요',
    pickCityTitle: '도시를 선택하세요',
    backToCountries: '국가 목록',
    searchPlaceholder: '도시 검색…',
    availableBadge: '이용가능',
    preparingBadge: '준비중',
    waitlistCount: '대기 {n}명',
    popular: '인기',
    allCities: '전체 도시',
    legendOpen: '오픈된 지역은 바로 이용할 수 있어요.',
    suggestedLocaleNote: '안내: 이 지역에서는 {lang} 표시가 유용할 수 있어요 (설정에서 언제든 변경).',
    radiusTitle: '위치 및 반경 설정',
    radiusMenuLabel: '위치 반경 설정',
    radiusDesc: '각 관심 지역마다 얼마나 넓은 범위의 정보를 볼지 설정할 수 있어요',
    selectRadius: '검색 반경 선택',
    addLocation: '관심 지역 추가',
    selectCountry: '국가 선택',
    selectCity: '도시 선택',
    selectCityPlaceholder: '도시를 선택해주세요',
    labelOptional: '별칭 (선택)',
    labelPlaceholder: '예: 우리 동네, 직장 근처',
    addBtn: '추가하기',
    settingSaved: '위치 설정이 저장됐습니다',
    settingFailed: '저장에 실패했습니다',
    settingFailedDetail: '저장 실패: {detail}',
    radiusUpdated: '반경이 업데이트됐습니다',
    primarySpotLabel: '주요 위치',
    gpsAuto: '현재 위치 (자동)',
    gpsDetecting: '위치 감지 중...',
    gpsAutoDesc: 'GPS 기반 자동 감지 · 변경 불필요',
    interestLocation: '관심 지역 (수동 선택)',
    viewByCurrentGps: '📍 현재 위치로 보기',
    currentSelection: '현재 선택: {summary}',
    gpsCityTitle: '현재 GPS 도시',
    gpsBadge: 'GPS',
    removeInterest: '{region} 제거',
    backToSearch: '← 검색으로 돌아가기',
    searchAgain: '← 다시 검색하기',
  },
  travelHub: {
    title: '여행',
    subtitle: '{city} 여행, 어떻게 준비하세요?',
    packageTitle: '패키지 여행',
    packageDesc: '항공+숙소+투어를 묶어서, 정해진 일정대로',
    freeTitle: '자유여행',
    freeDesc: '숙소·투어·액티비티를 원하는 대로 골라 담기',
    quoteTitle: '맞춤 견적문의',
    quoteDesc: '인원·예산·일정 알려주면 전문가가 견적 제안',
    quoteHint: '어떤 걸 고를지 모르겠다면 맞춤 견적문의로 먼저 상담받아보세요.',
    quoteFormTitle: '맞춤 견적문의',
    fieldCity: '여행지',
    fieldHeadcount: '인원',
    headcountPh: '인원 수',
    fieldBudget: '예산대',
    fieldDates: '희망 일정',
    fieldDatesPh: '예: 9월 초, 미정 등',
    fieldContact: '연락처(선택)',
    fieldContactPh: '답변받을 연락처',
    fieldNote: '추가 요청사항',
    fieldNotePh: '아이 동반, 어르신 동반, 선호 숙소 등 자유롭게 적어주세요',
    budgetUnder50: '~50만원',
    budget50to100: '50~100만원',
    budget100to200: '100~200만원',
    budgetOver200: '200만원+',
    submitBtn: '견적 요청하기',
    submitting: '보내는 중...',
    submitSuccess: '견적 요청을 보냈어요. 확인 후 연락드릴게요.',
    submitError: '요청을 보내지 못했어요. 다시 시도해 주세요.',
    loginRequired: '로그인 후 이용할 수 있어요.',
    destStepTitle: '어디로 떠나세요?',
    destStepSubtitle: '나라를 먼저 고르고, 도시를 선택해주세요. 아직 안 정했다면 건너뛰어도 돼요.',
    destCountryLabel: '나라 선택',
    destCityLabel: '{country} — 도시 선택',
    destNoCities: '아직 등록된 도시가 없어요.',
    destSkip: '나중에 정할게요',
    subtitleWithDest: '{dest} 여행, 무엇을 도와드릴까요?',
    browseTitle: '단품투어·액티비티 둘러보기',
    browseDesc: '데이투어, 액티비티, 골프, 렌터카 등 상품 바로 보기',
    consultTitle: '자유여행·패키지 맞춤 상담',
    consultDesc: '원하는 여행을 알려주시면 전문가가 견적을 제안해드려요',
    hubFab: '맞춤 상담',
    adultsLabel: '성인',
    childrenLabel: '아동',
    infantsLabel: '유아',
    fieldPurpose: '여행 목적',
    purposeFamily: '가족여행',
    purposeHoneymoon: '신혼여행',
    purposeParents: '효도여행',
    purposeFriends: '친구모임',
    purposeGolf: '골프여행',
    fieldHotelGrade: '희망 숙소 등급',
    hotelGuesthouse: '게스트하우스',
    hotel3: '3성급',
    hotel4: '4성급',
    hotel5: '5성급',
    hotelResortVilla: '리조트/풀빌라',
    fieldRoomType: '객실 타입',
    roomSingle: '싱글',
    roomDouble: '더블',
    roomTwin: '트윈',
    roomFamily: '패밀리룸',
    singleSupplementNote: '싱글룸은 1인 추가요금(싱글차지)이 붙을 수 있어요.',
    fieldMealPlan: '식사 포함',
    mealNone: '불포함',
    mealBreakfast: '조식만',
    mealBreakfastDinner: '조식+석식',
    fieldFlightIncluded: '항공권',
    flightYes: '항공권 포함',
    flightTourOnly: '숙박·투어만',
    flightUnsure: '잘 모르겠어요',
    fieldActivities: '하고 싶은 활동',
    actActivity: '액티비티',
    actMassage: '마사지/스파',
    actGolf: '골프',
    actFood: '맛집투어',
    actShopping: '쇼핑',
    actSnap: '스냅촬영',
  },
  interest: {
    food: '맛집/음식',
    golf: '골프',
    realestate: '부동산',
    medical: '의료/건강',
    education: '교육/학교',
    shopping: '쇼핑',
    sports: '스포츠/레저',
    culture: '문화/공연',
    finance: '금융/투자',
    parenting: '육아/자녀',
    beauty: '미용/뷰티',
    travel: '여행/항공',
  },
  /** 소문자 네임스페이스 — 공통 메뉴/설정 라벨 */
  mypage: {
    myInfo: '내 정보',
    myTrades: '내 거래',
    favorites: '찜 목록',
    points: '포인트',
    notifications: '알림설정',
    settings: '앱설정',
    privacy: '개인정보처리방침',
    terms: '서비스이용약관',
    logout: '로그아웃',
    withdrawal: '회원탈퇴',
    referralCode: '내 추천코드',
    editProfile: '프로필 수정',
    mannerTemp: '매너온도',
    reviews: '받은 후기',
  },
  profile: {
    nickname: '닉네임',
    bio: '자기소개',
    contact: '연락처',
    kakao: '카카오톡 ID',
    telegram: '텔레그램 ID',
    whatsapp: '왓츠앱',
    phone: '전화번호',
    nationality: '국적',
    residence: '거주지',
    language: '언어',
    editPhoto: '사진 변경',
    save: '저장하기',
    follow: '팔로우',
    following: '팔로잉',
    receiveNotifications: '알림받기',
    addChannel: '채널 추가',
    externalNotifications: '외부 알림 받기',
    externalNotificationsHint: '켜두면 앱 알림 외에도 새 소식을 놓치지 않도록 알려드려요',
  },
  visa: {
    expiry: '비자 만료일',
    dday: '만료까지',
    type: '비자 종류',
    reminder: '만료 알림',
    expired: '만료됨',
    safe: '안전',
    warning: '주의',
    danger: '위험',
  },
  emergency: {
    police: '경찰',
    fire: '소방',
    ambulance: '구급',
    embassy: '대사관',
    community: '한인커뮤니티',
    common: '공통',
    call: '전화하기',
    disclaimer: '연락처가 변경될 수 있습니다',
    empty: '해당 연락처가 없습니다',
    category: {
      all: '전체',
      emergency: '긴급번호',
      embassy: '대사관',
      hospital: '병원',
      community: '커뮤니티',
    },
  },
  pwa: {
    bannerAria: '앱 설치 안내',
    bannerTitle: '홈 화면에 추가해 보세요',
    iosHint: '공유 버튼 → 홈 화면에 추가',
    androidHint: '아래 설치를 누르거나 브라우저 메뉴에서 앱 설치를 선택하세요.',
    install: '설치',
    close: '닫기',
  },
  header: {
    pickRegion: '지역 선택',
    myNeighborhood: '내 동네',
    regionPickerAria: '지역 선택',
    regionHint: '최대 2개까지 선택할 수 있어요.',
    regionLimit: '이미 2개를 선택했어요. 해제 후 다시 선택해 주세요.',
    closePanel: '지역 선택 닫기',
    search: '검색',
    notifications: '알림',
    services: '전체 서비스',
    visaDday: '비자 D-{n}',
    visaExpired: '비자 만료',
  },
  search: {
    placeholder: '상품·게시글·구인구직 검색',
    placeholderAll: '전체 검색',
    placeholderHub: '{hub}에서 검색',
    categoryAll: '카테고리 전체',
    hint: '거래·동네생활·구인구직 DB에서 제목·본문·설명을 검색해요.',
    empty: '검색 결과가 없어요.',
    products: '거래',
    catalogItems: '예약상품',
    posts: '커뮤니티',
    jobs: '구인/구직',
    tabAll: '전체',
    tabBiz: '업체',
    tabCatalogItems: '예약상품',
    tabProducts: '거래',
    tabStories: '쇼츠',
    tabPosts: '커뮤니티',
    tabJobs: '구인/구직',
    adBadge: '광고',
    jobHireBadge: '구인',
    jobSeekBadge: '구직',
    jobsMoreInTab: '자세한 내용은 구인구직 탭에서 이어서 확인하세요.',
    recentTitle: '최근 검색',
    popularTitle: '인기 검색',
    popularTerm1: '다낭 원룸',
    popularTerm2: '비자 연장',
    popularTerm3: '오토바이 렌트',
    popularTerm4: '한식 재료',
    popularTerm5: '구인 알바',
  },
  feed: {
    interested: '관심 있음',
    notInterested: '관심 없음',
    hidePost: '이 글 숨기기',
    whySeeing: '이 글이 왜 보이나요?',
    report: '신고하기',
  },
  shorts: {
    discover: '이웃',
    storyHome: '밍글',
    neighbor: '이웃',
    mingle: '밍글',
    adBadge: '광고',
    adCta: '더 알아보기',
    adHint: '스폰서 콘텐츠입니다',
    storyTabNearby: '📍 내 주변',
    storyTabWebtoon: '🎨 웹툰',
    storyTabPopular: '⭐ 인기',
    filterAll: '전체',
    filterVideo: '영상',
    filterWebtoon: '웹툰',
    filterBlog: '블로그',
    filterBusiness: '업체',
    filterNews: '뉴스',
    filterLife: '라이프',
    filterSettle: '정착',
    tabEmptyNews: '표시할 뉴스가 없어요',
    tabEmptySettle: '표시할 정착 가이드가 없어요',
    tabEmptyLife: '아직 라이프 콘텐츠가 없어요',
    tabEmptyMingle: '아직 밍글 스토리가 없어요',
    pullHint: '↓ 새로고침',
    pullRelease: '놓으면 새로고침',
    webtoonEmpty: '아직 웹툰이 없어요',
    webtoonStartSeries: '웹툰 연재 시작',
    webtoonEpisodeSuffix: '화',
    webtoonPremiumBadge: '💎 유료',
  },
  translation: {
    insufficientPoints: '포인트가 부족합니다. 충전 후 이용해주세요',
    pointsBalance: '현재 포인트',
    costPerUse: '번역 1회 비용',
    premiumFree: '프리미엄 회원 월 20회 무료',
    dashboardTitle: '번역 관리',
    menuLabel: '콘텐츠 번역 관리',
    dashboardDesc: '내 쇼츠/스토리를 다국어로 번역하면 더 많은 교민들이 볼 수 있어요. AI가 자동으로 번역해드려요.',
    noStories: '등록된 스토리가 없습니다',
    autoBtn: '✨ AI 자동 번역',
    translating: 'AI가 번역 중...',
    autoComplete: 'AI 번역이 완료됐어요. 내용을 확인하고 저장해주세요',
    autoFailed: '자동 번역에 실패했어요. 직접 입력해주세요',
    saved: '번역이 저장됐습니다',
    saveFailed: '저장에 실패했습니다',
    saveBtn: '번역 저장',
    loadingStories: '로딩 중…',
    statusDone: '✅ 번역 완료',
    statusNeed: '⚠️ 번역 필요',
    sourceTag: '원문',
    fieldTitle: '제목',
    fieldCaption: '캡션',
    chargePack500Tag: '🌐 번역 10회',
    dashboardHint: '내가 올린 스토리 제목·캡션을 EN/VI/RU로 번역해 저장합니다.',
    pickStory: '스토리 선택',
    selectPlaceholder: '선택…',
    previewTitle: '제목',
    previewCaption: '캡션',
    runAuto: 'AI 자동 번역',
    saveOk: '번역을 저장했어요.',
  },
  points: {
    toastAwarded: '🎉 +{amount}P 적립됐습니다!',
    insufficientToast: '포인트가 부족합니다',
    homeLowBanner: '포인트가 부족해요',
    homeLowCta: '충전 안내',
    chargeTitle: '포인트 충전',
    currentBalance: '현재 잔액',
    selectPackage: '충전 패키지 선택',
    popular: '인기',
    bonus: '보너스',
    total: '합계',
    chargeNotice: '충전 안내',
    noticeItem1: '충전 요청 후 관리자 확인 후 지급됩니다',
    noticeItem2: '포인트는 광고비, 프리미엄 기능에 사용됩니다',
    noticeItem3: '충전된 포인트는 환불되지 않습니다',
    chargeRequested: '충전 요청이 완료됐습니다. 확인 후 지급됩니다',
    chargeFailed: '충전 요청에 실패했습니다',
    chargeBtn: '결제 요청',
    selectFirst: '패키지를 선택해주세요',
    charge: '충전',
    insufficient: '포인트가 부족합니다. 충전 후 이용해주세요',
  },
  share: {
    open: '공유하기',
    system: '다른 앱으로 공유',
    kakao: '카카오톡',
    copy: '링크 복사',
    copied: '링크가 복사됐습니다',
    copyFailed: '복사에 실패했어요.',
    kakaoHint: '카카오톡이 없으면 링크를 복사했어요.',
    promoFooter: '🏝️ Mingo 앱에서 다낭 생활정보 더 보기',
  },
  rateLimit: {
    toast: '잠시 후 다시 시도해주세요',
  },
  privacyPage: {
    title: '개인정보 처리방침',
    collected: '수집하는 정보',
    collectedBody:
      '계정(이메일, 닉네임, 설정), 선택·허용 시 지역/위치, 게시물·댓글·이미지·채팅 등 이용자가 입력한 콘텐츠, 앱 사용·보안·통계에 필요한 기기·접속·행태 정보 등을 처리할 수 있습니다.',
    purpose: '수집 목적',
    purposeBody: '서비스 제공·개선, 맞춤 지역 콘텐츠, 사기 방지, 고지, 선택 동의 시 마케팅 등',
    retention: '보관 기간',
    retentionBody: '탈퇴 시 또는 목적 달성 시까지, 관련 법령이 정한 경우는 해당 기간',
    thirdParty: '제3자 제공 / 판매',
    thirdPartyBody:
      '회원의 개인정보를 사업적으로 판매하지 않습니다. 인프라·분석 등 처리 위탁은 서비스 운영에 필요한 범위에서 이루어질 수 있습니다. 무관한 제3자 마케팅 전달은 별도 동의가 있을 때만 합니다.',
    gdpr: 'GDPR(EEA/UK 등)',
    gdprBody:
      '해당 권리가 있으면 열람·정정·삭제·이동·처리제한·이의 제기 권한을 보장하기 위해 노력하며, 감독기관에 이의를 제기할 수 있습니다.',
    deletion: '삭제 요청',
    deletionBody: '앱 설정 → 회원 탈퇴, 또는 support@mingo.app 으로 연락. 분쟁·법령에 따라 일부는 보관될 수 있습니다.',
    security: '보안',
    securityBody: '암호화(전송), 접근 제어 등을 적용하나, 어떤 시스템도 완전하진 않으니 강한 비밀번호를 쓰세요.',
    contact: '문의',
    cookies: '쿠키 및 유사 기술',
    cookiesBody:
      '로그인 유지, 설정 저장, 기본 이용 통계, 남용 방지를 위해 쿠키·로컬 스토리지 등을 사용할 수 있습니다. 브라우저 설정 또는 앱 데이터 삭제로 일부를 제어할 수 있습니다.',
    minors: '아동·청소년',
    minorsBody:
      '본 서비스는 관할 법령상 부모 동의가 필요한 연령 미만을 대상으로 하지 않습니다. 미성년자의 정보가 수집된 것으로 판단되면 연락 주시면 조치하겠습니다.',
    transfers: '국제 이전',
    transfersBody:
      '데이터는 거주지 외 국가(제공업체 위치)에서 처리될 수 있으며, 필요 시 표준계약조항 등 적법한 안전장치를 사용합니다.',
    regulatory: '규제 고지',
    regulatoryBody:
      '거주 지역에 따라 추가 권리·고지가 적용될 수 있으며, 현지 강행법에서 배제할 수 없는 권리는 유지됩니다.',
    disputePrivacy: '개인정보 관련 분쟁',
    disputePrivacyBody:
      '개인정보 문제는 먼저 문의 주시고, 해당 법률에 따라 감독기관에 이의를 제기할 수 있습니다.',
  },
  termsPage: {
    title: '서비스 이용약관',
    intro: '서비스 소개',
    introBody:
      'Mingo(밍고)는 해외 체류자·여행자를 위한 정보·커뮤니티 연결 서비스입니다. 오프라인 거래·채용의 당사자는 이용자이며, 당사는 연결·정보 제공에 그칩니다.',
    role: '플랫폼의 역할',
    roleBody:
      '당사는 직업소개소·부동산 중개·은행·에스크로가 아닌 경우가 많습니다(별도 계약이 없는 한). 당사자는 서로 합의로 계약·거래하며, 민·형사 책임은 당사자에게 있습니다.',
    rules: '이용 규칙',
    rulesBody: '허위 연락처·기만 정보 게시, 안전거래·커뮤니티 가이드 위반을 해서는 안 됩니다.',
    prohibited: '금지 행위',
    prohibit1: '사기, 허위 정보, 금전 편취',
    prohibit2: '괴롭힘·혐오·괴롭힘성 언론',
    prohibit3: '불법 정보·타인·기관 사칭',
    prohibit4: '스팸·자동화 남용',
    disclaimer: '면책',
    disclaimerBody:
      '콘텐츠는 “있는 그대로” 제공됩니다. 이용자 콘텐츠의 사실·적법성·안전에 대해 보증하지 않으며, P2P 거래 손해에 대해 당사는 직접 당사자로서 책임을 지지 않을 수 있습니다.',
    dispute: '분쟁 해결',
    disputeBody: '이용자 간 분쟁은 신고·차단, 관할 기관, 재판 등의 절차에 따르며, 당사는 선의의 협조에 노력합니다.',
    law: '준거법 및 관할',
    lawBody: '본 약관은 대한민국 법령이 준거법이며, 분쟁은 대한민국 법률이 정한 법원을 관할로 합니다(강행법이 허용하는 범위에서).',
    modifications: '약관 변경',
    modificationsBody:
      '서비스·법령·보안에 따라 약관을 개정할 수 있으며, 중요한 변경은 앱 내 공지 또는 이메일로 안내할 수 있습니다. 시행일 이후 계속 이용하면 개정에 동의한 것으로 봅니다.',
    indemnity: '면책·배상',
    indemnityBody:
      '법이 허용하는 범위에서, 귀하의 서비스 오용·게시 콘텐츠·약관·법령 위반으로 발생한 청구·손해·비용(합리적인 변호사 비용 포함)으로부터 밍고 및 관련 주체를 면책·방어합니다.',
    userContent: '이용자 콘텐츠 및 라이선스',
    userContentBody:
      '게시물의 권리는 귀하에게 있으나, 서비스 운영·개선·안전·번역·표시를 위해 호스팅·저장·복제·가공·배포할 수 있는 비독점적 라이선스를 부여합니다.',
    aiDisclaimer: 'AI·번역·운세 기능',
    aiDisclaimerBody:
      '자동 번역·추천·운세형 콘텐츠는 편의·엔터테인먼트 목적이며 법률·의료·금융·이민 등 전문 조언을 대체하지 않습니다.',
    marketplaceRisk: '개인 간 거래',
    marketplaceRiskBody:
      '거래·만남은 이용자 간 책임입니다. 신원·품질·대금을 독립적으로 확인하고 공공장소에서 만나며, 사기 의심 시 앱 내 신고 기능을 이용하세요.',
    arbitration: '분쟁 전 합의',
    arbitrationBody:
      '소송 전 선의로 연락하여 해결을 시도합니다. 법이 허용하는 한 긴급 가처분은 예외로 할 수 있습니다.',
    severability: '분리가능성',
    severabilityBody: '일부 조항이 무효여도 나머지 조항은 유효합니다.',
    accessibility: '접근성',
    accessibilityBody:
      '가독성·모바일 사용성을 개선하기 위해 노력합니다. 장벽이 있으면 구체적으로 알려 주시면 합리적 개선을 검토합니다.',
  },
  notificationCenter: {
    title: '알림',
    markAll: '전체 읽음',
    unread: '읽지 않음',
    loading: '알림을 불러오는 중…',
    emptyRemote: '새 알림이 없습니다.',
    tab: {
      all: '전체',
      unread: '안 읽음',
      read: '읽음',
    },
  },
  home: {
    feedLabel: '중고거래 목록',
    categories: { all: '전체', used: '중고거래', rent: '렌트', job: '구인구직' },
    loadingFeed: '피드 불러오는 중…',
    pullRelease: '놓으면 새로고침',
    productCategoryFilter: '카테고리',
    sectionCategoryServices: '서비스',
    sectionTrade: '최근 거래',
    sectionMingoStory: '밍고스토리',
    sectionFeedAds: '추천',
    sectionHotCommunity: '인기 커뮤니티',
    sectionLostFound: '분실·실종 소식',
    lostFoundUrgent: '긴급',
    sectionEvents: '행사·장터',
    ariaEvents: '행사·장터',
    sectionNearbyBiz: '내 주변 업체',
    adRailTitle: '추천 업체',
    sponsored: '스폰서',
    sectionLife: '생활정보',
    sectionCommunity: '커뮤니티',
    sectionVnNews: '베트남 소식',
    ariaVnNews: '베트남 소식',
    sectionCountryNews: '{country} 소식',
    ariaCountryNews: '{country} 소식',
    sectionDiscover: '발견 피드',
    ariaDiscover: '발견 피드',
    discoverLoadMore: '더 보기',
    newsAgo: {
      justNow: '방금',
      minutes: '{n}분 전',
      hours: '{n}시간 전',
      days: '{n}일 전',
      weeks: '{n}주 전',
      months: '{n}개월 전',
      years: '{n}년 전',
    },
    newsSource: {
      embassy: '대사관',
      local: '로컬',
      exchange: '환율',
      general: '뉴스',
      insidevina: '인사이드비나',
      default: '뉴스',
    },
    newsCategory: {
      politics: '정치',
      society: '사회',
      economy: '경제',
      sports: '스포츠',
      general: '일반',
    },
    newsCategoryAll: '전체',
    more: '더보기',
    visaRun: '비자런',
    noVisaRun: '예정 없음',
    emptySection: '표시할 항목이 없어요.',
    eventAriaLabel: '밍고 이벤트',
    eventTitle: '🎯 밍고 이벤트',
    eventEmptyHint: '진행 중인 모임·이벤트를 확인하고 참여해 보세요.',
    eventSeeAll: '이벤트 보러가기',
    interestAds: '맞춤 추천',
    shortsPromo: '밍고스토리',
    shortsPromoTitle: '다낭 교민들의 생생한 일상을\n쇼츠로 만나보세요',
    shortsPromoBtn: '쇼츠 보러가기',
    interestAdsSub: '내 관심사 기반 추천',
    communityEmpty: '아직 게시글이 없어요. 첫 글을 남겨보세요!',
    communityWriteBtn: '글쓰기',
    sampleBiz: '샘플',
    dealTitle: '오늘의 딜',
    globalServices: '글로벌 서비스',
    globalServicesSub: '어디서든 이용 가능한 서비스',
    onlineServices: '온라인 서비스',
    onlineServicesSub: '비대면으로 이용 가능한 서비스',
    badgeGlobal: '전세계',
    badgeOnline: '온라인',
    recTitleTourist: '🎯 여행자 추천',
    recTitleNomad: '💻 노마드 추천',
  },
  trade: {
    title: '거래',
    empty: '이 카테고리에 올라온 글이 없어요.',
    selling: '판매중',
    reserved: '예약중',
    done: '거래완료',
    laneAll: '전체',
    laneFeed: '피드',
    laneUsed: '중고거래',
    laneRent: '렌트',
    laneJobs: '구인구직',
    laneGroup: '공동구매',
    lanesAria: '거래 유형',
    categoryFilter: '카테고리',
    searchPlaceholder: '상품명·지역 검색',
    shortcuts: {
      aria: '바로가기',
      realEstate: '부동산',
      jobs: '구인구직',
      moving: '이사/청소',
      rental: '렌트',
      groupBuy: '공동구매',
      vehicle: '차량',
    },
    jobsInlineHint: '구인구직 미리보기 — 전체는 구인구직에서 확인하세요.',
    openJobsPage: '구인구직 열기',
    openGroupBuyPage: '공동구매 전체',
    price: '가격',
    region: '지역',
    category: '카테고리',
    description: '상품 설명을 입력하세요',
    priceInput: '가격을 입력하세요',
    addPhoto: '사진 추가',
    currency: '화폐단위',
    condition: '상태',
    new: '새상품',
    used: '중고',
    sold: '거래완료',
  },
  life: {
    title: '생활정보',
    localIntro: '검색하거나 카테고리로 주변 생활 정보를 확인하세요.',
    exchangeInSettings: '환율 계산: 앱 설정에서 이용할 수 있어요.',
    koreanOk: '한국어 가능',
    koreanLimited: '한국어 제한',
    signature: '대표 메뉴',
    categorySectionTitle: '카테고리',
    listingsDbIntro:
      '「DB 통합 리스팅」은 병원·맛집 등 카테고리별로 Supabase에 등록된 글을 한곳에서 모아 보는 메뉴예요. 앱 업데이트 없이 운영에서 카테고리를 켜고 끌 수 있어요.',
    searchPlaceholder: '병원, 맛집, 미용...',
    registeredListTitle: '등록된 업체',
    viewMap: '지도',
    viewList: '목록',
    mapListToggle: '보기 전환',
    openInGoogleMaps: 'Google 지도에서 열기',
    mapMiniHint: '핀을 눌러 업체를 선택하세요.',
    mapMiniDetail: '상세 보기',
    favoritesSection: '즐겨찾기',
    safepathScopeCaption: '지역 기준',
    safepathFallbackNote: '이 지역 전용 시드가 없어 기본(다낭) 안내를 보여줍니다.',
    safepathComingSoonByRegion: '🚧 {region} 지역 정보는 준비 중입니다.',
    safepathInheritedNote: '인근 지역 템플릿을 바탕으로 표시됩니다. 공식 안내를 확인하세요.',
    safepathOfficialDisclaimer: '실제 절차·서류는 관할 기관 및 대사관 공지를 최우선으로 확인해 주세요.',
    safepathNotFound: '해당 항목을 찾을 수 없습니다.',
    safepathSectionTasks: '핵심 할 일',
    safepathSectionDetails: '체크리스트',
    safepathSectionAgencies: '관련 기관',
    safepathSectionPartners: '참고 파트너 유형',
    safepathSectionTrust: '검수·출처',
    safepathRiskHigh: '민감도: 높음',
    safepathRiskMedium: '민감도: 보통',
    favorite: '즐겨찾기',
    unfavorite: '즐겨찾기 해제',
    emptyList: '등록된 업체가 없습니다.',
    searchNoMatch: '검색 결과가 없어요. 다른 키워드를 시도해 보세요.',
    searchOnMain: '이 페이지는 가이드·링크 위주입니다. 업체 검색은 생활정보 메인에서 해 보세요.',
    registerBannerQ: '이 분야 업체를 운영하시나요?',
    registerBannerA: '무료로 등록하세요!',
    registerBannerBtn: '업체 등록하기',
    registerFromEmpty: '업체 등록하기',
    pageHospital: '병원/약국',
    pageRestaurant: '맛집',
    pageVisa: '비자/행정',
    visaPageNote: '비자·서류·연장 조건은 개인별로 다릅니다. 링크와 정부/대사관 공지를 꼭 확인하세요.',
    pageBeauty: '미용/마사지',
    pageCleaning: '청소/이사',
    pageReturn: '귀국정보',
    call: '전화하기',
    map: '지도보기',
    vnEmergency: '베트남 응급 (경찰·구급)',
    emergencyCall: '전화하기 (115)',
    vnEmergencyLine: ' ※ 현지 115 · 필요 시 대사관·여행자 보험 안내를 확인하세요.',
    hospitalKoreanHint: '다낭에서 한국어가 가능한 병원·클리닉은 아래에서 확인하세요. (정보는 참고용)',
    hospitalSections: '빠른 안내',
    hospitalKoreanList: '한국어 가능 병원/클리닉 — 방문 전 전화로 가능 여부 확인',
    hospitalER: '24시간 응급실 — 응급 심한 경우 115, 가까운 국제병원 응급실',
    hospitalPharmacy: '약국 — 처방전·영문 약이름을 준비하면 수월합니다.',
    restFilterAll: '전체',
    restFilterKorean: '한식',
    restFilterLocal: '현지식',
    restFilterWestern: '양식',
    restFilterCafe: '카페',
    foodExploreTitle: '맛집·음식 탐색',
    foodExploreHint: '등록 업체와 가이드 맛집을 한곳에서 찾아보세요. 지역 제한 없이 정렬·검색할 수 있어요.',
    foodExploreCta: '맛집·음식 전체 탐색',
    foodExploreSortLabel: '정렬',
    foodExploreSortRecommended: '추천순',
    foodExploreSortRating: '별점 높은순',
    foodExploreSortReviews: '리뷰 많은순',
    foodExploreDeliveryBadge: '배달 가능',
    openNow: '영업중',
    closed: '마감',
    reviewsCount: '리뷰',
    priceTier: '가격대',
    bookVia: '예약',
    bookPhone: '전화',
    bookKakao: '카카오',
    cleaningTipsTitle: '이용 팁',
    cleaningCheck: '이사 전 체크: 계약서·취득세·채널(엘리베이터) 확인',
    cleaningPrice: '평균 가격은 평수·이동거리에 따라 달라요. 견적 2~3곳 권장.',
    cleaningQuote: '견적 문의하기',
    returnD30: 'D-30: 은행·렌트 정리, 비행 일정, 짐 수량 파악',
    returnD7: 'D-7: 수하물 규정 확인, 세관 제한 품목(금·현금) 확인',
    returnD0: 'D-day: 항공권·여권·COVID/건강 서류, 출입국 심사 대비',
    movingAndBaggage: '이사·이삿짐·수하물',
    returnCheckTitle: '귀국 체크리스트',
    returnPageNote: '항공·입국·세관·건강·면허 규정은 수시로 바뀔 수 있어요. 링크와 공식 공지를 확인하세요.',
    typeClean: '청소',
    typeMove: '이사',
    customs: '세관/면세',
    customsLine: '입국 시 1인 USD 800(유연) 등 규정 확인 — 민감 품목(육·과일) 주의',
    returnShip: '이삿짐(해상/항공) — 견적 비교 후 포장/신고',
    returnBaggage: '항공 수하물 — 위탁/기내 kg·배터리(보조) 규정',
    nhisAndLicense: '건강보험·운전면허',
    returnNhis: '귀국 후 건강보험: 외국 체류 기간·유예 규정 확인(국민건강보험)',
    returnLicense: '한국면허 갱신·적성검사 일정(경찰청/인터넷) 확인',
    usefulLinks: '유용한 링크',
    visaTypes: '비자 종류',
    visaTypesLine: '관광(단기) · 취업(노동허가+비자) · 사업/투자 등(조건 다름) — 사전 확인 필수',
    visaHow: '신청/연장: 소속·초청에 따라 제출 서류가 달라집니다.',
    visaDocs: '여권 사본, 사진, 체류 목적·소명, 초청·노동계약(해당 시) 등',
    consulate: '다낭 한국총영사관(업무) — 사전 전화/예약 확인(공휴일·시간).',
    visaExtendSection: '체류·갱신',
    visaExtend: '체류/갱신은 만료 15일 이전 권장, 초과 시 과태료 가능',
    vnImmigration: '베트남 이민·출입국(공식 사이트)',
    krEmbassy: '한국 대사관·총영사관(예약)',
    visaRun: '비자·입국 정보(참고용)',
    koreaCustoms: '관세청(UniPass) · 입국 신고',
    nhis: '국민건강보험(복직/자격)',
    driverLicense: '운전면허(적성검사·갱신)',
    visaHowApply: '비자 신청: e-Visa(단기) 등 공식 루트, 취업·초청은 사전에 노동허가/초청 절차를 확인하세요.',
    visaChecklistTitle: '필요 서류(예시)',
    consulateCallout: '다낭·현지 총영사관/영사: 전화·업무시간·예약은 기관 홈페이지/공지 기준.',
    visaRunExplainer: '비자런(국경 이동)은 기간·횟수 제한·불이익 사례가 있을 수 있어요. 잘못된 정보만 믿지 말고 이민·출입국 공지를 기준으로 하세요.',
    beautyFilterAll: '전체',
    beautyFilterHair: '미용실',
    beautyFilterNail: '네일',
    beautyFilterMassage: '마사지',
    beautyFilterSpa: '스파',
  },
  community: {
    title: '커뮤니티',
    tabFeed: '게시판',
    tabGroup: '모임',
    recommendGroups: '인기 모임',
    seeAll: '전체보기',
    empty: '게시글이 없어요.',
    writeFab: '게시글 작성',
    writeFabLabel: '글쓰기',
    sortNew: '최신순',
    sortHot: '인기순',
    sortUpcoming: '다가오는 순',
    sortLabel: '정렬',
    dataEmpty: '데이터가 없습니다',
    dataError: '불러오지 못했습니다. 다시 시도해 주세요',
    extrasNavLabel: '커뮤니티 바로가기',
    surveysLink: '설문 · 포인트 적립',
    newsLink: '뉴스 · 가이드',
    groupsLink: '그룹 채팅',
    recipesLink: '레시피 · 요리',
    categoryGroupInfo: '정보 카드',
    categoryGroupFree: '자유글',
    category: {
      lostFound: '분실·실종',
    },
    categories: {
      near: '내 지역',
      all: '전체',
      event: '행사·장터',
      visarun: '비자런',
      travel: '같이가요',
      flash: '번개',
      general: '일반',
      free: '자유',
      qna: '질문',
      share: '공유·제보',
      food: '맛집추천',
      together: '같이해요',
      info: '정보공유',
      humor: '유머·일상',
      pet: '반려동물',
      realestate: '부동산·이사',
      jobs: '알바토크',
      jobtalk: '알바토크',
      review: '후기',
      incident: '사건사고',
      scam: '사기주의',
      notice: '긴급·공지',
      lost: '분실·실종',
      question: '질문',
      meet: '만남',
      emergency: '긴급·안내',
      education: '육아·교육',
      medical: '의료·건강',
      suggestion: '건의사항',
    },
    languageFilterLabel: '언어 필터',
    languageOptions: {
      all: '전체',
      ko: '한국어',
      en: '영어',
      vi: '베트남어',
      ru: '러시아어',
    },
    emptyDesc: '첫 글을 작성해보세요.',
    emptyAction: '✏️ 첫 글 쓰기',
    eventEmpty: '아직 등록된 행사가 없어요',
    eventEmptyDesc: '다가오는 행사·야시장 정보가 여기에 표시돼요.',
    eventBadgeAlways: '상설',
    eventBadgeRecurring: '매주',
    eventBadgeDday: 'D-{n}',
    allLoaded: '모든 글을 불러왔습니다',
  },
  contactSetup: {
    title: '연락처를 등록해보세요',
    desc: '카카오톡·왓츠앱·잘로로 교민들과 바로 연결돼요',
    registerBtn: '등록하기',
    later: '나중에',
  },
  myPage: {
    title: '내 정보',
    tagline: '함께하는 교민 안전 정보',
    menuNavAria: '설정 메뉴',
    logout: '로그아웃',
    manner: '매너온도',
    mannerAria: '신뢰도 매너온도',
    changeAvatarAria: '프로필 사진 변경',
    avatarBusy: '프로필 사진 처리 중...',
    menu: {
      realEstateBrowse: '부동산·임대 매물',
      myProperties: '내 매물 관리 (집주인·세입자)',
      trades: '내 거래내역',
      favorites: '관심목록',
      premium: '프리미엄 멤버십',
      visaAlerts: '비자·행정 안내',
      visaExpirySetup: '비자 만료일 설정',
      language: '언어 설정',
      region: '지역 설정',
      appSettings: '앱 설정',
      notificationSettings: '알림 설정',
      mingoEvents: '밍고 이벤트',
      exchangeRates: '환율 정보',
      blockedUsers: '차단한 계정',
      orders: '주문 내역',
      businessDashboard: '업체 대시보드',
      manageAds: '광고 설정 · 관리',
      pointHistory: '포인트 내역',
      accountSettings: '계정설정',
    },
    settings: { languageValue: '언어', regionValue: '지역' },
    pointsTitle: '포인트',
    pointsBalance: '보유',
    pointsUnit: 'P',
    referralCode: '내 추천 코드',
    copyReferral: '복사',
    copied: '복사했어요.',
    pointsHistory: '내역',
    pointsHistoryPage: '전체 내역',
    pointsPageTitle: '포인트 내역',
    pointsPageHint: '충전·차감 내역입니다. 날짜·금액·사유를 확인할 수 있어요.',
    pointsEmpty: '내역이 없어요.',
    pointsHow: '포인트는 추후 프리미엄 기능에 사용할 수 있어요 (베타).',
    languageModalTitle: '표시 언어',
    languageUpdated: '언어가 변경되었습니다',
    premiumUntil: '프리미엄 혜택(추천 보상) ~ {date}',
    paymentHistory: '결제 내역',
    paymentsEmpty: '결제 내역이 없어요.',
    receiptDownload: '영수증',
    receiptSoon: '영수증 다운로드는 준비 중이에요.',
    editProfile: '프로필 수정',
    following: '팔로잉',
    followers: '팔로워',
    activityScore: '활동지수',
    mannerTier: '등급',
    mannerNew: '신규',
    mannerNewDesc: '아직 노쇼·신고·리뷰 이력이 없어요. 활동이 쌓이면 등급이 매겨져요.',
    statsPoints: '밍고포인트',
    statsTrades: '거래완료',
    statsReviews: '받은리뷰',
    statsNoShow: '노쇼횟수',
    myTrades: '내 거래',
    myFavorites: '찜 목록',
    myReviews: '내 리뷰',
    myCommunityPosts: '내 커뮤니티 글',
    myCommunityPostsEmpty: '작성한 글이 없어요.',
    myCommunityPostsHint: '커뮤니티에서 글을 작성하면 여기에 모여요.',
    myGroups: '내 모임',
    myGroupsEmpty: '가입한 모임이 없어요.',
    myGroupsHint: '커뮤니티에서 모임을 찾아 가입하거나, 직접 모임을 만들어 보세요.',
    invite: '친구 초대',
    inviteCopied: '초대 링크가 복사되었습니다.',
    inviteShareText: '밍고에서 같이 다낭 생활정보 나눠요! 가입하면 포인트 드려요 🎁',
    noShowRecovery: '예약 제재 중 - 회복하기',
    referralTitle: '친구 초대 코드',
    referralInviteBtn: '초대하기',
    referralCount: '초대한 친구 {n}명',
    adCta: '내 업체를 광고해보세요!',
    expiryUrgentTitle: '기간만료 임박 알림',
    expiryUrgentToday: '오늘',
  },
  payments: {
    modalTitle: '결제',
    product: '상품',
    amount: '금액',
    card: '카드 정보',
    pay: '결제하기',
    success: '결제가 완료되었습니다.',
    disabledLead: '결제 서비스 준비 중입니다.',
    contact: '문의',
    invalidKey: 'Stripe Publishable Key가 유효하지 않습니다.',
    stripeNotReady: '결제 모듈을 불러오는 중입니다. 잠시 후 다시 시도해 주세요.',
    receiptLater: '영수증 이메일은 추후 발송 예정입니다.',
    comingShort: '준비 중입니다.',
    paid: '결제 완료',
    adTitle: '광고비 결제',
    adLead: '노출 범위에 따라 월 단가가 다릅니다. 결제 전 문의를 권장합니다.',
    selected: '선택',
    inquiryLink: '문의하기',
    adActivatedHint: '결제가 접수되었습니다. 슬롯 연결은 담당자가 진행합니다.',
    premiumTitle: '프리미엄 멤버십',
    premiumPrice: '월 {price} USD',
    premiumProductName: 'Mingo 프리미엄 (월간)',
    benefit1: '광고 없는 환경',
    benefit2: '게시글 상단 노출 1회/주',
    benefit3: '비자 알림 무제한',
    benefit4: '프리미엄 배지',
    premiumExtended: '프리미엄 기간이 연장되었습니다.',
    errors: {
      noApiUrl: '결제 서버 URL(REACT_APP_STRIPE_PAYMENT_API_URL)이 필요합니다.',
      network: '결제 서버에 연결할 수 없습니다.',
      intentFailed: '결제 준비에 실패했습니다.',
      card: '카드 결제에 실패했습니다.',
      notSucceeded: '결제가 완료되지 않았습니다.',
      noUser: '로그인 정보를 확인할 수 없습니다.',
      recordFailed: '결제 기록 저장에 실패했습니다.',
      generic: '결제 중 오류가 발생했습니다.',
    },
  },
  service: {
    title: '전체 서비스',
    sections: { fortune: '운세/타로', trade: '동네 거래', life: '생활 서비스', expat: '교민 정보', biz: '비즈니스' },
    items: {
      fortune: '운세/타로',
      used: '중고거래',
      rent: '렌트/임대',
      realestate: '부동산',
      jobs: '구인구직',
      car: '중고차',
      hospital: '병원/약국',
      food: '맛집',
      beauty: '미용/마사지',
      move: '청소/이사',
      visa: '비자/행정',
      meetup: '모임/이벤트',
      emergency: '긴급 연락처',
      lost: '분실물 찾기',
      ads: '광고 등록',
      bizProfile: '비즈니스 프로필',
      groupBuy: '공동구매',
      languageExchange: '언어 교환',
    },
  },
  serviceV2: {
    secTrade: '🛍️ 거래/쇼핑',
    secLife: '🏠 생활/서비스',
    secTravel: '✈️ 예약/관광',
    secSports: '🏃 스포츠/레저',
    secBooking: '🎫 예약/티켓/체험',
    secMedical: '🏥 의료/건강/교육',
    secPro: '💼 전문/법률',
    secFreelance: '✨ 프리랜서/재능',
    secBusiness: '💼 비즈니스/전문',
    secCreator: '🎬 크리에이터/콘텐츠',
    secCommunity: '👥 커뮤니티/정보',
    guideText: '업체·예약·거래는 여기서, 생활 정보는 생활정보 탭에서',
    items: {
      used: '중고거래',
      vehicles: '중고차',
      groupBuy: '공동구매',
      currencyExchange: '환전',
      talentMarket: '재능마켓',
      luxuryUsed: '명품중고',
      booking: '예약/티켓 허브',
      flights: '항공권',
      poolVilla: '풀빌라',
      liveCommerce: '라이브 쇼핑',
      crowdfunding: '크라우드펀딩',
      webtoon: '웹툰',
      shorts: '쇼츠',
      hotel: '호텔/숙박',
      insurance: '보험',
      remittance: '송금',
      community: '커뮤니티',
      news: '뉴스/정보',
      fortune: '운세',
      restaurant: '맛집',
      supermarket: '슈퍼마켓',
      dental: '치과',
      laundry: '세탁소',
      repair: '에어컨/수리',
      babysitter: '베이비시터',
      translation: '통역/번역',
      guideMarket: '가이드 마켓',
      sos: 'SOS 긴급도움',
      groupDelivery: '한국 직구',
      interpreter: '통역 서비스',
      realestate: '부동산',
      rental: '렌탈',
      koreanShop: '한국마트',
      wedding: '웨딩',
      deals: '딜/쿠폰',
      settlement: '정착패키지',
      golf: '골프',
      medicalTourism: '의료관광',
      boat: '요트/보트',
      photo: '사진/영상',
      eventPlanner: '이벤트플래너',
      digital: 'IT/디지털',
      professional: '전문서비스',
      visaAgency: '비자대행',
      mentoring: '멘토링',
      academy: '학원/교육',
      schools: '국제학교',
      educationConsult: '유학상담',
      experiences: '체험',
      activity: '액티비티',
      languageExchange: '언어교환',
      hospital: '병원/약국',
      pet: '펫서비스',
      fitness: '헬스/피트니스',
      groupChats: '그룹채팅',
      meetup: '이벤트/밋업',
      surveys: '설문조사',
      emergency: '긴급연락처',
      visa: '비자알림',
      carpool: '카풀',
      rider: '라이더',
      airportPickup: '공항픽업',
      mapSearch: '지도검색',
      bizProfile: '내 업체',
      ads: '광고 관리',
      jobs: '구인구직',
      expatInfo: '교민 필수 정보',
    },
  },
  shortsV2: {
    tabDiscover: '발견',
    tabStoryHome: '스토리홈',
    create: '스토리 올리기',
    createTitle: '스토리 작성',
    shortBadge: '쇼츠',
    next: '다음 영상',
    viewLink: '보러가기',
    chipAll: '당하동 전체',
    chipNearby: '걸어서 10분',
    chipRealEstate: '부동산',
    chipMeetup: '모임',
    uploadVideo: '영상 등록',
    uploadVideoDone: '영상 등록됨',
    uploadPhoto: '사진 등록',
    uploadPhotoDone: '사진 등록됨',
    addOnePhoto: '사진 추가 (선택)',
    photoHint: '사진은 최대 {max}장까지 올릴 수 있어요. (업로드 시 자동 압축)',
    photoMax: '사진은 최대 {max}장까지 올릴 수 있어요.',
    photoCount: '사진 {count}/{max}',
    filterLabel: '필터',
    intensityLabel: '강도',
    filterNone: '원본',
    filterWarm: '웜',
    filterCool: '쿨',
    filterVintage: '빈티지',
    filterContrast: '선명',
    filterMono: '흑백',
    durationHint: '5~60초 사이의 영상만 업로드 할 수 있어요.',
    durationInvalid: '영상은 5초~60초 사이만 업로드할 수 있어요. 다른 영상을 선택해주세요.',
    uploadNetworkError: '네트워크 연결을 확인해주세요.',
    uploadTooLarge: '영상 용량이 너무 큽니다. 더 짧은 영상으로 다시 시도해주세요.',
    storyPhotoOptionalHint: '사진은 선택사항이에요. 텍스트만으로도 스토리를 올릴 수 있어요.',
    titleLabel: '제목',
    titlePlaceholder: '제목을 입력해주세요 (선택)',
    contentLabel: '내용',
    content: '내용 입력',
    contentPlaceholder: '스토리와 관련한 간단한 내용을 입력해주세요.',
    place: '장소명',
    placePlaceholder: '스토리와 관련된 장소를 추가해주세요.',
    noTitle: '제목 없는 스토리',
    addTag: '태그 추가',
    submit: '작성 완료',
    created: '스토리가 등록되었습니다.',
    tabVideo: '영상',
    tabPhoto: '사진',
    tabStory: '스토리',
    mentionHint: '(@닉네임으로 멘션)',
    optionalParen: '(선택)',
    dragReorderHint: '드래그하여 순서 변경',
    changeVideo: '영상 변경',
    businessBlockTitle: '업체 홍보는 캠페인으로 등록해주세요',
    businessBlockDesc: '개인 스토리·숏 작성 화면은 개인 컨텍스트에서만 이용할 수 있습니다. 업체 홍보 영상은 광고 캠페인(ad_creative)으로 등록해 주세요.',
    businessPromoCta: '홍보 영상 등록하기',
    toolDockAria: '미디어 편집 도구',
    mirrorFlip: '좌우 반전',
    trimStart: '트림 시작 ({sec}s)',
    trimEnd: '트림 종료 ({sec}s)',
    playbackRate: '배속',
    coverFrame: '커버 프레임 ({sec}s)',
    altTextLabel: '대체 텍스트 (선택)',
    altTextPlaceholder: '스크린리더용 설명',
    pinPlaceLabel: '핀 장소명 (선택)',
    pinPlacePlaceholder: '예: 미케비치',
    aspectTitle: '세로(9:16) 비율 맞추기',
    aspectDesc: '원본({width}×{height})은 9:16이 아닙니다. 표시 방식을 선택하세요. 원본 파일은 그대로 업로드됩니다.',
    aspectCrop: '크롭 (꽉 채움)',
    aspectLetterbox: '레터박스 (블러 배경)',
    aspectOriginal: '원본 유지',
    overlayTextPlaceholder: '텍스트',
    overlayAdd: '추가',
    overlayAddAria: '텍스트 추가',
    overlayBgHighlight: '배경 하이라이트',
    overlayTextPrompt: '텍스트를 입력하세요',
    overlayTextAria: '텍스트 오버레이',
    overlayStickerAria: '스티커 오버레이',
    overlayDrawAria: '손그림 오버레이',
    overlayPinAria: '위치 핀',
    overlayDrawColorAria: '손그림 색상 {color}',
    overlayDrawHint: '사진 위를 드래그하면 손그림이 추가됩니다.',
    overlayPinHint: '사진을 탭하면 위치 핀이 추가됩니다.',
    font: {
      default: '기본',
      hand: '손글씨',
      bold: '굵게',
      typewriter: '타자기',
    },
    stroke: {
      thin: '얇게',
      normal: '보통',
      thick: '굵게',
    },
    tool: {
      stickers: '스티커',
      text: '텍스트',
      filter: '필터',
      frame: '액자',
      draw: '손그림',
      pin: '위치핀',
      video: '영상 편집',
    },
    filterPreset: {
      none: '원본',
      bright: '화사하게',
      vintage: '빈티지',
      cool: '쿨톤',
      warm: '웜톤',
      dreamy: '몽환적',
      grayscale: '흑백',
      highcontrast: '고대비',
      vivid: '선명하게',
      dark: '어둡게',
      sepia: '세피아',
      fresh: '청량함',
      pastel: '파스텔',
      film: '필름느낌',
      neon: '네온',
      lomo: '로모',
      cinematic: '시네마틱',
      golden: '골든아워',
      moonlight: '문라이트',
      intense: '강렬하게',
      soft: '부드럽게',
    },
    framePreset: {
      none: '없음',
      polaroid: '폴라로이드',
      'gradient-line': '그라데이션',
      'film-perf': '필름',
      round: '라운드',
      dotted: '도트',
      timestamp: '타임스탬프',
      'film-slide': '슬라이드',
      magazine: '매거진',
      blackline: '블랙라인',
      doubleline: '더블라인',
      'shadow-card': '그림자',
      'neon-glow': '네온',
      doodle: '낙서',
      ticket: '티켓',
      'sticky-note': '스티키',
    },
  },
  booking: {
    title: '예약/티켓',
    heroTitle: '다낭 교민 추천 예약 서비스',
    heroDesc: '체험·호텔·항공·가이드·의료관광\n한국어로 예약하세요',
    catExperiences: '🎫 체험/클래스/투어',
    catExperiencesDesc: '쿠킹클래스·서핑·투어·공연·요가',
    catHotel: '🏨 호텔/리조트',
    catHotelDesc: '다낭·호이안 호텔 비교 예약',
    catPoolVilla: '🏡 풀빌라',
    catPoolVillaDesc: '프라이빗 풀빌라 · 교민 특가',
    catFlights: '✈️ 항공권',
    catFlightsDesc: '한국↔베트남 항공권 검색',
    catGuides: '🧭 가이드 마켓',
    catGuidesDesc: '현지 한국어 가이드 예약',
    catMedical: '🏥 의료관광',
    catMedicalDesc: '베트남 의료관광 · 성형 · 검진',
    catAirport: '🚐 공항픽업',
    catAirportDesc: '다낭 공항 픽업/샌딩 서비스',
    featuredExp: '인기 체험',
  },
  hotel: {
    title: '호텔/숙박',
    all: '전체',
    search: '검색',
    categories: '유형',
    sortRecommended: '추천순',
    sortPriceLow: '가격낮은순',
    sortRatingHigh: '평점높은순',
    listDestinationPh: '목적지 (도시)',
    villaBannerTitle: '풀빌라 특별 숙소',
    villaBannerDesc: '프라이빗 풀빌라 · 교민 특가',
    registerCta: '호스트 등록',
    badgePopular: '인기',
    favorite: '찜하기',
    perNightFrom: '1박',
    totalForNights: '{nights}박 총',
    taxesIncluded: '모든 세금 포함',
    beachMinutes: '해변 {n}분',
    gallerySeeAll: '전체보기 {n}장',
    galleryTitle: '사진 전체',
    openMap: '지도보기',
    amenitiesGridTitle: '시설',
    roomsPick: '객실 선택',
    maxGuests: '최대 {n}명',
    breakfastIn: '조식 포함',
    breakfastOut: '조식 미포함',
    pay: { now: '지금 결제 (할인)', later: '나중에 결제', onsite: '현장 결제' },
    selectThisRoom: '이 객실 선택',
    locationSection: '위치',
    mapPreview: 'Google 지도에서 보기',
    distBeach: '해변까지 {n}분',
    distAirport: '공항까지 {n}분',
    distHospital: '병원까지 {n}분',
    distFood: '맛집까지 {n}분',
    revClean: '청결도',
    revLocation: '위치',
    revService: '서비스',
    revValue: '가성비',
    pickDates: '날짜선택',
    footerTotal: '총 금액',
    amenityAc: '에어컨',
    amenityWifi: 'Wi‑Fi',
    amenityPool: '수영장',
    amenityGym: '헬스장',
    amenityParking: '주차',
    amenityElevator: '엘리베이터',
    amenityBreakfast: '조식',
    amenityHousekeeping: '청소',
    amenitySafe: '금고',
    amenityPets: '반려동물',
    amenityNosmoking: '금연',
    amenityAccessible: '장애인 편의',
    register: {
      title: '호텔 등록',
      next: '다음',
      back: '이전',
      submit: '등록 신청',
      step1: '숙소 유형',
      step2: '기본정보',
      step3: '위치',
      step4: '요금설정',
      step5: '편의시설',
      step6: '객실정보',
      step7: '사진',
      step8: '하우스룰',
      step9: '노출',
      typeGuesthouse: '게스트하우스',
      typeVilla: '빌라',
      stepRoomInfo: '객실정보',
      stepPricing: '요금설정',
      stepAmenities: '편의시설',
      stepRules: '하우스룰',
      amenityPool: '수영장',
      amenityBreakfast: '조식',
      amenityParking: '주차',
      peakSeason: '성수기',
      offSeason: '비수기',
      hotelName: '호텔명',
      desc: '설명',
      country: '국가',
      city: '도시',
      address: '상세 주소',
      beachMin: '해변까지(분)',
      airportMin: '공항까지(분)',
      centerMin: '시내까지(분)',
      landmark: '주요 관광지',
      priceNight: '1박 가격',
      currency: '통화',
      minNights: '최소 숙박일',
      roomType: '객실 유형',
      roomGuests: '최대 인원',
      bedType: '침대 유형',
      roomPrice: '객실 1박 가격',
      addRoom: '객실 추가',
      heroUrl: '대표 이미지 URL',
      galleryUrls: '추가 이미지 URL (줄바꿈으로 구분)',
      cancelPolicy: '취소 정책',
      cancelFree: '무료취소',
      cancelPartial: '부분환불',
      cancelNone: '환불불가',
      checkinMethod: '체크인 방법',
      houseRules: '하우스 룰',
      languages: '언어 지원 (쉼표)',
      exposure: '노출 등급',
      perks: '특별 혜택',
      doneMsg: '검토 후 게시됩니다.',
      amenityBasic: '기본',
      amenityBath: '욕실',
      amenityBuilding: '건물',
      amenityService: '서비스',
      amenityOther: '기타',
      amenityTv: 'TV',
      amenityFridge: '냉장고',
      amenityBathtub: '욕조',
      amenityShower: '샤워',
      amenityHairdryer: '헤어드라이어',
      amenityRestaurant: '레스토랑',
      amenityBar: '바',
      amenityRoomService: '룸서비스',
      amenityLaundry: '세탁',
      amenityAirportPickup: '공항픽업',
      roomInvalid: '객실명과 가격을 확인해 주세요.',
      roomName: '객실명',
      roomImageUrl: '객실 이미지 URL',
      photoCatsHint: '카테고리별 URL은 중복 없이 합쳐 저장돼요 (최대 20장).',
      catExterior: '외관',
      catLobby: '로비',
      catRoom: '객실',
      catPool: '수영장',
    },
    reviewsLabel: '리뷰 {n}건',
    reviewsTab: '리뷰',
    noRooms: '등록된 객실이 없어요',
    noReviews: '아직 리뷰가 없어요',
    bookOk: '예약 요청이 접수됐어요',
    type: {
      hotel: '호텔',
      resort: '리조트',
      guesthouse: '게스트하우스',
      villa: '빌라',
      hostel: '호스텔',
    },
    checkIn: '체크인',
    checkOut: '체크아웃',
    guests: '인원',
    perNight: '1박',
    book: '예약하기',
    rooms: '객실',
    amenities: '시설/옵션',
    noHotels: '등록된 호텔이 없어요',
    adminTitle: '호텔 관리',
    adminTotal: '전체 호텔',
    adminPending: '승인 대기',
    adminReported: '신고됨',
    adminApprove: '승인',
    adminHide: '숨김',
    adminDelete: '삭제',
    adminName: '이름',
    adminCity: '도시',
    adminStatus: '상태',
    adminModeration: '검수',
  },
  rental: {
    title: '렌탈',
    allTypes: '전체',
    car: '차량',
    motorbike: '오토바이',
    scooter: '스쿠터',
    bicycle: '자전거',
    van: '밴/SUV',
    truck: '트럭',
    type_car: '승용차',
    type_suv_van: 'SUV/밴',
    type_motorbike: '오토바이',
    type_scooter: '스쿠터',
    type_bicycle: '자전거',
    type_truck: '트럭',
    type_e_scooter: '전동킥보드',
    type_tuk_tuk: '툭툭',
    type_boat: '보트',
    automatic: '자동',
    manual: '수동',
    seatsUnit: '인승',
    perDay: '1일',
    perWeek: '7일',
    perMonth: '30일',
    weekDiscountBadge: '7일 {n}%↓',
    pricePolicy: '가격 정책',
    discountDown: '할인',
    perDaySuffix: '/일',
    mileagePolicy: '주행거리',
    mileageLimitKm: '일 {n}km · 초과 km당 {fee}',
    fuelPolicy: '연료 정책',
    insurancePick: '보험 선택',
    driverOption: '운전 옵션',
    withDriverDaily: '기사 포함 (+{fee}/일)',
    withDriverIncluded: '기사 포함(요금 포함)',
    insuranceFullDaily: '풀커버 (+{fee}/일)',
    included: '포함',
    cityAll: '전체 도시',
    cityHcmc: '호치민',
    cityDaNang: '다낭',
    cityHanoi: '하노이',
    cityTokyo: '도쿄',
    cityOsaka: '오사카',
    cityBangkok: '방콕',
    cityChiangMai: '치앙마이',
    eScooter: '전동킥보드',
    suv: 'SUV/밴',
    tukTuk: '툭툭',
    boat: '보트',
    semiAuto: '세미자동',
    gasoline: '가솔린',
    diesel: '디젤',
    electric: '전기',
    hybrid: '하이브리드',
    withDriver: '기사 포함',
    selfDrive: '셀프 드라이브',
    licenseIntl: '국제면허',
    fuelFullToFull: '만땅 반납',
    fuelSameLevel: '현재상태 반납',
    fuelIncluded: '연료 포함',
    mileageUnlimited: '주행거리 무제한',
    insuranceBasic: '기본보험',
    insuranceFull: '풀커버',
    chipWithDriver: '기사포함',
    currencyLabel: '통화',
    discount7Toggle: '7일 할인율(%) 적용',
    discount7Pct: '7일 할인율 (%)',
    discount30Toggle: '30일 할인율(%) 적용',
    discount30Pct: '30일 할인율 (%)',
    offersDriverToggle: '기사 포함 옵션 제공',
    driverPerDayLabel: '기사 포함 추가 요금 (/일)',
    insuranceFullDailyHost: '풀커버 보험 추가 요금 (/일, 예약 시)',
    estTwentyDays: '월 20일 대여시 예상: {amount}',
    incToolsLabel: '공구',
    incChildSeatLabel: '어린이시트',
    incPhoneMountLabel: '폰 거치대',
    fuelPolicyPickTitle: '연료 정책',
    mileageKmDayLabel: '1일 주행 제한 (km)',
    mileageOverageLabel: '초과 시 km당 요금',
    registerLangs: '지원 언어',
    registerExposure: '노출 등급',
    deposit: '보증금',
    depositRefund: '반납시 전액 환불',
    licenseRequired: '면허 필요',
    licenseInternational: '국제면허',
    licenseLocal: '현지면허',
    licenseNone: '면허 불필요',
    minAge: '최소 나이',
    ageUnit: '세',
    delivery: '배달',
    deliveryAvailable: '배달 가능',
    deliveryNo: '픽업만 가능',
    deliveryFee: '배달비',
    pickup: '픽업',
    pickupDay: '픽업일',
    returnDay: '반납일',
    pickupLocation: '픽업 위치',
    pickupCity: '도시',
    pickupLocationPh: '예: 다낭 공항',
    pickupHours: '픽업 가능 시간',
    pickupInfo: '픽업/반납 정보',
    pickupMethod: '픽업 방법',
    pickupSelf: '직접 픽업',
    pickupDelivery: '배달 요청 (+{fee})',
    returnLocation: '반납 위치',
    includes: '포함사항',
    excludesTitle: '불포함',
    excludeFuel: '주유비',
    excludeRepair: '수리비',
    includesNone: '표시할 항목이 없어요',
    helmet: '헬멧',
    insurance: '기본보험',
    gps: 'GPS',
    bookNow: '예약하기',
    selectDates: '날짜 선택',
    cardChat: '채팅',
    cardRent: '렌트하기',
    applyRent: '렌트 신청하기',
    applyRentNeedDates: '날짜를 먼저 선택해 주세요',
    search: '검색',
    totalDays: '총 {n}일',
    totalAmount: '총 합계',
    registerCta: '차량 등록',
    myRentals: '내 차량',
    myBookings: '내 예약',
    noRentals: '등록된 차량이 없어요',
    noBookings: '예약 내역이 없어요',
    hostInfo: '호스트 정보',
    responseRate: '응답률',
    responseTime: '평균 응답시간',
    activityBadge: '활동지수 {n}',
    hostLangs: '지원 언어',
    reviewCar: '차량상태',
    reviewClean: '청결도',
    reviewPickup: '픽업편의',
    reviewValue: '가성비',
    reviewsTitle: '리뷰',
    reviewCount: '리뷰 {n}건',
    noReviews: '아직 리뷰가 없어요',
    verifiedVehicle: '인증차량',
    badgeNew: '신규',
    favorite: '찜하기',
    demoBadge: '데모',
    demoFavorite: '데모 차량은 찜할 수 없어요.',
    demoBooked: '데모 예약이 완료됐어요 (실제 결제 없음)',
    bookingSuccess: '예약이 확정됐어요!',
    needDates: '날짜를 선택해 주세요.',
    notFound: '차량을 찾을 수 없어요.',
    sortPrice: '가격순',
    sortRating: '평점순',
    noIntlLicense: '국제면허 불필요',
    specTitle: '스펙',
    specType: '차종',
    specTrans: '변속기',
    specSeats: '인원',
    specFuel: '연료',
    specCc: '배기량',
    specYear: '연식',
    specColor: '색상',
    specDoors: '도어',
    rulesTitle: '대여 조건',
    licenseNeed: '필요 면허',
    mapSection: '위치',
    openMap: '지도에서 보기',
    nextStep: '다음',
    prevStep: '이전',
    confirmBooking: '예약 확정하기',
    registerStep1: '차량 유형',
    registerStep2: '차량정보',
    registerStep3: '보험·면허',
    registerStep4: '요금설정',
    registerStep5: '추가옵션',
    registerStep6: '연료·주행',
    registerStep7: '픽업위치',
    registerStep8: '차량사진',
    registerStep9: '노출·연락처',
    register: {
      typeScooter: '스쿠터',
      typeBicycle: '자전거',
      stepVehicleInfo: '차량정보',
      stepPricing: '요금설정',
      stepPickup: '픽업위치',
      stepInsurance: '보험/면허',
      stepPhotos: '차량사진',
      stepOptions: '추가옵션',
      optionHelmet: '헬멧',
      optionGPS: 'GPS',
      optionAirport: '공항픽업',
    },
    registerTitle: '차량 등록',
    brand: '브랜드',
    model: '모델',
    year: '연식',
    color: '색상',
    seats: '인승',
    engineCc: '배기량(cc)',
    listingTitle: '노출 제목',
    listingTitlePh: '예: 2022 Toyota Camry',
    minAgeShort: '최소 나이',
    priceDay: '1일 가격',
    priceWeek: '1주 가격(선택)',
    priceMonth: '1개월 가격(선택)',
    estMonth: '월 30일 대여시 예상 수익',
    photoHint: '깨끗하고 밝은 사진이 예약률을 높여요!',
    photoFront: '앞면 (필수)',
    photoRear: '뒷면 (필수)',
    photoSide: '옆면',
    photoInterior: '내부',
    photoExtra: '추가',
    incCleanLabel: '청소 완료',
    incTankLabel: '만땅 제공',
    phone: '전화번호',
    kakao: '카카오톡 ID',
    consultHours: '상담 가능 시간',
    instantBook: '즉시예약 가능',
    submitList: '등록하기',
    registerDone: '등록됐어요. 검토 후 노출돼요.',
    adminTitle: '렌탈 관리',
    adminTotal: '전체 차량',
    adminAvailable: '이용가능',
    adminBooked: '예약중',
    adminReported: '신고됨',
    adminToday: '오늘 신규',
    adminApprove: '승인',
    adminHide: '숨김',
    adminDelete: '삭제',
    adminHost: '호스트',
    adminBookings: '예약수',
    adminStatus: '상태',
  },
  fortune: {
    title: '운세·타로',
    intro: '무료 운세가 있고, 광고를 본 뒤 무료로 쓰는 항목도 있어요.',
    freeLabel: '무료 (광고 없음)',
    adLabel: '광고 후 무료',
    adHint: '광고 보고 무료 이용',
    badge: '광고 보고 무료 이용',
    west12: '별자리',
    cats4: '재물 · 사랑 · 직업 · 건강',
    lunarYmd: '음력 생년월일',
    sajuHour: '태어난 시(모를 때는 모름)',
    run: '운세 보기',
    analyzing: '운세를 분석 중입니다... 🔮',
    claudeNoKey: 'AI 키가 없습니다. 로그인 후 서버(Edge)에 ANTHROPIC_API_KEY를 설정해 주세요.',
    claudeFail: '잠시 후 다시 시도해주세요',
    birthSaved: '생년이 프로필에 저장됐어요.',
    birthYear: '출생 연도 (띠용)',
    pickZodiac: '또는 띠 선택',
    date: '기준일',
    saveBirthToProfile: '생년 프로필에 저장',
    birthYearSolo: '출생 연도',
    zodiacAuto: '띠',
    tabDay: '일',
    tabWeek: '주',
    tabMonth: '월',
    birthMd: '생일(월/일) — 별자리',
    signIs: '별자리',
    loading: '불러오는 중…',
    luckColor: '이달의 행운 색',
    luckNum: '행운의 숫자',
    shareCta: '내 운세 공유하기',
    shareOk: '공유했어요',
    shareCopy: '클립보드에 복사했어요',
    sharing: '공유 중…',
    dreamMin: '조금 더 적어 주세요 (5자 이상).',
    nameLen: '2~6자 한글 이름만.',
    nameKoOnly: '한글만 입력해 주세요.',
    compatScore: '궁합 점수(참고)',
    tapToFlip: '탭해서 뒤집기',
    tarotSummary: '종합: 과거·현재·미래가 이어지는 흐름 속에서, 지금의 선택이 앞길을 열어요.',
    ad: {
      lead: '광고를 보면 무료로\n이용할 수 있어요 😊',
      skip: '닫기',
      continue: '이어가기',
      placeholder: '광고 영역',
      brandLine: 'Mingo - 교민 앱',
      adInquiry: '광고 문의: support@mingo.app',
    },
    m: {
      today: '오늘의 운세',
      horoscope: '별자리 운세',
      zodiac: '띠별 운세',
      astrology: '점성술',
      tarot1: '타로 1장',
      year: '올해/신년 운세',
      saju: '사주풀이',
      tojeong: '토정비결',
      tarot3: '타로 3장',
      compat: '궁합 보기',
      dream: '꿈해몽',
      name: '이름 풀이',
    },
    cat: { luck: '총운', wealth: '재물', health: '건강', love: '사랑' },
    legalFooter: '본 운세·점성·타로 등은 오락·참고용이며 전문적인 조언이 아닙니다. 중요한 결정은 전문가와 상담하세요.',
    aiPreamble1: 'AI가 생성한 오락용 콘텐츠입니다. 실제 점술·의료·법률 판단이 아닙니다.',
    aiPreamble2: '실제 운명·미래와 다를 수 있습니다.',
  },
  cookie: {
    title: '쿠키·저장소 안내',
    body: '로그인·언어 등 필수 저장소를 사용합니다. 분석·마케팅은 선택 끄기가 가능합니다.',
    gdpr: 'GDPR 권리(열람·정정·삭제 등)를 존중하며, 자세한 내용은 개인정보 처리방침을 보세요.',
    essential: '필수(앱 작동)',
    analytics: '분석(서비스 개선)',
    marketing: '마케팅(선택)',
    rejectNonEssential: '필수 외 거부',
    saveSelection: '선택 저장',
    acceptAll: '모두 허용',
    privacyLink: '개인정보 처리방침',
  },
  ads: { badge: '광고', paidNotice: '이 상품은 유료 광고입니다' },
  scamAlert: {
    regionLabel: '사기·안전 경고',
    badge: '경고',
    dismissToday: '오늘 하루 안보기',
    detail: '자세히 보기',
    carousel: '다른 경고',
  },
  scamBanner: {
    trade:
      '안전하게 거래하세요. 선입금·계좌이체 요구, 외부 메신저 유도, 시세보다 너무 싼 매물은 사기일 수 있어요. 가능하면 직거래하세요.',
    finance:
      '송금 사기 주의. 환율이 유난히 좋거나 "먼저 보내라"고 하면 의심하세요. 검증된 업체·공식 채널만 이용하세요.',
  },
  report: {
    title: '신고하기',
    type: '신고 유형',
    content: '신고 내용',
    placeholder: '상황을 간단히 적어 주세요 (3자 이상).',
    submit: '신고하기',
    sending: '전송 중…',
    done: '신고가 접수되었습니다. 감사합니다.',
    failed: '신고를 보낼 수 없습니다.',
    needContent: '내용을 입력해 주세요.',
    types: {
      false_info: '허위·과장 정보',
      fraud: '사기·금전 편취',
      illegal: '불법·범죄 연루',
      spam: '스팸·도배',
      other: '기타',
      scam: '사기',
      fake: '허위매물',
      abuse: '욕설·괴롭힘',
    },
    adminQueue: '접수된 신고는 검토됩니다. 다수 신고 시 게시글이 자동으로 숨겨질 수 있어요.',
    duplicate: '이미 이 글을 신고하셨어요.',
  },
  visaSettings: {
    title: '비자 만료일 설정',
    kind: '비자 종류',
    expire: '만료일',
    saving: '저장 중…',
    saved: '저장했어요.',
    failed: '저장에 실패했어요.',
    needDate: '만료일을 선택해 주세요.',
    kinds: {
      tourist: '관광',
      resident: '거주',
      work: '취업',
      student: '학생',
      other: '기타',
    },
  },
  visaAlert: {
    banner30: '비자 만료 30일 전입니다. 연장·준비를 확인하세요.',
    banner7: '비자 만료 7일 전입니다. 서류·일정을 서두르세요.',
    bannerExpired: '저장한 비자 만료일이 지났습니다. 정보를 갱신해 주세요.',
    urgentTitle: '비자 만료 임박',
    urgentBody: '내일 또는 오늘 비자가 만료됩니다. 상태를 확인하세요.',
    goVisa: '비자 안내 보기',
    dismissToday: '오늘 하루 안보기',
  },
  visaInfo: {
    pageTitle: '비자·행정 안내',
    myVisa: '내 비자 정보',
    noDate: '미설정',
    officialTitle: '공식 참고 링크',
    links: {
      immigrationVn: '베트남 출입국 (참고)',
      mofaKr: '외교부 해외안전여행 (참고)',
    },
    blocks: {
      tourist: {
        title: '관광비자',
        body: '체류 기간·무비자·연장 규정은 여권 국가별로 다릅니다. 공식 창구 외 브로커에 주의하고 입국 스탬프 사본을 보관하세요.',
      },
      resident: {
        title: '거주비자',
        body: '취업·가족·투자 등 목적별 조건이 다릅니다. 체류지 증명·소득·건강검진 등 갱신 서류를 미리 확인하세요.',
      },
      work: {
        title: '취업비자·노동허가',
        body: '고용주 스폰서십이 핵심입니다. 계약서·직종·세금 의무를 확인한 뒤 서명하세요.',
      },
      student: {
        title: '학생비자',
        body: '재학 증명·학교 서한이 필요할 수 있습니다. 주소·수업 기간 변경 시 학교에 알리세요.',
      },
      other: {
        title: '기타',
        body: '규정은 수시로 바뀝니다. 대사관·공식 이민청 안내를 최종 기준으로 확인하세요.',
      },
    },
    guidesTitle: '비자 가이드 (DB)',
    guidesCountry: '국가',
    guidesEmpty: '등록된 가이드가 없습니다. 마이그레이션을 적용해 주세요.',
    guidesReq: '필요 서류',
    guidesRenew: '갱신',
    guidesLink: '공식 링크',
    durationLabel: '체류·기간',
    countryVN: 'Vietnam / 베트남',
    countryTH: 'Thailand / 태국',
    countryKR: 'Korea / 한국',
    filterAll: '전체',
    notifyExpiry: '비자 만료 알림 받기',
    ddayDays: '{n}일',
    officialDisclaimer: '주의: 공식 사이트 최신 공지를 확인하세요.',
  },
  emergencySafety: {
    barAria: '긴급·안전',
    barTitle: '🆘 긴급·안전',
    alertBarAria: '긴급 안전 경보',
    more: '더보기',
    viewContacts: '긴급 연락처 보기',
    callFirst: '응급 시 먼저 전화하세요. 앱은 보조 안내입니다.',
    trustLine: '운영자 확인 정보 · AI 생성 아님',
    sosCall: '📞 응급 전화',
    moreAlerts: '외 {count}건 ›',
    alertModalTitle: '긴급 안전 경보',
    alertDetailLink: '자세히 보기',
    alertTypeScam: '사기 주의',
    alertTypeDisaster: '재난·기상',
    alertTypeHealth: '보건',
    alertTypeCivil: '민방위',
  },
  emergencyContacts: {
    title: '긴급 연락처',
    intro: '',
    regionHint: '선택 지역: {cities} · 기준 국가: {country}',
    regionUnset: '미선택(기본 베트남)',
    tabEmergency: '긴급',
    tabLocal: '내 지역',
    tabEmbassy: '대사관',
    tabHospital: '병원',
    tabCommunity: '한인커뮤니티',
    tabCommon: '공통',
    sectionLocal: '{country} 응급',
    sectionEmbassy: '대사관·영사관 ({country})',
    sectionHospital: '{country} 병원·응급실',
    sectionCommunity: '한인회·커뮤니티',
    sectionCommon: '공통',
    embassyMissing: '이 국가에 등록된 한국 대사관·영사관 목록이 없습니다. 외교부 해외안전여행을 확인하세요.',
    communityNote: '',
    rolePolice: '경찰',
    roleFire: '소방',
    roleAmbulance: '구급',
    roleFireAmbulance: '소방·구급(통합)',
    embassyKrHanoi: '주베트남 대한민국 대사관 (하노이)',
    embassyKrHcmc: '주베트남 대한민국 대사관 (호치민)',
    embassyKrDanang: '주다낭 대한민국 총영사관',
    embassyKrBangkok: '주태국 대한민국 대사관 (방콕)',
    embassyKrTokyo: '주일본 대한민국 대사관 (도쿄)',
    embassyKrOsaka: '주오사카 대한민국 총영사관',
    communityDanang: '다낭 한인회',
    communityHcmc: '호치민 한인회',
    communityBangkok: '방콕 한인회',
    communitySeoul: '서울 교민 모임',
    commonKoreanOnly: '한국인 이용자를 위한 공통 안내입니다.',
    commonMofaTitle: '외교부 해외안전여행 (국내)',
    commonMofaOverseasTitle: '해외 긴급전화 (모국 연결)',
    commonWiseTitle: 'Wise 긴급',
    commonWiseBody: '앱 또는 웹 고객센터에서 문의하세요.',
    commonInsuranceTitle: '여행자보험 긴급',
    commonInsuranceBody: '가입한 보험사에서 안내하는 긴급번호를 확인하세요. 보험사마다 다릅니다.',
    empty: '등록된 연락처가 없습니다.',
  },
  groupBuy: {
    title: '공동구매',
    register: '모집 글 등록',
    tabRecruiting: '모집중',
    tabOngoing: '진행중',
    tabCompleted: '완료',
    people: '참여 {cur} / 목표 {target}명',
    perPerson: '1인당',
    deadline: '마감',
    join: '참가하기',
    joined: '참여했어요.',
    joinFail: '참여에 실패했어요.',
    full: '모집이 마감됐어요.',
    completed: '완료',
  },
  groupBuyWrite: {
    title: '공동구매 등록',
    productName: '상품명',
    desc: '상품 설명',
    price: '1인당 가격 (숫자)',
    target: '목표 인원',
    deadline: '마감일',
    delivery: '배송 방법',
    contact: '주최자 연락처',
    photo: '사진',
    pickPhoto: '사진 선택',
    needFields: '필수 항목을 입력해 주세요.',
    fail: '등록에 실패했어요.',
  },
  talent: {
    hubTitle: '전문가를 찾고 계신가요?',
    hubDesc: '인테리어·수리·IT·사진·통역 등\n다양한 분야 전문가를 만나보세요',
    orBrowseAll: '또는 전체 둘러보기',
    registerDesc: '전문가로 등록하고 싶으세요?',
    registerLink: '재능마켓 보기',
    searchPlaceholder: '서비스명, 전문분야 검색',
    sortRating: '별점순',
    sortOrders: '주문순',
    sortNewest: '최신순',
    sortPrice: '가격순',
    registerBtn: '전문가 등록하기',
    notFound: '서비스를 찾을 수 없습니다',
    reviews: '후기',
    orders: '건',
    priceFixed: '고정가',
    pricePerHour: '시간당',
    deliveryIn: '{n}일 내 납기',
    serviceInfo: '서비스 정보',
    deliveryDays: '납기',
    days: '일',
    revisions: '수정 횟수',
    times: '회',
    noRevision: '수정 없음',
    responseTime: '응답 시간',
    about: '서비스 소개',
    portfolio: '포트폴리오',
    inquirySent: '채팅 문의를 시작합니다',
    inquiryBtn: '문의하기',
    registerTitle: '전문가 등록',
    stepCategory: '어떤 서비스를 제공하시나요?',
    stepService: '서비스 정보',
    serviceTitle: '서비스 제목',
    serviceTitlePlaceholder: '예: 한국어↔베트남어 전문 번역',
    serviceDesc: '서비스 소개',
    serviceDescPlaceholder: '제공하는 서비스, 경력, 강점을 소개해주세요',
    tags: '태그',
    tagsPlaceholder: '예: 번역, 공문서, 계약서 (쉼표로 구분)',
    languages: '가능 언어',
    stepPricing: '가격 및 납기',
    priceType: '가격 유형',
    price: '가격',
    stepContact: '연락처 및 확인',
    contactKakao: '카카오 오픈채팅',
    contactPhone: '전화번호',
    registerSuccess: '전문가 등록이 완료됐습니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록하기',
  },
  golf: {
    title: '골프/회원권',
    tabMarket: '🎫 회원권 마켓',
    tabMembership: '회원권',
    tabBuddy: '버디 찾기',
    tabClub: '동호회',
    typeAll: '전체',
    typeGolf: '골프장',
    typeResort: '리조트',
    typeSpa: '스파',
    typeFitness: '피트니스',
    typeTennis: '테니스',
    typeOther: '기타',
    exclusive: '밍고 독점',
    verified: '검증완료',
    inquiryOnly: '문의로 예약',
    emptyMembership: '등록된 회원권이 없습니다',
    emptyRound: '모집중인 라운딩이 없습니다',
    emptyClub: '동호회가 없습니다',
    postRound: '라운딩 모집',
    createClub: '동호회 만들기',
    clubCreateNeedVerified: '유기명 회원권이 인증된 경우에만 동호회를 만들 수 있어요.',
    clubCreateCta: '회원권 인증·등록',
    spotsLeft: '남은 자리',
    joinRound: '참가하기',
    joinSuccess: '참가 신청이 완료됐습니다',
    alreadyJoined: '이미 참가중입니다',
    roundFull: '마감됨',
    roundDetail: '라운딩 상세',
    notFound: '정보를 찾을 수 없습니다',
    courseInfo: '코스 정보',
    holes: '홀 수',
    caddie: '캐디',
    cart: '카트',
    teeTime: '티타임',
    amenities: '편의시설',
    description: '소개',
    bookingTitle: '예약 신청',
    selectDate: '날짜 선택',
    selectSlot: '티타임 선택',
    slotsLeft: '잔여',
    participants: '인원',
    notes: '요청사항',
    notesPlaceholder: '특별 요청사항을 입력하세요',
    stage1Notice: '현재 문의 단계입니다. 채팅으로 상세 안내를 받으세요',
    submitInquiry: '문의하기',
    submitBooking: '예약 신청',
    chatInquiry: '채팅 문의',
    chatContact: '채팅',
    bookingSuccess: '문의가 접수됐습니다. 채팅으로 안내드릴게요',
    bookingFail: '문의 접수에 실패했습니다',
    website: '공식 사이트',
    skillAll: '실력 무관',
    skillBeginner: '입문',
    skillIntermediate: '중급',
    skillAdvanced: '고급',
    skillBand: '실력',
    feeTypeLabels: {
      free: '무료',
      dutch: '더치페이',
      fixed: '고정 참가비',
    },
    date: '날짜',
    feeCost: '비용',
    feeIncludes: '포함사항',
    included: '포함',
    notIncluded: '별도',
    clubDetail: '동호회',
    joinClub: '가입 신청',
    joinClubGradeBlocked: '등급 조건 미충족',
    joinGradeLabel: '참여 최소 등급',
    joinGradeAny: '일반 이상',
    joinGradeUnnamedPlus: '무기명 회원권 이상',
    joinGradeNamedVerifiedPlus: '유기명 인증 회원권 이상',
    joinGradeRequired: '이 모임은 {grade}만 참여할 수 있어요.',
    joinClubSuccess: '동호회에 가입했습니다',
    clubWriteTitle: '동호회 만들기',
    clubName: '모임 이름',
    clubDesc: '소개',
    clubRegularDay: '정기 일정',
    roundWriteTitle: '라운딩 모집',
    roundTitle: '제목',
    roundCourse: '골프장',
    roundDate: '라운드 날짜',
    roundMax: '모집 인원',
    roundFee: '1인 비용',
    marketBannerTitle: '회원권 사고팔기',
    marketBannerDesc: '골프·리조트·스포츠 회원권 직거래',
    marketWrite: '내 회원권 등록',
    marketNotice: '개인 간 직거래입니다. 밍고는 거래에 책임지지 않습니다. 반드시 직접 확인 후 거래하세요.',
    marketEmpty: '등록된 회원권이 없습니다',
    marketWriteFirst: '첫 번째로 등록하기',
    marketWriteTitle: '회원권 등록',
    marketStepType: '어떤 회원권인가요?',
    marketStepBasic: '기본 정보',
    marketStepPrice: '가격 및 연락처',
    marketStepLegal: '법적 고지 및 확인',
    marketTitle: '제목',
    marketTitlePlaceholder: '예: 바나힐 무기명 회원권 양도',
    marketDesc: '상세 설명',
    marketDescPlaceholder: '회원권 상태, 혜택, 특이사항 등을 자세히 적어주세요',
    marketPrice: '판매 가격',
    marketExpires: '만료일',
    marketInfo: '회원권 정보',
    marketLegalTitle: '거래 주의사항',
    marketLegal1: '본 플랫폼은 개인 간 거래 게시판을 제공할 뿐, 거래를 중개하지 않습니다.',
    marketLegal2: '회원권 진위 여부는 반드시 해당 골프장/리조트에 직접 확인하세요.',
    marketLegal3: '유기명 회원권은 양도 시 골프장 승인이 필요할 수 있습니다.',
    marketLegal4: '거래 전 반드시 직접 만나 실물을 확인하세요. 선입금 요구는 사기일 수 있습니다.',
    marketLegal5: '밍고는 거래로 인한 손실, 사기 피해에 대해 법적 책임을 지지 않습니다.',
    marketLegalAgree: '위 주의사항을 모두 확인했으며 동의합니다',
    marketLegalNotice: '개인 간 직거래입니다. 밍고는 거래에 책임지지 않습니다.',
    marketDetailTitle: '회원권 상세',
    marketStatusManage: '거래 상태 변경',
    marketStatusUpdated: '상태가 변경됐습니다',
    marketStatus: {
      active: '거래중',
      reserved: '예약중',
      sold: '거래완료',
      cancelled: '취소',
    },
    marketWriteSuccess: '회원권이 등록됐습니다',
    marketWriteFail: '등록에 실패했습니다',
    namedBadge: '유기명',
    unnamedBadge: '무기명',
    transferPossible: '양도가능',
    negotiable: '가격협의',
    membershipTypeLabel: '회원권 종류',
    facilityName: '시설명',
    facilityNamePlaceholder: '예: 바나힐 골프클럽',
    facilityRules: '시설 양도 규정',
    facilityRulesPlaceholder: '골프장/리조트 양도 규정을 입력해주세요',
    contactKakao: '카카오 문의',
    contactKakaoPlaceholder: '카카오 오픈채팅 ID',
    contactPhone: '전화 문의',
    region: '지역',
    saveFail: '저장에 실패했습니다',
  },
  membership: {
    sectionTitle: '내 회원권',
    sectionDesc: '무기명/유기명 회원권을 등록하면 신뢰 배지 및 혜택이 강화됩니다. 회원권이 없어도 일반 모임은 커뮤니티에서 만들 수 있어요.',
    add: '회원권 추가',
    formTitle: '회원권 등록',
    type: '회원권 유형',
    typeGolf: '골프',
    typeResort: '리조트',
    typeSpa: '스파',
    typeFitness: '피트니스',
    typeTennis: '테니스',
    typeOther: '기타',
    facilityName: '시설명',
    facilityPlaceholder: '예: 바나힐 골프클럽',
    namedType: '회원권 종류',
    named: '유기명',
    unnamed: '무기명',
    memberNumber: '회원번호 (선택)',
    memberNumberPlaceholder: '회원증에 표시된 번호',
    expiresAt: '만료일',
    cardImage: '회원증 사진',
    cardImageHint: '회원증 사진으로 인증을 요청할 수 있습니다',
    notes: '메모',
    notesPlaceholder: '추가 정보',
    save: '저장',
    verified: '인증완료',
    pendingVerify: '인증대기',
    expires: '만료일',
    verifyNotice: '밍고 어드민이 회원증 사진 확인 후 인증합니다',
    addSuccess: '회원권이 등록됐습니다',
    addFail: '등록에 실패했습니다',
    deleteSuccess: '회원권이 삭제됐습니다',
  },
  contract: {
    title: '전자계약서',
    defaultTitle: '밍고 파트너십 계약서',
    parties: '계약 당사자',
    subject: '계약 대상',
    commissionRate: '수수료율',
    period: '계약 기간',
    terms: '계약 조건',
    signatures: '서명 현황',
    notSigned: '미서명',
    agreeLabel: '위 계약 내용을 확인하고 동의합니다',
    agreeFirst: '동의 체크 후 서명하세요',
    sign: '전자 서명하기',
    signSuccess: '서명이 완료됐습니다',
    signFail: '서명에 실패했습니다',
    alreadySigned: '이미 서명하셨습니다',
    notFound: '계약서를 찾을 수 없습니다',
    status: {
      draft: '초안',
      sent: '발송됨',
      signed: '서명완료',
      expired: '만료',
      cancelled: '취소',
    },
  },
  visaRun: {
    title: '비자런 모집',
    modeSelect: '모집 유형 선택',
    modePersonal: '개인 모집',
    modePersonalDesc: '교민끼리 자유롭게, 수수료 없음',
    modeBusiness: '업체 공식',
    modeBusinessDesc: '여행사·렌트카 공식 상품',
    filterAll: '전체',
    transportAll: '전체',
    transportType: '이동 수단',
    transportBus: '버스',
    transportVan: '승합차',
    transportCar: '개인차량',
    transportTrain: '기차',
    transportFlight: '항공',
    transportMixed: '복합이동',
    transportDetail: '이동 수단 상세',
    transportDetailPlaceholder: '예: VIP 버스, 에어컨 승합차 등',
    borderCrossing: '국경 통과 지점',
    borderCrossingPlaceholder: '예: 목 바이, 람 람, 카이웨',
    visaType: '비자 종류',
    visaTourist: '관광비자',
    visaEVisa: 'E-Visa',
    visaExempt: '무비자',
    visaOther: '기타',
    emptyFilter: '해당 유형의 모집이 없습니다',
    bookingUrl: '예약 링크',
    bookingUrlPlaceholder: '공식 예약 페이지 URL',
    officialBooking: '공식 예약하기',
    chatInquiry: '문의하기',
    chatContact: '채팅 문의',
    personalNotice: '개인 모집입니다. 채팅으로 직접 연락하거나 참여 버튼을 눌러주세요',
    joinUseOfficial: '상세 화면에서 공식 예약 링크를 이용해 주세요',
    write: '모집하기',
    writeTitle: '비자런 모집 등록',
    detailTitle: '비자런 상세',
    bannerText: '비자 만료 전 함께 다녀오세요! 혼자보다 저렴하게',
    tabRecruiting: '모집중',
    tabFull: '마감',
    tabCompleted: '완료',
    empty: '모집중인 비자런이 없습니다',
    writeFirst: '첫 번째 모집하기',
    join: '참여하기',
    joinSuccess: '참여 신청이 완료됐습니다',
    joinFail: '참여 신청에 실패했습니다',
    alreadyJoined: '이미 참여중입니다',
    statusFull: '마감됨',
    statusCompleted: '완료됨',
    spotsLeft: '남은 자리',
    notFound: '비자런 정보를 찾을 수 없습니다',
    destination: '목적지',
    departCity: '출발 도시',
    formTitle: '제목',
    titlePlaceholder: '예: 다낭→캄보디아 비자런 모집',
    departDate: '출발일',
    returnDate: '귀국일',
    price: '1인 비용',
    maxParticipants: '최대 인원',
    currency: '통화',
    includes: '포함사항',
    includesPlaceholder: '예: 항공권, 호텔 (쉼표로 구분)',
    excludes: '불포함사항',
    excludesPlaceholder: '예: 비자비용, 식사 (쉼표로 구분)',
    meetingPoint: '집결지',
    meetingPointPlaceholder: '예: 다낭 공항 3터미널 오전 6시',
    description: '상세 설명',
    descPlaceholder: '비자런 일정, 주의사항 등 자세히 적어주세요',
    contact: '연락처',
    contactPlaceholder: '카카오톡 ID 또는 전화번호',
    submit: '모집 등록하기',
    writeSuccess: '비자런 모집이 등록됐습니다',
    writeFail: '등록에 실패했습니다',
    city: {
      danang: '다낭',
      hcmc: '호치민',
      hanoi: '하노이',
    },
  },
  transfer: {
    title: '권리금/업체 승계',
    write: '등록하기',
    writeTitle: '승계 매물 등록',
    detailTitle: '승계 상세',
    bannerText: '귀국·사정으로 양도하는 매물을 찾아보세요. 수수료 없이 직거래',
    empty: '등록된 매물이 없습니다',
    writeFirst: '첫 번째 등록하기',
    notFound: '매물 정보를 찾을 수 없습니다',
    typeAll: '전체',
    typeStore: '가게',
    typeRestaurant: '식당',
    typeCafe: '카페',
    typeOffice: '사무실',
    typeHouse: '주거',
    typeOther: '기타',
    premium: '권리금',
    monthlyRent: '월세',
    perMonth: '월',
    negotiable: '가격 협의',
    remainingLease: '잔여 계약',
    months: '개월',
    regionSection: '지역',
    currency: '통화',
    formTitle: '제목',
    titlePlaceholder: '예: 미케비치 카페 권리금 양도',
    region: {
      all: '전체',
      danang: '다낭',
      hcmc: '호치민',
      hanoi: '하노이',
    },
    address: '주소/위치',
    addressPlaceholder: '예: 다낭 미케비치 근처',
    sizeSqm: '면적 (㎡)',
    reason: '양도 사유',
    reasonReturn: '귀국 예정',
    reasonBusiness: '사업 종료',
    reasonPersonal: '개인 사정',
    reasonOther: '기타',
    includes: '포함 항목',
    includesPlaceholder: '예: 인테리어, 주방기기 (쉼표로 구분)',
    description: '상세 설명',
    descPlaceholder: '업체 현황, 매출, 특징 등 자세히 작성해주세요',
    contactPhone: '전화번호',
    contactKakao: '카카오톡 ID',
    kakaoPlaceholder: '카카오톡 오픈채팅 ID',
    stepType: '어떤 매물인가요?',
    stepBasic: '가격 정보',
    stepLocation: '위치 및 규모',
    stepDetail: '상세 정보',
    stepContact: '연락처 및 확인',
    stepConfirm: '등록 내용 확인',
    submit: '매물 등록하기',
    writeSuccess: '매물이 등록되었습니다',
    writeFail: '등록에 실패했습니다',
    statusUpdated: '상태가 변경되었습니다',
    statusManage: '상태 관리',
    status: {
      active: '거래중',
      negotiating: '협의중',
      done: '완료',
      cancelled: '취소',
    },
    kakaoContact: '카카오 문의',
    phoneContact: '전화 문의',
    chatContact: '채팅 문의',
    legalNotice: '본 플랫폼은 중개 역할을 하지 않습니다. 거래 전 반드시 직접 확인하세요.',
  },
  events: {
    title: '밍고 이벤트',
    participate: '참여하기',
    completed: '참여 완료',
    alreadyCompleted: '이미 참여한 이벤트예요',
    empty: '현재 진행 중인 이벤트가 없어요',
    myMingo: '내 밍고',
    dDay: 'D-{n}',
    register: '이벤트 등록',
    feeFree: '참가비 무료',
    feePaid: '참가비 {amount} {cur}',
    participants: '참가 {cur} / 최대 {max}',
    join: '참가 신청',
    joined: '신청했어요.',
    joinFail: '신청에 실패했어요.',
    full: '정원이 찼어요.',
    ticketsTitle: '티켓',
    ticketRemaining: '{n} / {max} 남음',
    ticketBuySoon: '티켓 구매 (준비 중)',
    ticketStandard: '일반석',
    ticketVip: 'VIP석',
    ticketTrail: '트레일 패스',
    ticketSnackPack: '간식 팩 추가',
    rewardGranted: '🎉 {amount} 지급!',
  },
  eventsWrite: {
    title: '이벤트 등록',
    name: '이벤트명',
    datetime: '날짜/시간',
    place: '장소',
    fee: '참가비 (0=무료)',
    max: '최대 인원',
    body: '상세 설명',
    photo: '사진',
    needFields: '필수 항목을 입력해 주세요.',
    fail: '등록에 실패했어요.',
  },
  langEx: {
    title: '언어 교환',
    intro: '모국어와 배우고 싶은 언어를 등록하고 파트너를 찾아보세요.',
    cards: '프로필',
    partner: '회원',
    native: '모국어',
    learning: '배우고 싶은 언어',
    level: '레벨',
    times: '가능 시간',
    timesPh: '예: 평일 19–21시',
    mode: '방식',
    bio: '소개',
    register: '내 프로필 등록/수정',
    save: '저장',
    needLang: '모국어와 배울 언어를 입력해 주세요.',
    fail: '저장에 실패했어요.',
    levelBeginner: '초급',
    levelMid: '중급',
    levelAdv: '고급',
    methodOnline: '온라인',
    methodOffline: '오프라인',
    methodBoth: '온·오프',
  },
  chat: {
    newChat: '+ 새 채팅',
    title: '채팅',
    inputPlaceholder: '메시지를 입력하세요',
    send: '전송',
    sendPhoto: '사진전송',
    completeTrade: '거래완료',
    writeReview: '후기작성',
    leaveChat: '채팅방 나가기',
    noMessages: '메시지가 없습니다',
    blocked: '차단된 사용자입니다',
    loadingList: '대화 목록 불러오는 중…',
    empty: '채팅이 없어요. 상품에서 채팅을 시작해 보세요.',
    noMessagesYet: '메시지가 없어요',
    unread: '읽지 않음 {n}건',
    loginToSee: '로그인하면 내 채팅을 볼 수 있어요.',
    emptyTitle: '아직 채팅이 없어요',
    emptyDesc: '교민들과 대화를 시작해보세요',
    emptyDescBiz: '업체 상품에서 문의하기를 눌러 대화를 시작해 보세요.',
    selectRoom: '채팅방을 선택하세요.',
    expandPopup: '확장',
    messageDeleted: '메시지가 삭제되었습니다',
    defaultRoom: '채팅',
    defaultGroup: '모임',
    loadListFailed: '채팅 목록을 불러오지 못했습니다.',
    tabs: {
      chat: '채팅',
      group: '모임',
      business: '거래',
      dm: 'DM',
    },
    tradeProduct: '중고 거래',
    businessInquiry: '업체 문의',
    unknownUser: '알 수 없음',
    promoTitle: '이런 서비스 어때요?',
    promoInvite: '친구 초대',
    promoInviteDesc: '친구를 초대하고 보상 받기',
    promoTheme: '테마 설정',
    promoThemeDesc: '채팅 테마 커스터마이즈',
    promoSafety: '안전 거래 가이드',
    promoSafetyDesc: '안전한 거래 대화 가이드',
    promoGuide: '빠른 사용법',
    promoGuideDesc: '채팅 사용법 빠르게 보기',
    time: { justNow: '방금', daysAgo: '{n}일 전' },
    productStatus: {
      used: '중고거래',
      rent: '렌트/임대',
      job: '구인구직',
      free: '무료나눔',
      electronics: '전자기기',
      furniture: '가구/인테리어',
      fashion: '의류/잡화',
      food: '식품/음료',
      sports: '스포츠/레저',
      books: '도서/문구',
      vehicle: '차량/오토바이',
      kids: '유아/아동',
      beauty: '뷰티/미용',
      household: '생활용품',
      pets: '반려동물',
      tickets: '티켓/교환권',
      etc: '기타',
      car: '중고차',
      real_estate: '부동산',
      property: '부동산',
    },
    productSold: '거래완료',
    tradeComplete: '거래 완료',
    tradeConfirmTitle: '거래를 완료할까요?',
    tradeConfirmBody: '완료 후에는 상품이 판매 완료로 표시되고, 상대방에게 후기를 남길 수 있어요.',
    tradeConfirmOk: '네, 완료할게요',
    tradeDone: '거래가 완료되었어요.',
    tradeNeedDb: '서버에 연결된 상품에서만 거래 완료할 수 있어요.',
    day: { today: '오늘', yesterday: '어제' },
    room: {
      more: '더보기',
      productFallback: '상품',
      inputPlaceholder: '메시지 입력',
      send: '전송',
      addImage: '사진',
      addEmoji: '이모티콘',
      sending: '전송 중…',
      loadError: '채팅방을 열 수 없어요.',
      demoNotice: '체험용 채팅입니다. 서버에 저장되지 않아요.',
      loading: '불러오는 중…',
      sendFailed: '전송에 실패했어요. 다시 시도해 주세요.',
      showAdTypesAction: '광고 종류 보기',
      noOriginalMessage: '원본 메시지 없음',
      photoLabel: '사진',
      adPreviewLabel: '광고 미리보기',
      messageFallback: '메시지',
      meLabel: '나',
      otherLabel: '상대',
      deletedMessageReply: '삭제된 메시지에게 답장',
      replyTo: '{author}에게 답장',
      needProfile: '채팅을 쓰려면 로그인을 완료해 주세요.',
      imageOnly: '[사진]',
      back: '뒤로',
      notifications: '알림',
      emptyConversation: '대화를 시작해 보세요.',
      loadFailed: '채팅을 불러오지 못했습니다.',
      propertyFallback: '매물',
      systemMessage: '시스템 메시지',
      fastResponse: '응답빠름',
      bookingLabel: '예약',
      guestsCount: '{n}명',
      quotationTitle: '견적서',
      totalLabel: '합계',
      acceptQuote: '견적 수락',
      acceptQuoteSoon: '견적 수락은 곧 연결됩니다.',
      savedMessagesTitle: '나에게 보낸 메시지',
      productLoadFailed: '상품을 불러오지 못했어요. 상품 보기에서 확인해 주세요.',
      productNotPublished: '아직 게시되지 않은 상품이에요.',
      bookingInfoLoadFailed: '예약 정보를 불러오지 못했어요',
      bookingRequestAccepted: '예약 요청이 접수됐어요. 업체 확인을 기다려 주세요.',
      bookingSummaryAdults: '[예약 요청] {title} · {date} · 성인 {adults}명',
      bookingSummaryChildrenSuffix: ', 아동 {children}명',
      bookingRequestMessageSent: '예약 요청 메시지를 보냈어요. 업체가 채팅으로 확인해 드려요.',
      bookingRequestFailed: '예약 요청에 실패했어요',
      bookingConfirmedToast: '예약을 확정했어요.',
      bookingConfirmFailed: '확정에 실패했어요',
      bookingRejectedToast: '예약을 거절했어요.',
      bookingRejectFailed: '거절에 실패했어요',
      quotedMessageDeleted: '삭제된 메시지입니다.',
      imageLinkCopied: '이미지 링크를 복사했어요.',
      shareFailed: '공유에 실패했어요.',
      roomListLoadFailed: '채팅방 목록을 불러오지 못했어요.',
      noMessageToForward: '전달할 메시지가 없습니다.',
      forwardedToRoom: '다른 채팅방으로 전달했어요.',
      forwardFailed: '전달에 실패했어요.',
      messageCopied: '메시지를 복사했어요.',
      copyFailed: '복사에 실패했어요.',
      shareUnsupportedType: '공유할 수 없는 메시지 유형입니다.',
      shareTextCopied: '공유용 텍스트를 복사했어요.',
      deleteMessageConfirm: '이 메시지를 삭제할까요?',
      messageDeletedSuccessToast: '메시지를 삭제했어요.',
      deleteFailed: '삭제에 실패했어요.',
      reportReasonPrompt: '신고 사유를 입력하세요 (fraud/spam/abuse/other)',
      reportNotePrompt: '신고 내용을 간단히 입력하세요.',
      reportSubmitted: '신고가 접수되었습니다.',
      reportDuplicate: '이미 신고한 메시지입니다.',
      reportFailed: '신고에 실패했어요.',
      reactionListLoadFailed: '반응 목록을 불러오지 못했어요.',
      reactionFailed: '리액션에 실패했어요.',
      viewReactionUsersAria: '반응한 사용자 보기',
      forwardAction: '전달',
      forwardModalTitle: '채팅방으로 전달',
      noForwardableRooms: '전달 가능한 채팅방이 없습니다.',
      forwardToSelfFailed: '나에게 전달에 실패했어요.',
      sendToMeLabel: '나에게',
      reactionsTitle: '{emoji} 반응',
      noReactionUsers: '반응한 사용자가 없습니다.',
      booking: {
        requested: '예약 요청',
        confirmed: '예약 확정',
        rejected: '예약 거절',
        statusRequest: '요청',
        statusConfirmed: '확정',
        statusRejected: '거절',
        comboComponentsLabel: '포함 서비스',
      },
    },
    translate: '번역',
    translating: '번역 중…',
    translateFailed: '번역할 수 없습니다',
    groupChat: '모임 채팅',
    emojiSearchPlaceholder: '이모지 검색',
    emojiCategory: {
      recent: '최근 사용',
      smileys: '스마일리',
      animals: '동물·자연',
      food: '음식',
      travel: '여행·장소',
      activities: '활동',
      objects: '사물',
      symbols: '기호',
      flags: '깃발',
    },
  },
  friends: {
    hubTitle: '친구',
    findTitle: '친구 찾기',
    findAdd: '+ 친구',
    addFriend: '친구 추가',
    hubMenu: '친구 메뉴',
    suggestedTitle: '추천',
    suggestedHint: '우선순위: 같은 도시 > 관심사 겹침 > 맞팔 친구 > 최근 활동',
    suggestedReason: {
      same_city: '같은 도시',
      shared_interest: '관심사가 비슷함',
      mutual_friend: '맞팔 친구가 겹침',
      recent_activity: '최근 활동 사용자',
    },
    suggestedEmpty: '추천할 사용자가 아직 없어요',
    suggestedLoadMore: '더 보기',
    dismissSuggestion: '관심없음',
    shareProfile: '프로필 공유',
    shareAction: '프로필 공유',
    copyLink: '링크 복사',
    downloadQr: '다운로드',
    shareCopied: '프로필 링크를 복사했어요',
    menuAccountSettings: '프로필 편집',
    hubStatsAria: '내 활동 통계',
    statsExplainer: '친구: 서로 승인해 연결된 사이 · 팔로워: 나를 구독하는 사람 · 팔로잉: 내가 구독하는 사람',
    hubStats: {
      posts: '게시글',
      friends: '친구',
      followers: '팔로워',
      following: '팔로잉',
    },
    contentTabStories: '밍고스토리',
    contentTabReplies: '답글',
    contentTabsAria: '게시글·답글·밍고스토리 탭',
    businessOwnerBadge: '{name} 업체 사장님',
    gridEmptyStories: '등록된 밍고스토리가 없어요',
    gridEmptyReplies: '남긴 답글이 없어요',
    replyOnOwnPost: '내 글',
    mingosSection: '찐친',
    regularFriendsSection: '일반 친구',
    friendsViewHint: '찐친과 일반 친구로 나뉘어 보여요',
    emptyMingos: '아직 찐친이 없어요 · 친구 메뉴(⋮)에서 지정할 수 있어요',
    emptyRegularFriends: '일반 친구가 없어요',
    mingoBadge: '찐친',
    findClose: '닫기',
    tabs: {
      friends: '친구',
      pending: '대기',
      find: '찾기',
    },
    pendingReceived: '받은 요청',
    pendingSent: '보낸 요청',
    followers: '팔로워',
    following: '팔로잉',
    mutualFollow: '맞팔',
    followListEmpty: '아직 없어요',
    emptyFriends: '아직 친구가 없어요',
    emptyPending: '대기 중인 요청이 없어요',
    loading: '불러오는 중…',
    loadError: '목록을 불러오지 못했어요. 잠시 후 다시 시도해 주세요.',
    searchPlaceholder: '닉네임 검색 (2자 이상)',
    searching: '검색 중…',
    emptyQuery: '닉네임을 입력해 보세요',
    noResults: '검색 결과가 없어요',
    searchError: '검색에 실패했어요. 잠시 후 다시 시도해 주세요.',
    kakaoFindBtn: '카카오 친구 중 밍고 사용자 찾기',
    kakaoFindLoading: '찾는 중…',
    kakaoFindEmpty: '카카오 친구 중 밍고를 쓰는 분이 아직 없어요.',
    kakaoFindConsentRequired: '카카오 친구목록 동의가 아직 승인되지 않았어요. 승인되면 자동으로 사용할 수 있어요.',
    kakaoFindNoToken: '카카오로 다시 로그인한 후 이용해 주세요.',
    kakaoFindError: '카카오 친구 목록을 불러오지 못했어요. 잠시 후 다시 시도해 주세요.',
    statusFriend: '친구',
    statusRequest: '친구 신청',
    statusRequested: '요청됨',
    statusAccept: '수락하기',
    statusDecline: '거절',
    statusCancel: '취소',
    requestSent: '친구 요청을 보냈어요',
    requestAccepted: '친구가 되었어요',
    requestAcceptedHint: '이제 채팅 탭에서 대화할 수 있어요',
    requestDeclined: '요청을 거절했어요',
    requestCancelled: '요청을 취소했어요',
    autoFriendMade: '맞팔로 친구가 됐어요!',
    settings: {
      title: '친구 설정',
      sectionFriends: '친구',
      autoFriendOnMutualFollow: '맞팔 시 자동으로 친구 되기',
      autoFriendOnMutualFollowDesc:
        '켜면 서로 팔로우할 때 친구로 추가돼요. 끄면 맞팔만 되고 친구는 직접 맺어야 해요. 이미 있는 관계에는 소급 적용되지 않아요.',
    },
    menu: {
      chat: '채팅하기',
      hide: '숨기기',
      block: '차단하기',
      remove: '친구 삭제',
      hidden: '친구를 숨겼어요',
      blockConfirm: '{name} 님을 차단할까요? 채팅과 게시물이 보이지 않게 돼요.',
      blockedDone: '친구를 차단했어요',
      removeConfirm: '{name} 님을 친구에서 삭제할까요?',
      removedDone: '친구를 삭제했어요',
      unhide: '숨김 해제',
      unhideDone: '숨김을 해제했어요',
      manageHidden: '숨긴 친구',
      manageBlocked: '차단한 친구',
      friendSettings: '친구 설정',
      searchByHandle: '닉네임/핸들로 검색',
      backToFriends: '친구 목록',
      hiddenTitle: '숨긴 친구',
      hiddenEmpty: '숨긴 친구가 없어요',
      setMingo: '찐친으로 지정',
      unsetMingo: '찐친 해제',
      setMingoDone: '찐친으로 지정했어요',
      unsetMingoDone: '찐친 지정을 해제했어요',
    },
    errors: {
      self: '자기 자신에게는 보낼 수 없어요',
      blocked: '요청할 수 없는 사용자예요',
      notFound: '사용자를 찾을 수 없어요',
    },
  },
  story: {
    visibility: {
      label: '공개 범위',
      public: '전체공개',
      friends: '친구공개',
      mingoFriends: '찐친공개',
      private: '나만보기',
    },
    revenueTitle: '스토리 수익',
    totalRevenue: '총 수익 포인트',
    revenueDesc: '조회수·제휴·유료열람으로 포인트를 받아요',
    revenueStructure: '수익 구조',
    rev100Views: '조회수 100회마다',
    rev1000Views: '조회수 1,000회 달성',
    revAffiliate: '업체 제휴 클릭',
    revUnlock: '유료 콘텐츠 열람',
    revenueHistory: '수익 내역',
    revenueEmpty: '아직 수익 내역이 없어요\n쇼츠를 올려 수익을 시작하세요!',
    revenueMenuLabel: '스토리 수익 관리',
    revenueLoading: '로딩 중…',
  },
  productDetail: {
    back: '뒤로',
    more: '더보기',
    mannerTemp: '매너온도',
    chat: '채팅하기',
    chatNoSeller: '회원이 등록한 상품에서만 채팅할 수 있어요.',
    chatOwnProduct: '내가 올린 상품이에요.',
    chatOpenFailed: '채팅을 시작할 수 없어요. 연결을 확인해 주세요.',
    reportScam: '사기 신고',
    reportNeedDb: '서버에 등록된 상품만 신고할 수 있어요.',
    like: '좋아요',
    likeOn: '좋아요 취소',
    likeOff: '좋아요',
    sliderLabel: '상품 이미지',
    commissionTrade: '안전거래 수수료 {rate}% · 약 {fee} {currency} 별도',
    commissionJob: '안전거래 수수료 건당 {fee} {currency} 별도',
    commissionWaived: '수수료 면제 조건에 해당할 수 있어요.',
    safePaymentSoon: '안전결제 준비중',
    views: '조회 {count}',
    likeNeedDb: '이 상품에서는 좋아요를 저장할 수 없어요.',
    favorite: '찜하기',
    favoriteOn: '찜 해제',
    favoriteCount: '찜 {count}',
    similarProducts: '비슷한 상품',
  },
  paymentReady: {
    title: '안전거래 준비중입니다',
    subtitle: '현재는 직접 거래로 진행해주세요',
    note: '곧 앱 내 안전거래·에스크로를 제공할 예정이에요.',
    contact: '연락하기',
  },
  postDetail: {
    back: '뒤로',
    more: '더보기',
    report: '신고하기',
    reportNeedDb: '서버에 등록된 글만 신고할 수 있어요.',
    comments: '댓글',
    commentPlaceholder: '댓글을 입력하세요',
    post: '등록',
    likes: '좋아요',
    likeOn: '좋아요 취소',
    likeOff: '좋아요',
    views: '조회 {count}',
    commentEmpty: '댓글 내용을 입력해 주세요.',
    commentsEmpty: '아직 댓글이 없어요. 첫 댓글을 남겨보세요.',
    commentNeedDb: '서버에 등록된 글에만 댓글을 남길 수 있어요.',
    commentSent: '댓글이 등록됐습니다',
    translate: '번역',
    showOriginal: '원문 보기',
    viewMyLanguage: '번역으로 보기',
    autoTranslatedBadge: '내 언어로 자동 번역됨',
    translateFailed: '번역할 수 없습니다',
    translateBusy: '번역 중…',
  },
  event: {
    subtype: {
      event: '행사·장터',
      visarun: '비자런',
      flash: '번개',
      travel: '같이가요',
    },
    field: {
      origin: '출발지',
      destination: '도착지',
      vehicle: '차량 종류',
      prep: '준비물',
      lodging: '숙소 정보',
      lodgingPh: '예: 호텔명, 에어비앤비 링크',
      meal: '식사',
    },
    vehicle: {
      bus: '버스',
      car: '승용차',
      motorbike: '오토바이',
      van: '밴',
      taxi_share: '택시/카풀',
      other: '기타',
      otherPh: '차량 종류 직접 입력',
    },
    meal: {
      included: '포함',
      excluded: '불포함',
      hint: '식사 포함 시 본문에 상세를 적어주세요.',
    },
    prep: {
      passport: '여권',
      visaFee: '비자 비용',
      photo: '증명사진',
      cash: '현금(USD)',
      add: '직접 추가',
      addPh: '준비물 직접 입력',
    },
  },
  write: {
    tradeTitle: '물건 등록',
    done: '완료',
    close: '닫기',
    communityTitle: '커뮤니티 글쓰기',
    submit: '등록',
    photos: '사진',
    title: '제목',
    category: '카테고리',
    price: '가격',
    freeShare: '무료나눔',
    body: '내용',
    bodyPlaceholder: '동네 이웃과 거래해보세요',
    regionLine: '거래 지역',
    regionArea: '지역',
    communityBodyPh: '동네 이웃과 정보를 나눠보세요',
    optionalPhoto: '사진 (선택)',
    regionUnset: '지역 미선택',
    regionDetecting: '위치 확인 중…',
    regionTapToSelect: '탭하여 지역 선택',
    regionPickTitle: '거래 지역 선택',
    useGpsRegion: '현재 위치 사용',
    needRegion: '거래 지역을 선택하거나 GPS를 허용해 주세요.',
    regionAll: '전체',
    titlePlaceholder: '글 제목을 입력하세요',
    pricePlaceholder: '가격을 입력하세요',
    deletePhotoAria: '사진 삭제',
    saving: '등록 중…',
    saved: '저장했어요.',
    saveFailed: '저장에 실패했어요.',
    needTitle: '제목을 입력해 주세요.',
    needTitleBody: '제목과 내용을 입력해 주세요.',
    needSupabase: '서버 연결이 필요해요.',
    freeShareLabel: '나눔 · 무료',
    priceNegotiable: '가격 협의',
    currency: '화폐 단위',
    submitCta: '등록하기',
    needSession: '로그인 세션이 없습니다. 다시 로그인한 뒤 시도해 주세요.',
    needUserProfile: '회원 정보를 불러오지 못했습니다. 잠시 후 다시 시도하거나 로그인을 확인해 주세요.',
    needAuthorId: '글 등록을 위해 로그인된 계정과 회원 정보가 필요합니다.',
    errorRls: '저장 권한이 없습니다. 로그인 상태를 확인해 주세요.',
    errorFk: '회원 정보와 연결되지 않았습니다. 로그인 후 다시 시도해 주세요.',
    dbErrorDetail: '저장 오류: {detail}',
    justNow: '방금 전',
    imageOptimizing: '이미지 최적화 중...',
    event: {
      scheduleType: '일정 유형',
      always: '상설',
      oneday: '하루',
      period: '기간',
      recurring: '매주',
      startAt: '시작',
      endAt: '종료',
      date: '날짜',
      dateFormatHint: '연도-월-일',
      openHours: '운영 시간',
      defaultHours: '기본 운영 시간',
      openTime: '시작 시간',
      closeTime: '종료 시간',
      perDayHours: '요일마다 시간 다름',
      perDayHoursHint: '비워두면 기본 운영 시간을 따릅니다.',
      scheduleNote: '예외 메모',
      scheduleNotePh: '예: 토요일은 6:00~12:00',
      recurrence: '반복 요일',
      recurrencePh: '예: every_sat, 매주 토요일',
      weekday: {
        mon: '월',
        tue: '화',
        wed: '수',
        thu: '목',
        fri: '금',
        sat: '토',
        sun: '일',
      },
      needRecurrenceDays: '반복 요일을 하나 이상 선택해 주세요.',
      location: '장소',
      locationPh: '예: 한 시장 앞 광장',
      priceInfo: '가격 정보',
      priceInfoPh: '예: 무료, 50,000동~',
      externalUrl: '예매·링크',
      recruitCount: '모집 인원',
      recruitCountPh: '예: 4',
      deadline: '모집 마감일',
      needScheduleType: '일정 유형을 선택해 주세요.',
      needStartAt: '시작 일시를 입력해 주세요.',
      needEndAt: '종료 일시를 입력해 주세요.',
      needEndAfterStart: '종료 시간은 시작 시간보다 늦어야 해요.',
    },
  },
  tradeCats: {
    all: '전체',
    used: '중고거래',
    rent: '렌트',
    car: '중고차',
    job: '알바',
    real_estate: '부동산',
    free: '무료나눔',
  },
  productCategory: {
    all: '전체',
    electronics: '전자기기',
    furniture: '가구/인테리어',
    fashion: '의류/잡화',
    food: '식품/음료',
    sports: '스포츠/레저',
    books: '도서/문구',
    vehicle: '차량/오토바이',
    kids: '유아/아동',
    beauty: '뷰티/미용',
    household: '생활용품',
    pets: '반려동물',
    tickets: '티켓/교환권',
    job: '구인구직',
    rent: '임대/렌탈',
    etc: '기타',
  },
  countries: {
    KR: '한국',
    VN: '베트남',
    US: '미국',
    TH: '태국',
    JP: '일본',
    CN: '중국',
    TW: '대만',
    RU: '러시아',
    GB: '영국',
    PH: '필리핀',
    ID: '인도네시아',
    MY: '말레이시아',
    SG: '싱가포르',
    KH: '캄보디아',
    MM: '미얀마',
    AU: '호주',
    CA: '캐나다',
    FR: '프랑스',
    DE: '독일',
    NL: '네덜란드',
  },
  contentFilter: {
    blocked: '부적절한 내용이 포함되어 있습니다.',
    sanitized: '일부 내용이 수정되었습니다.',
  },
  spam: {
    rateLimited: '잠시 후 다시 시도해주세요.',
    duplicate: '같은 내용을 반복해서 올릴 수 없어요.',
    linkOnlyWarn: '링크만 있는 글은 주의가 필요해요. 내용을 보강해 주세요.',
    phoneWarn: '연락처가 과다하게 포함되어 있어요. 스팸으로 간주될 수 있습니다.',
  },
  imageReport: {
    title: '이미지 신고',
    types: {
      adult: '성인 콘텐츠',
      violence: '폭력',
      spam: '스팸',
      other: '기타',
    },
    received: '신고가 접수되었습니다. (누적 {n}회)',
    hidden: '신고가 누적되어 이미지가 숨겨졌습니다. 어드민 검토 후 복구될 수 있어요.',
    hiddenLabel: '검토 중인 이미지',
  },
  block: {
    author: '작성자 차단',
    listTitle: '차단한 계정',
    empty: '차단한 계정이 없어요.',
    unblock: '차단 해제',
    unblocked: '차단을 해제했어요.',
    done: '차단했어요.',
    failed: '처리할 수 없어요.',
    needAuthor: '차단할 작성자 정보가 없어요.',
    chatBlocked: '차단 상태이거나 상대와 채팅할 수 없어요.',
  },
  realEstate: {
    title: '부동산·임대',
    registerCta: '매물 등록',
    filters: '필터',
    filterRegion: '지역',
    filterRegionAll: '전체',
    regionDanang: '다낭',
    regionHcmc: '호치민',
    regionOther: '기타',
    priceMin: '최소 가격(숫자)',
    priceMax: '최대 가격(숫자)',
    roomSize: '방 크기',
    roomAll: '전체',
    room: { studio: '원룸', '1ldk': '1LDK', '2ldk': '2LDK 이상' },
    furnished: '가구 포함',
    furnishedOnly: '가구 포함만',
    furnYes: '가구 O',
    furnNo: '가구 X',
    petOk: '반려동물 가능',
    petOnly: '반려 가능만',
    petYes: '반려 O',
    petNo: '반려 X',
    fieldKind: '매물 종류',
    fieldPrice: '가격',
    fieldLocation: '위치',
    fieldDesc: '상세 설명',
    fieldDescEn: '영문 설명 (번역용)',
    fieldNick: '닉네임',
    fieldFlag: '국기(이모지)',
    photos: '사진 (최대 10장)',
    saved: '등록했어요.',
    empty: '조건에 맞는 매물이 없어요.',
    needPriceLocation: '가격과 위치를 입력해 주세요.',
    needNickname: '닉네임을 입력해 주세요.',
    justNow: '방금',
    hoursAgo: '{n}시간 전',
    daysAgo: '{n}일 전',
    tab: {
      all: '전체',
      monthly: '월세',
      jeonse: '전세',
      short: '단기임대',
      sale: '매매',
    },
    reTabAll: '전체',
    reTabLong: '장기거주',
    reTabShort: '단기숙박',
    reTabSale: '매매',
    reSubLongMonthly: '월세',
    reSubLongJeonse: '전세',
    reSubLongColiving: '코리빙',
    reSubShortHotel: '호텔',
    reSubShortGuest: '게스트하우스',
    reSubShortAirbnb: '에어비앤비식',
    reSubShortServiced: '서비스드아파트',
    reSubSaleApt: '아파트',
    reSubSaleVilla: '빌라',
    reSubSaleRetail: '상가',
    rePriceSale: '매매가',
    rePriceMonth: '월세',
    rePriceNight: '1박',
    rePerMonth: '월',
    regionHoian: '호이안',
    filterAmenities: '편의시설',
    filterPets: '반려동물',
    filterInstant: '즉시예약',
    verified: '인증됨',
    instantBook: '즉시예약',
    reviews: '리뷰',
    openWrite: '내 매물 등록 (집주인·세입자·업체)',
    tabListings: '매물',
    tabBrokers: '중개사',
    pageTabsAria: '부동산 탭',
    brokerHint: '지역 부동산 중개 업체 목록입니다. 카드를 누르면 업체 프로필로 이동합니다.',
    brokerCount: '{n}개 업체',
    brokerEmpty: '등록된 중개 업체가 없습니다',
    detailChat: '채팅으로 문의하기',
    detailCall: '전화하기',
    detailPhase2: '날짜 선택·예약 요청은 다음 단계에서 제공될 예정이에요.',
    noHostChat: '호스트 정보가 없어 채팅을 열 수 없어요. 전화로 문의해 주세요.',
    selfChat: '내가 등록한 매물이에요.',
    reviewsEmpty: '아직 리뷰가 없어요.',
    writeStep1: '유형',
    writeStep2: '카테고리',
    writeStep3: '기본 정보',
    writeStep4: '가격',
    writeStep5: '편의시설',
    writeStep6: '사진',
    writeStep7: '확인',
    writeNext: '다음',
    writeBack: '이전',
    writeSubmit: '등록하기',
    myListings: '내 매물',
    myListingsSub: '집주인·세입자·업체 매물',
    reservationRequestsTitle: '예약 요청',
    reservationsSoon: '예약 요청 목록은 준비 중이에요.',
    reviewsManageSoon: '리뷰 관리는 준비 중이에요.',
    translateSoon: '번역(영어)은 추후 자동 연동될 예정이에요.',
    catlong_monthly: '월세',
    catlong_jeonse: '전세',
    catlong_coliving: '코리빙',
    catshort_hotel: '호텔',
    catshort_guesthouse: '게스트하우스',
    catshort_airbnb: '에어비앤비',
    catshort_serviced: '서비스드',
    catsale_apartment: '아파트',
    catsale_villa: '빌라',
    catsale_retail: '상가',
    reChipAll: '전체',
    reChipMonthly: '월세',
    reChipJeonse: '전세',
    reChipSale: '매매',
    reChipShort: '단기임대',
    reChipInstant: '즉시입주',
    reChipPets: '반려동물',
    reChipTransfer: '승계',
    reChipRoommate: '룸메',
    reOwnerFilter: '등록 유형',
    rePropertyTypeFilter: '매물 종류',
    rePropertyTypeHint: '아파트·단독·상가·토지 등 원하는 종류를 선택하세요. (중복 선택 가능)',
    rePropertyTypeEmpty: '전체 매물 종류',
    reTransactionFilter: '거래 유형',
    reTransactionHint: '먼저 임대 또는 매매를 선택하세요.',
    reTransAll: '전체',
    reTransRent: '임대',
    reTransSale: '매매',
    reDealDetailFilter: '세부 거래',
    reDealDetailHint: '월세·전세·단기 등 원하는 임대 방식을 고르세요.',
    reDealDetailHintSale: '매매 매물만 보려면 매매를 선택하세요.',
    reFilterStepPrefix: '{n}단계',
    reRoomSpecFilter: '방·화장실',
    reRoomSpecHint: '최소 방 수·화장실 수를 선택하세요. (예: 2방+ = 방 2개 이상)',
    reBedroomFilter: '방',
    reBathroomFilter: '화장실',
    reBedroomMin: '{n}방+',
    reBathroomMin: '{n}+',
    reRoomSpecEmpty: '전체',
    reRoomSpecSelected: '선택한 조건이 적용됩니다.',
    reDepositMonthsAmount: '보증금 {months}개월 · {amount}',
    reFilterScopeTitle: '지역 기준 안내',
    reFilterScopeGps:
      'GPS 위치 기준 {radius}km 이내와 앱에서 선택한 지역({country} · {city}) 매물을 함께 보여줍니다. 상단 위치 설정을 바꾸면 목록이 달라질 수 있어요.',
    reFilterScopeManual:
      '앱 상단에서 선택한 국가·도시({country} · {city}) 기준으로 매물을 보여줍니다. GPS를 켜면 거리 기준 검색도 함께 적용됩니다.',
    reDistrictFilter: '구(행정구역)',
    reDistrictHint: '원하는 구를 여러 개 선택할 수 있어요. 미선택 시 해당 도시 전체입니다.',
    reDistrictAll: '전체 구',
    reDistrictEmpty: '이 도시의 구 목록을 불러오지 못했습니다. 도시를 바꾸거나 잠시 후 다시 시도해 주세요.',
    reOwnerAll: '전체',
    reOwnerIndividual: '개인',
    reOwnerBusiness: '업체',
    reOwnerTenant: '세입자',
    reKoreanAmenityFilter: '편의 옵션',
    reKoreanAmenityHint: '정수기·비데·주방 등 원하는 편의시설을 선택하세요.',
    reEmptyFirst: '아직 등록된 매물이 없습니다. 첫 매물을 등록해 보세요!',
    reEmptyFiltered: '선택한 조건에 맞는 매물이 없습니다.',
    reEmptyCta: '매물 등록하기',
    reAvailabilitySlot: '확인 요청 {n}회',
    reAvailabilityPlaceholder: '아직 있나요? (준비 중)',
    reListedToday: '오늘',
    reListedDaysAgo: '{n}일 전',
    reListedMonthsAgo: '{n}개월 전',
    reListedYearsAgo: '{n}년 전',
    reCardRating: '★{rating} ({n})',
    rePriceFilterBtn: '가격',
    rePriceSheetTitle: '가격 범위',
    rePriceApply: '적용',
    rePriceClose: '닫기',
    reLegalDisclaimer:
      '본 서비스는 정보 공유 목적이며, 공인 중개가 아닙니다. 계약 전 반드시 전문가 상담을 받으세요.',
    reFilterReset: '초기화',
    reFilterApplyResults: '적용 {n}건',
    reDisclaimerToggle: 'ⓘ 안내',
    reBeachMin: '해변 {n}분',
    reFloorSuffix: '층',
    reFavorite: '찜하기',
    reFavoriteOn: '찜함',
    reCardRailAria: '등록자·등록일·상담 언어',
    reCardBed: '방{n}',
    reCardBath: '화{n}',
    reCardLiving: '거실{n}',
    reCardVeranda: '베란다{n}',
    reChatInquiry: '채팅문의',
    rePhoneCall: '전화',
    reSectionLocation: '위치·거리',
    reSectionOptions: '옵션',
    reSectionHost: '등록자',
    reSectionDescription: '상세 설명',
    registerOwnerHint: '집주인·세입자(승계·양도) 등록은 아래 버튼 → 1단계에서 유형을 선택하세요.',
    reSectionSurroundings: '주변 환경',
    reMaintIncludedShort: '관리비 포함',
    reActivityBadge: '활동지수',
    reConsultHours: '상담 시간',
    reShare: '공유',
    reMinPrice: '최소',
    reMaxPrice: '최대',
    needSectionTitle: '원하는 조건 선택',
    needSectionHint: '아래 항목을 선택해두면 필요한 매물을 더 빠르게 찾기 쉬워요.',
    needTag_nearStation: '역/주요도로 가까움',
    needTag_petFriendly: '반려동물 가능',
    needTag_lowDeposit: '보증금 낮음',
    needTag_furnished: '가구 포함',
    needTag_shortMoveIn: '즉시 입주 가능',
    needTag_koreanSupport: '한국어 상담 가능',
    needSelected: '{n}개 조건 선택됨',
    needSelectedEmpty: '아직 선택한 조건이 없어요.',
    distanceUnitMin: '분',
    register: {
      typeMonthly: '월세',
      typeDeposit: '전세',
      typeSale: '매매',
      typeCommercial: '상가',
      step1: '매물 유형',
      step2: '기본정보',
      step3: '위치',
      step4: '건물정보',
      step5: '가격',
      step6: '편의시설',
      step7: '입주조건',
      step8: '사진',
      step9: '최종확인',
      stepBuildingInfo: '건물정보',
      stepPricing: '가격',
      stepAmenities: '편의시설',
      stepMoveIn: '입주조건',
      deposit: '보증금',
      monthlyRent: '월세',
      maintenanceFee: '관리비',
      isAgent: '공인중개사',
    },
  },
  realEstateWrite: {
    title: '매물 등록',
    step: '단계',
    next: '다음',
    prev: '이전',
    submit: '등록하기',
    preview: '미리보기',
    typeApartment: '아파트',
    typeVilla: '빌라',
    typeTownhouse: '연립주택',
    typeHouse: '단독주택',
    typeBuilding: '건물',
    typeCommercial: '상가/오피스',
    typeLand: '토지',
    typeHotel: '호텔/리조트',
    transMonthlyNoDeposit: '월세 (보증금 없음)',
    transMonthlyDeposit: '월세 (보증금 있음)',
    transSale: '매매',
    transShort: '단기임대',
    transLong: '장기임대',
    success: '매물이 등록되었습니다!',
    updateSuccess: '매물이 수정되었습니다!',
    editTitle: '매물 수정',
    saveEdit: '저장하기',
    country: '국가',
    city: '도시',
    selectCity: '도시를 선택하세요',
    district: '구(행정구역)',
    selectDistrict: '구를 선택하세요',
    districtHint: '검색·필터에 사용됩니다. 모르면 비워두고 상세 주소만 입력해도 됩니다.',
    countryVn: '베트남',
    countryKr: '한국',
    countryUs: '미국',
    addressDetail: '상세 주소',
    landmarkDist: '주요 랜드마크까지 (분)',
    distanceBeach: '해변까지',
    distanceAirport: '공항까지',
    distanceCenter: '시내까지',
    price: '가격',
    currency: '통화',
    deposit: '보증금',
    depositMonths: '보증금 개월수',
    depositHint: '개월 수만 입력하면 월세 기준으로 보증금 금액이 자동 계산됩니다. 금액을 직접 입력해도 됩니다.',
    depositMonth1: '1개월',
    depositMonth2: '2개월',
    depositMonth3: '3개월',
    depositMonth6: '6개월',
    depositMonthNegotiate: '협의',
    refundPolicy: '환불 조건',
    refundFull: '전액 환불',
    refundPartial: '부분 환불',
    refundNone: '환불 없음',
    maintenanceIncluded: '관리비 포함',
    maintenanceFee: '관리비 (별도)',
    negotiable: '협상 가능',
    availableImmediately: '즉시 입주 가능',
    moveInDate: '입주 가능일',
    areaSqm: '전용면적 (㎡)',
    bedrooms: '방',
    bathrooms: '화장실',
    livingRoom: '거실',
    balconyTerrace: '발코니/테라스',
    balconySize: '발코니/테라스 크기',
    balconySizePlaceholder: '예: 4㎡ · 선택 입력',
    optionYes: '있음',
    optionNo: '없음',
    floor: '해당 층',
    totalFloors: '전체 층수',
    direction: '방향',
    dir_south: '남향',
    dir_east: '동향',
    dir_west: '서향',
    dir_north: '북향',
    dir_se: '남동향',
    dir_sw: '남서향',
    builtYear: '건축연도',
    petsAllowed: '반려동물 가능',
    smokingAllowed: '흡연 가능',
    basicAmenities: '기본 옵션',
    buildingFacilities: '건물 시설',
    amenityAc: '에어컨',
    amenityFridge: '냉장고',
    amenityWasher: '세탁기',
    amenityBed: '침대',
    amenitySofa: '소파',
    amenityTv: 'TV',
    amenityWifi: '인터넷/WiFi',
    amenityMicrowave: '전자레인지',
    amenityDishwasher: '식기세척기',
    facPool: '수영장',
    facGym: '헬스장',
    facElevator: '엘리베이터',
    facSecurity: '경비/보안',
    facCctv: 'CCTV',
    facParking: '주차장',
    facConvenience: '편의점',
    facCafe: '카페',
    photoHint: '거실, 침실, 화장실, 주방, 뷰 사진을 올리면 더 많은 관심을 받아요!',
    primaryPhoto: '대표 사진',
    tapToUpload: '탭하여 업로드',
    morePhotos: '추가 사진 (최대 20장)',
    addPhotos: '사진 추가',
    remove: '삭제',
    ownerType: '등록 유형',
    owner_individual: '개인 임대인',
    owner_agency: '부동산 중개업체',
    owner_owner: '직접 소유자',
    phone: '전화번호',
    kakao: '카카오톡 ID',
    telegram: '텔레그램',
    consultStart: '상담 시작',
    consultEnd: '상담 종료',
    languages: '지원 언어',
    langKo: '한국어',
    langEn: '영어',
    langVi: '베트남어',
    langRu: '러시아어',
    langJa: '일본어',
    listingTitle: '매물 제목',
    listingDesc: '상세 설명',
    surroundings: '주변 환경',
    notes: '특이사항',
    exposure: '노출 등급',
    exposureFree: '무료 (기본 노출)',
    exposurePremium: '프리미엄 $10 (상위 노출)',
    exposureFeatured: '피처드 $30 (상단 고정)',
    needFields: '필수 항목을 모두 입력해 주세요.',
    spineStep1: '누가 · 거래 종류',
    spineStep2: '매물 정보 · 옵션',
    spineStep3: '거래 조건',
    spineStep4: '확인 · 등록',
    spineWho: '등록 주체',
    spineDeal: '거래 종류',
    spineOwnerIndividual: '집주인',
    spineOwnerBusiness: '업체',
    spineOwnerTenant: '세입자 (승계·양도)',
    veranda: '베란다',
    editStep: '수정 {step}/{total} · {section}',
    businessContextLabel: '등록 업체',
    businessContextLoading: '업체 정보 불러오는 중…',
    selectBusiness: '소속 업체',
    selectBusinessPlaceholder: '업체를 선택하세요',
    reBusinessEmptyHint: '업체로 등록하려면 먼저 업체 프로필을 만들어 주세요.',
    reBusinessEmptyCta: '업체 등록하러 가기',
    dealMonthlyRent: '월세',
    dealJeonse: '전세',
    dealSale: '매매',
    dealShortTerm: '단기 임대',
    dealTransfer: '승계 · 양도',
    tenantDealAutoHint: '세입자 등록은 승계·양도 거래만 가능합니다.',
    dealRoommate: '룸메이트 · 셰어',
    deal_monthly_rent: '월세',
    deal_jeonse: '전세',
    deal_sale: '매매',
    deal_short_term: '단기',
    deal_transfer: '승계',
    deal_roommate: '룸메이트',
    transferKindTitle: '승계 유형',
    transferResidential: '거주 승계',
    transferCommercial: '상업 승계 (권리금)',
    transfer_residential: '거주',
    transfer_commercial: '상업',
    transferCommercialHint: '권리금·상업 승계는 properties 한 곳에만 저장됩니다. 부동산·사업양도 목록에 동일 매물이 노출됩니다 (다음 STEP).',
    spinePropertyType: '매물 유형',
    koreanAmenities: '한국형 · 공통 옵션',
    amenitiesSection: '옵션',
    consultLanguages: '상담 가능 언어',
    consultLang_ko: '한국어',
    consultLang_vi: '베트남어',
    consultLang_en: '영어',
    consultLang_ru: '러시아어',
    consultLang_zh: '중국어',
    consultLang_ja: '일본어',
    requiredHint: '* 필수 입력 항목',
    previewHint: '등록 후 목록에서 이렇게 보입니다.',
    invalidImage: 'JPG, PNG, GIF, WEBP 이미지만 업로드할 수 있어요.',
    photoLimit: '추가 사진은 최대 20장까지입니다.',
    mapLat: '위도 (선택)',
    mapLng: '경도 (선택)',
    monthlyRent: '월세',
    salePrice: '매매가',
    titleDeedStatus: '등기·권리 상태',
    titleDeedStatusPlaceholder: '예: 핑크북, 외국인 명의 가능',
    foreignerOwnershipOk: '외국인 명의 가능',
    jeonseAmount: '전세금',
    jeonseContractMonths: '계약 기간 (개월)',
    contractMonthsMin: '최소 계약 (개월)',
    shortPrice: '가격',
    priceUnit: '가격 단위',
    priceUnitMonth: '월',
    priceUnitWeek: '주',
    minPeriodDays: '최소 기간 (일)',
    maxPeriodDays: '최대 기간 (일)',
    remainingContractMonths: '남은 계약 (개월)',
    depositTransfer: '보증금 승계',
    includedItems: '포함 물품',
    includedItemsPlaceholder: '가구, 가전 (쉼표로 구분)',
    originalContractNotes: '원 계약 조건',
    keyMoney: '권리금',
    businessType: '업종',
    businessTypePlaceholder: '예: 카페, 식당, 마사지',
    monthlyRevenue: '월 매출 (선택)',
    operatingMonths: '영업 기간 (개월)',
    fixtures: '시설·인테리어',
    equipment: '집기·장비',
    totalRooms: '전체 방 수',
    shareCount: '모집 인원',
    genderPreference: '성별 선호',
    genderAny: '무관',
    genderFemale: '여성',
    genderMale: '남성',
    sharedSpaces: '공용 공간',
    sharedSpacesPlaceholder: '주방, 거실 (쉼표로 구분)',
    costPerPerson: '1인당 비용',
  },
  jobs: {
    title: '구인구직',
    tabHire: '구인',
    tabSeek: '구직',
    feeNotice: '매칭 성사 시 수수료가 부과될 수 있어요. 현재는 무료 서비스이며, 추후 수수료가 적용될 예정입니다.',
    disclaimerLegal: '이 서비스는 구인·구직 정보 공유만을 목적으로 하며, 밍고는 직업소개소나 유료 인력알선업체가 아닙니다.',
    writeFab: '글쓰기',
    writeHire: '구인 글쓰기',
    writeSeek: '구직 글쓰기',
    needTitle: '제목을 입력해 주세요.',
    saved: '등록했어요.',
    hubBoardBannerTitle: '구인구직 게시판',
    hubBoardBannerDesc: '구인·구직 글을 올리고 연락하세요',
    hubBoardBannerCta: '게시판 보기',
    fieldTitle: '제목 / 업체명 또는 닉네임',
    fieldCompanyName: '회사명 (선택)',
    fieldCompanyNamePlaceholder: '예: 비엣호아 마트',
    fieldSalary: '급여 / 희망급여',
    fieldRegion: '지역',
    regionPickTitle: '근무지역 선택',
    needRegion: '근무지역을 선택하거나 GPS를 허용해 주세요.',
    fieldMapPin: '근무지 위치 (선택)',
    mapPinHint: '지도에 위치를 찍으면 내 근처 찾는 구직자에게 더 잘 노출돼요',
    fieldOccupation: '직종',
    occupationPlaceholder: '직종 선택 (선택)',
    fieldPostLanguage: '공고 언어',
    postLanguageHint: '이 공고를 실제로 작성한 언어를 선택하세요. 구직자가 언어로 공고를 찾을 때 쓰여요.',
    occupation: {
      translation: '번역·통역',
      it: 'IT·개발',
      marketing: '마케팅',
      accounting: '회계·사무',
      food_service: '요식업·서비스직',
      education: '교육',
      construction: '건설·기술직',
      design: '디자인',
      other: '기타',
    },
    fieldEmploymentType: '고용형태',
    employmentTypePlaceholder: '고용형태 선택 (선택)',
    employmentType: {
      fulltime: '정규직',
      contract: '계약직',
      parttime: '파트타임',
      freelance: '프리랜서',
      intern: '인턴',
      daily: '일용직',
    },
    fieldCareerLevel: '경력',
    careerLevelPlaceholder: '경력 선택 (선택)',
    careerLevel: {
      any: '경력무관',
      entry: '신입',
      experienced: '경력직',
    },
    fieldSalaryType: '급여형태',
    salaryTypePlaceholder: '급여형태 선택 (선택)',
    salaryType: {
      hourly: '시급',
      daily: '일급',
      weekly: '주급',
      monthly: '월급',
      yearly: '연봉',
      negotiable: '협의',
    },
    fieldWorkDays: '근무요일',
    workDays: {
      mon: '월',
      tue: '화',
      wed: '수',
      thu: '목',
      fri: '금',
      sat: '토',
      sun: '일',
    },
    fieldWorkHours: '근무시간',
    workHoursPlaceholder: '예: 09:00-18:00, 협의',
    fieldWorkHoursPresets: '근무시간대 (맞춤 추천용)',
    fieldExpectedDuration: '예상 근무기간 (맞춤 추천용)',
    viewOnMapCta: '지도에서 크게 보기',
    safetyNoticeText:
      '채권추심 보조, 고액 알바 명목으로 체크카드나 계좌 비밀번호를 요구하면 보이스피싱 등 범죄에 연루될 수 있어요. 지원 전 아래에서 미리 확인해 보세요.',
    companyInfoTitle: '기업정보',
    companyVerifiedBadge: '인증업체',
    companyAddressLabel: '회사주소',
    companyRecentHireLabel: '채용 활동',
    companyRecentHireValue: '최근 1년간 채용공고 {count}건',
    fieldEducationLevel: '학력',
    educationLevelPlaceholder: '학력 선택 (선택 안 하면 학력무관)',
    educationLevel: {
      any: '학력무관',
      high_school: '고졸 이상',
      associate: '초대졸 이상',
      bachelor: '대졸 이상',
      master_or_above: '석사 이상',
    },
    fieldBenefits: '복리후생',
    benefitsPlaceholder: '쉼표(,)로 구분 (예: 4대보험, 연차, 인센티브제)',
    fieldPreferredQualifications: '우대사항',
    preferredQualificationsPlaceholder: '예: 유사업무 경험 우대, 인근 거주 우대',
    fieldSkillTags: '이런 스킬이 있으면 좋아요',
    skillTagsPlaceholder: '쉼표(,)로 구분 (예: 고객 상담, 전화 상담)',
    fieldHeadcount: '모집인원',
    headcountPlaceholder: '예: 1',
    fieldDeadline: '접수 마감일',
    deadlineHint: '비워두면 상시모집으로 표시돼요',
    deadlineNone: '상시모집',
    fieldExtra: '상세 설명',
    fieldContact: '연락처',
    aiAssist: {
      cta: 'AI로 제목·설명 자동완성',
      desc: '입력하신 직종·지역·급여 등을 바탕으로 AI가 제목과 상세 설명을 작성해드려요. 강조하고 싶은 점이 있으면 아래에 적어주세요.',
      hintPlaceholder: '예: 친절한 사장님, 초보 환영, 한국어 가능자 우대',
      generate: '생성하기',
      generating: '생성 중...',
      success: 'AI가 제목과 설명을 채워넣었어요. 확인 후 자유롭게 수정하세요.',
      noKey: 'AI 글쓰기 기능을 지금은 사용할 수 없어요.',
      fail: '생성에 실패했어요. 잠시 후 다시 시도해주세요.',
    },
    applyCta: '지원하기',
    alreadyApplied: '지원 완료',
    applyCoverLetterLabel: '지원 메시지 (선택)',
    applyCoverLetterPlaceholder: '간단한 소개나 지원 동기를 남겨보세요',
    applySubmit: '지원서 보내기',
    applyCancel: '취소',
    applySuccess: '지원이 완료됐어요.',
    applyFailed: '지원에 실패했어요. 다시 시도해주세요.',
    applyOwnPost: '내가 올린 공고예요.',
    viewApplicants: '지원자',
    applicantsEmpty: '아직 지원자가 없어요.',
    applicationStatus: {
      applied: '지원함',
      reviewed: '검토중',
      accepted: '합격',
      rejected: '불합격',
    },
    acceptCta: '합격 처리',
    rejectCta: '불합격 처리',
    reviewCta: '검토중으로 표시',
    contactApplicantCta: '채팅으로 연락하기',
    contactPosterCta: '채팅으로 문의하기',
    callCta: '전화하기',
    noPosterChat: '작성자 정보가 없어 채팅을 열 수 없어요.',
    chatBlocked: '차단된 상대와는 채팅할 수 없어요.',
    premiumSection: '프리미엄 옵션',
    premiumFree: '일반 등록: 무료',
    premiumPin: '상단 노출',
    premiumPinPrice: '$10/주',
    premiumUrgent: '급구 배지',
    premiumUrgentPrice: '$5',
    premiumResume: '이력서 열람권',
    premiumResumePrice: '$3',
    premiumComing: '준비중',
    badgeTop: '상단',
    badgeUrgent: '급구',
    fallbackHire: '구인',
    fallbackSeek: '구직',
    emptyList: '아직 등록된 구인구직이 없어요.',
    negotiable: '협의',
    workConditions: '근무 조건',
    recruitConditions: '모집 조건',
    workRegionLabel: '근무지역',
    applyMethodLabel: '지원 방법',
    postedAt: '등록일',
    myApplicationsTitle: '지원현황',
    myApplicationsEmpty: '아직 지원한 공고가 없어요.',
    talentDirectory: {
      title: '인재정보',
      subtitle: '지금 일할 준비가 된 구직자들을 만나보세요.',
      empty: '아직 공개된 인재 프로필이 없어요.',
      anonymous: '밍고 회원',
      saveCta: '저장',
      savedCta: '저장됨',
      unlockHint: '첫 연락 1회 크레딧 차감',
      unlockInsufficientCredit: '광고 크레딧이 부족해요.',
      unlockFailed: '연락처 열람 처리에 실패했어요. 잠시 후 다시 시도해 주세요.',
      badges: {
        all: '전체',
        realtime: '실시간활동',
        veteran: '베테랑',
        student: '대학생',
        freelancer: '프리랜서',
      },
    },
    scamSearch: {
      title: '취업피해검색',
      subtitle: '전화번호·이메일·회사명으로 채용사기 제보 이력을 검색해 보세요.',
      searchPlaceholder: '전화번호, 이메일, 회사명 검색 (3자 이상)',
      searchBtn: '검색하기',
      searching: '검색 중…',
      tooShort: '검색어를 3자 이상 입력해 주세요.',
      noResult: '검색 결과가 없어요. 안전을 확인했다면 다행이에요.',
      report: {
        cta: '채용사기 피해 제보하기',
        formTitle: '피해 제보',
        phone: '상대방 전화번호',
        email: '상대방 이메일',
        company: '회사명',
        bankAccount: '입금 계좌',
        amountLost: '피해 금액 (선택)',
        description: '피해 내용',
        moderationNotice: '제보 내용은 운영진 검토 후 검색 결과에 공개됩니다.',
        saving: '등록 중…',
        submit: '제보하기',
        done: '제보가 접수되었습니다. 검토 후 공개됩니다.',
        error: {
          needDescription: '피해 내용을 입력해 주세요.',
          needContact: '전화번호/이메일/회사명/계좌 중 하나 이상 입력해 주세요.',
        },
      },
    },
    resume: {
      title: '이력서관리',
      subtitle: '이력서를 작성해두면 지원할 때 자동으로 함께 제출돼요.',
      photo: '증명사진',
      photoUpload: '사진 업로드',
      photoUploading: '업로드 중…',
      photoRemove: '삭제',
      photoTooLarge: '이미지 용량이 너무 커요.',
      headline: '한줄 소개',
      headlinePlaceholder: '예: 성실한 카페 알바 경력 2년',
      summary: '자기소개',
      summaryPlaceholder: '나를 소개하는 글을 자유롭게 적어주세요.',
      experience: '경력',
      experiencePlaceholder: '예: OO카페 홀서빙 (2023.01~2023.06)',
      education: '학력',
      educationPlaceholder: '예: OO대학교 경영학과 졸업',
      languages: '구사 언어',
      languagesPlaceholder: '예: 한국어(모국어), 영어(비즈니스)',
      addLine: '추가',
      skills: '보유 스킬',
      skillsPlaceholder: '쉼표(,)로 구분해서 입력 (예: POS, 재고관리, 운전면허)',
      desiredSalary: '희망 급여',
      desiredRegion: '희망 근무지역',
      desiredJobType: '희망 고용형태',
      desiredConditions: '희망 근무조건',
      nationality: '국적',
      publicConsent: '이력서를 인재정보에 공개하기',
      save: '저장하기',
      saving: '저장 중…',
      saved: '이력서를 저장했어요.',
      untitled: '이력서',
      completenessTitle: '이력서 완성도',
      expEmpty: '등록된 경력이 없어요.',
      expCompanyPh: '회사명',
      expRolePh: '직책/역할 (예: 홀서빙, 매니저)',
      expCurrent: '재직중',
      expDescriptionPh: '어떤 일을 담당했는지 간단히 적어주세요.',
      expAdd: '경력 추가',
      eduEmpty: '등록된 학력이 없어요.',
      eduSchoolPh: '학교명',
      eduDegreePh: '학위 선택',
      eduFieldPh: '전공',
      eduAdd: '학력 추가',
      degree: {
        high_school: '고졸',
        associate: '전문학사',
        bachelor: '학사',
        master: '석사',
        doctorate: '박사',
        other: '기타',
      },
      viewFullCta: '이력서 전체보기',
      modalTitle: '이력서',
      loadError: '이력서를 불러오지 못했어요.',
    },
    safetyTips: {
      title: '알바의 상식',
      intro: '안전한 구직을 위해 꼭 알아야 할 채용사기 유형과 체크리스트를 확인하세요.',
      ctaScamSearch: '취업피해검색 바로가기',
      ctaLaborConsult: '노무상담 받아보기',
      ctaContractTemplate: '근로계약서 양식 보기',
    },
    contractTemplate: {
      title: '근로계약서 양식',
      subtitle: '베트남 노동법 기준에 맞춰 체크할 항목을 정리한 참고용 양식이에요.',
      printCta: '인쇄하기 / PDF로 저장',
      docTitle: '근로계약서',
      docSubtitle: '아래 항목을 채워 넣고 서명해서 사용하세요. (한국어 / 베트남어 병기)',
    },
    followEmployerCta: '관심기업 등록',
    unfollowEmployerCta: '관심기업 해제',
    followedEmployers: {
      title: '관심기업',
      subtitle: '관심 등록한 채용 게시자의 새 공고를 모아볼 수 있어요.',
      empty: '아직 관심 등록한 기업이 없어요.',
      activeCount: '진행중인 공고 {count}건',
    },
    savedTalents: {
      title: '스크랩 인재',
      subtitle: '저장해둔 인재 프로필을 모아볼 수 있어요.',
      empty: '아직 저장한 인재가 없어요.',
      unsaveCta: '저장 해제',
    },
    moreMenu: '더보기 메뉴',
    searchPlaceholder: '공고 제목 검색',
    aiBannerText: 'AI가 나에게 맞는 알바를 찾았어요!',
    iconMenu: {
      matched: '맞춤',
      region: '지역별',
      shortTerm: '단기',
      urgent: '급구',
      all: '전체',
    },
    chipOccupationAll: '직종 전체',
    chipCountryAll: '국가 전체',
    chipRegionAll: '지역 전체',
    chipEmploymentAll: '고용형태 전체',
    filterSheetTitle: '상세 필터',
    filterReset: '초기화',
    filterApply: '적용하기',
    matchBadge: '맞춤 추천',
    regionBadge: {
      slot1Exact: '내 위치',
      slot2Exact: '관심지역',
      slot1Radius: '내 위치 근처 {km}km',
      slot1RadiusPlain: '내 위치 근처',
      slot2Radius: '관심지역 근처 {km}km',
      slot2RadiusPlain: '관심지역 근처',
    },
    matchReason: {
      tag: '관심 분야 일치',
      career: '경력 조건 일치',
      days: '근무 요일 일치',
      hours: '근무 시간대 일치',
      duration: '근무 기간 일치',
      nearby: '내 근처',
    },
  },
  jobsOnboarding: {
    title: '알바 선호도 설정',
    next: '다음',
    bannerText: '맞춤 알바를 찾아보세요',
    bannerCta: '선호도 설정하기',
    stepStyleTitle: '어떤 알바를 선호하세요?',
    style: {
      beginner_friendly: '초보 환영 알바',
      start_immediately: '바로 출근 알바',
      with_friends: '친구와 함께하는 알바',
      short_term: '단기 알바',
      browse_myself: '직접 찾아볼게요',
    },
    styleDesc: {
      beginner_friendly: '쉽고 재미있는 첫 알바를 찾고 있어요',
      start_immediately: '급하게 알바를 구하고 있어요',
      with_friends: '마음 맞는 친구랑 같이 일하고 싶어요',
      short_term: '1개월 이내로 짧게 일하고 싶어요',
      browse_myself: '천천히 둘러볼게요',
    },
    stepTagsTitle: '관심 있는 직종을 3개 이상 선택해주세요',
    stepCareerTitle: '경력을 알려주세요',
    stepReasonTitle: '지금 알바를 찾는 이유는?',
    reason: {
      vacation: '방학 알바',
      ongoing: '상시 알바',
      urgent: '급구 알바',
      browsing: '탐색 중',
    },
    stepConditionDuration: '일하는 기간',
    duration: {
      day: '하루(1일)',
      under_week: '1주일 이하',
      week_to_month: '1주일~1개월',
      m1_3: '1개월~3개월',
      m3_6: '3개월~6개월',
      m6_12: '6개월~1년',
      over_year: '1년 이상',
    },
    stepConditionDays: '일하는 요일',
    days: {
      all_week: '월~일',
      mon_sat: '월~토',
      weekday: '월~금',
      weekend: '주말(토,일)',
    },
    stepConditionHours: '일하는 시간',
    hours: {
      morning: '오전',
      afternoon: '오후',
      evening: '저녁',
      dawn: '새벽',
      fulltime: '풀타임(8시간 이상)',
    },
    finishTitle: '설정 완료!',
    finishDesc: '이제 홈에서 맞춤 공고를 확인할 수 있어요.',
    locationConsent: '내 근처 알바 추천도 받아볼게요',
    talentPublicConsent: '인재정보에 내 프로필 공개하기 (고용주가 열람할 수 있어요)',
    talentBadgesLabel: '나를 나타내는 배지',
    talentBadges: {
      veteran: '베테랑',
      student: '대학생',
      freelancer: '프리랜서',
    },
    saving: '저장 중…',
    start: '시작하기',
  },
  creditCharge: {
    title: '밍고크레딧 충전',
    balance: '보유 크레딧',
    unit: '{n}개',
    amountTitle: '충전할 크레딧 수량',
    amountPh: '원하는 크레딧 수량',
    notePh: '입금자명 등 메모 (선택)',
    noticeTitle: '안내',
    notice1: '충전 요청 후 확인되면 크레딧이 지급돼요.',
    notice2: '밍고크레딧은 앱 내 주문 확정용으로만 사용돼요 (실제 결제는 매장 현금 결제).',
    historyTitle: '내 충전 요청 내역',
    statusApproved: '지급완료',
    statusRejected: '반려됨',
    statusPending: '대기중',
    submit: '충전 요청',
    success: '충전 요청을 접수했어요. 확인 후 크레딧이 지급돼요.',
    fail: '충전 요청에 실패했어요.',
  },
  business: {
    listTitle: '업체 목록',
    registerCta: '업체 등록',
    advertiseLikeThis: '이 업체처럼 광고하고 싶으신가요?',
    registerTitle: '업체 등록',
    submit: '등록하기',
    name: '업체명',
    category: '업종',
    contact: '연락처',
    address: '주소',
    region: '지역',
    regionPh: '예: 미케비치',
    intro: '업체 소개',
    hours: '운영시간',
    targetLang: '대상 언어',
    scopeLevel: '서비스 범위',
    scopeCity: '로컬 서비스',
    scopeCityDesc: '특정 도시/지역에서만 운영\n(식당/병원/학원 등)',
    scopeCountry: '국가 단위 서비스',
    scopeCountryDesc: '해당 국가 전체 교민 대상\n(법률/보험/부동산 등)',
    scopeGlobal: '글로벌 서비스',
    scopeGlobalDesc: '전세계 어디서든 이용 가능\n(온라인/멘토링/디지털 등)',
    targetAudience: '주요 타겟 고객',
    targetExpat: '교민',
    targetTourist: '관광객',
    targetBoth: '교민 + 관광객',
    targetBusiness: '비즈니스',
    serviceOnline: '온라인 서비스 가능',
    serviceOnlineDesc: '비대면으로도 서비스 제공 가능\n(화상상담/배송/원격 등)',
    operatingCities: '운영 도시',
    addCity: '도시 추가',
    photos: '사진 업로드',
    needName: '업체명을 입력해 주세요.',
    saved: '등록했어요.',
    notFound: '업체를 찾을 수 없어요.',
    reviews: '리뷰 {n}건',
    contactBtn: '연락하기',
    inquiryCta: '문의하기',
    contactSoon: '연락 기능은 준비 중이에요.',
    adBtn: '광고 문의하기',
    adInquiry: '광고 문의는 고객센터로 연결될 예정이에요.',
    introEn: '영문 소개 (번역용, 선택)',
    primaryTitle: '대표 업체 선택',
    primaryHint: '프로필 배지에 노출할 대표 업체를 선택하세요.',
    primarySaved: '대표 업체를 저장했어요.',
    deliverySection: '배달·픽업',
    deliveryOn: '배달 가능',
    deliveryArea: '배달 가능 지역',
    deliveryAreaPh: '예: 미케비치 3km',
    minOrder: '최소 주문 금액',
    deliveryFee: '배달비',
    pickupOn: '픽업 가능',
    orderMethod: '주문 방법',
    orderPhone: '전화',
    orderKakao: '카카오톡',
    orderApp: '앱',
    orderVisit: '직접 방문',
    orderContact: '주문 연락처',
    closedDays: '휴무일',
    dayMon: '월',
    dayTue: '화',
    dayWed: '수',
    dayThu: '목',
    dayFri: '금',
    daySat: '토',
    daySun: '일',
    menuSection: '메뉴 등록',
    addMenu: '메뉴 추가',
    menuName: '메뉴명',
    menuPrice: '가격',
    menuDesc: '설명',
    menuPhoto: '사진',
    menuSoldOut: '품절',
    menuEdit: '수정',
    menuDelete: '삭제',
    menuSave: '저장',
    menuCats: {
      korean: '한식',
      chinese: '중식',
      western: '양식',
      drink: '음료',
      other: '기타',
      popular: '인기',
      set: '세트',
      dessert: '디저트',
    },
    badgeDelivery: '배달',
    badgePickup: '픽업',
    detailMinOrder: '최소 주문',
    detailDeliveryFee: '배달비',
    detailOrder: '주문하기',
    detailHours: '영업시간',
    detailClosed: '휴무',
    detailMenus: '메뉴',
    translate: '번역',
    translateOriginal: '원문',
    cats: {
      restaurant: '음식점',
      hospital: '병원',
      beauty: '미용',
      travel: '여행',
      realestate: '부동산',
      other: '기타',
      food_cafe_mart: '음식·카페·마트',
      travel_activity_experience: '여행·투어',
      accommodation_stay: '호텔·스테이',
      living_realestate_rental: '부동산·임대',
      home_interior: '홈/인테리어',
      health_medical_beauty: '의료/건강/미용',
      beauty_wellness: '뷰티·웰니스',
      health_medical: '의료·건강',
      education_lesson: '교육/레슨',
      mobility_transport: '모빌리티/이사/용달',
      telecom: '통신/유심/인터넷',
      finance_remittance: '금융/송금',
      wedding_event: '웨딩/이벤트',
      pet: '반려동물',
      creator_media: '크리에이터/미디어',
      parenting_care: '육아/돌봄',
      jobs_business: '구인구직',
      professional_services: '비자·법률·회계·행정',
    },
    catsDesc: {
      food_cafe_mart: '현지 맛집·한식·카페·마트·배달',
      living_realestate_rental: '부동산·월세·전세·매매·가전렌탈·승계',
      home_interior: '도배·장판·인테리어 시공·홈케어',
      travel_activity_experience: '투어·액티비티·예약 승계',
      accommodation_stay: '호텔·리조트·풀빌라·게스트하우스',
      jobs_business: '구인구직·프리랜서·인턴',
      professional_services: '비자·법률상담·세무회계·법인설립·번역통역',
      education_lesson: '학교·레슨·클래스·체험',
      health_medical_beauty: '의료·건강·미용 서비스',
      beauty_wellness: '미용실·이발소·네일·왁싱·마사지·스파·헬스',
      health_medical: '내과·치과·피부과·성형·한의원·약국',
      mobility_transport: '렌탈·이사·택배·차량 매매·정비',
      telecom: '유심·이심·휴대폰개통·인터넷설치·포켓와이파이',
      finance_remittance: '환전·송금·보험',
      wedding_event: '웨딩·이벤트·사진·영상',
      pet: '동물병원·펫미용·펫시터·용품',
      creator_media: '라이브·웹툰·유튜브·크리에이터',
      parenting_care: '베이비시터·산후도우미·아이돌봄·놀이방',
    },
    defaultMenuGroupName: {
      popular: '인기 메뉴',
      set: '세트',
      drink: '음료',
      dessert: '디저트',
      service: '서비스 · 상품',
      other: '기타',
    },
    optionItem: '항목',
    deliveryZonesTitle: '배달 구역',
    zoneNamePh: '구역명 (예: A구)',
    zoneOn: 'ON',
    zoneDelete: '구역 삭제',
    addZone: '구역 추가',
    menuCategoriesTitle: '메뉴 카테고리',
    menuCategoriesHint: '인기/세트/음료/디저트 등 카테고리를 정하고 메뉴마다 배정해요.',
    offeringsSection: '서비스 · 상품 (선택)',
    offeringsHint:
      '강좌·시술·클래스·패키지 등 고객에게 보여줄 항목을 적어 주세요. 식당·카페는 대분류에서 「식음료」를 선택하면 메뉴판·배달 입력을 쓸 수 있어요.',
    offeringName: '항목명 (예: 초급 한국어 주3회)',
    offeringPrice: '가격 · 수강료',
    offeringDesc: '설명 (시간·대상·준비물 등)',
    categoryDelete: '삭제',
    addCategory: '카테고리 추가',
    minOneCategory: '카테고리는 1개 이상 유지해 주세요.',
    optionGroupsTitle: '옵션 (사이즈, 토핑 등)',
    optionGroupNamePh: '옵션 그룹 (예: 사이즈)',
    optionGroupDelete: '그룹 삭제',
    addOptionGroup: '옵션 그룹 추가',
    addOptionItem: '옵션 항목 추가',
    optLabelPh: '이름 (예: 대)',
    optPriceDeltaPh: '추가 금액 (0)',
    optTypeSingle: '단일 선택',
    optTypeMulti: '다중 선택',
    optRequired: '필수',
    openNow: '오늘 영업중',
    closedNow: '오늘 마감',
    callNow: '전화하기',
    mapLink: '지도 링크',
    profileHubTitle: '내 업체',
    profileHubLead: '업체 등록·관리는 내 정보의 업체 대시보드에서 진행해 주세요.',
    profileLocalTitle: '이 기기에 저장된 업체',
    profileLocalHint: '등록 직후 미리보기용입니다. 앱 데이터를 지우면 함께 사라질 수 있어요.',
    profileEmptyLocal: '저장된 업체가 없어요. 위에서 등록해 보세요.',
    profileOpenStore: '스토어 보기',
  },
  categories: {
    medical_health: '의료/건강',
    beauty: '미용/뷰티',
    food_beverage: '식음료',
    real_estate_life: '부동산/생활',
    education: '교육',
    professional: '전문서비스',
    shopping_convenience: '쇼핑/편의',
    transport: '이동/운송',
    event_leisure: '이벤트/여가',
    care: '돌봄/케어',
    repair_tech: '수리/기술',
    misc: '기타',
    med_hospital: '병원/의원',
    med_dental: '치과',
    med_pharmacy: '약국',
    med_korean: '한의원',
    med_plastic: '성형외과',
    med_derma: '피부과',
    med_eye: '안과',
    med_ent: '이비인후과',
    med_obgyn: '산부인과',
    med_pediatric: '소아과',
    med_ortho: '정형외과',
    med_gym: '헬스장/피트니스',
    med_yoga: '요가/필라테스',
    med_rehab: '재활/물리치료',
    bea_hair: '미용실/헤어샵',
    bea_nail: '네일샵',
    bea_spa: '마사지/스파',
    bea_wax: '왁싱샵',
    bea_lash: '눈썹/속눈썹',
    bea_skin: '피부관리실',
    bea_tattoo: '타투/피어싱',
    food_korean: '한식당',
    food_japanese: '일식당',
    food_chinese: '중식당',
    food_western: '양식당',
    food_sea: '동남아식당',
    food_other_intl: '기타외국식',
    food_cafe: '카페/디저트',
    food_bakery: '베이커리',
    food_bar: '바/펍',
    food_delivery: '배달전문점',
    re_agency: '부동산중개',
    re_interior: '인테리어/리모델링',
    re_cleaning: '청소업체',
    re_moving: '이사/운반',
    re_laundry: '세탁소',
    re_ac: '에어컨/가전수리',
    re_lock: '열쇠/보안',
    re_pest: '해충방제',
    edu_korean: '한국어학원',
    edu_english: '영어학원',
    edu_local: '현지어학원',
    edu_music: '음악학원',
    edu_art: '미술학원',
    edu_sports: '수영/스포츠',
    edu_tutor: '과외/튜터링',
    edu_cooking: '요리교실',
    edu_it: '코딩/IT교육',
    edu_dance: '댄스',
    pro_visa: '비자/행정대행',
    pro_tax: '세무/회계',
    pro_legal: '법률/법무',
    pro_insurance: '보험',
    pro_interpret: '통역/번역',
    pro_photo: '사진/영상',
    pro_itdev: 'IT/웹개발',
    pro_design: '디자인',
    pro_consult: '컨설팅',
    shop_kmart: '한국마트/식품점',
    shop_cvs: '편의점',
    shop_flower: '꽃집',
    shop_pet: '반려동물샵',
    shop_fashion: '의류/패션',
    shop_electronics: '전자제품',
    tr_taxi: '택시/차량대절',
    tr_rentcar: '렌트카',
    tr_bike: '오토바이렌탈',
    tr_airport: '공항픽업',
    tr_move: '이삿짐운반',
    tr_quick: '퀵배송',
    ev_planner: '이벤트플래너',
    ev_wedding: '웨딩/스튜디오',
    ev_travel: '여행사/가이드',
    ev_golf: '골프장',
    ev_boat: '요트/보트',
    ev_sports: '스포츠시설',
    ev_karaoke: '노래방/오락',
    care_baby: '베이비시터',
    care_postpartum: '산후도우미',
    care_elder: '노인돌봄',
    care_pet: '반려동물케어',
    care_pethotel: '펫호텔/미용',
    rep_phone: '핸드폰수리',
    rep_pc: '컴퓨터수리',
    rep_appliance: '가전제품수리',
    rep_car: '자동차수리',
    rep_bike: '오토바이수리',
    rep_cycle: '자전거수리',
    misc_other: '기타 업종',
  },
  bookingTransfer: {
    title: '예약 양도',
    write: '양도 올리기',
    writeTitle: '예약 양도 등록',
    detailTitle: '예약 양도 상세',
    urgent: '긴급 양도',
    urgentToday: '오늘 마감',
    urgentDday: 'D-{days}',
    filterAll: '전체',
    listSection: '전체 목록',
    empty: '등록된 양도가 없습니다',
    emptyHint: '첫 양도를 올려 보세요.',
    viewDetail: '상세 보기',
    chat: '채팅하기',
    chatFail: '채팅을 시작할 수 없습니다',
    trustBadge: '신뢰도 {tier}',
    comingSoonHint: '곧 오픈됩니다. 조금만 기다려 주세요.',
    stepLabel: '{step}단계',
    fieldType: '예약 타입',
    fieldVenue: '장소명',
    fieldCheckIn: '체크인',
    fieldCheckOut: '체크아웃',
    fieldOriginalPrice: '원래 가격 (USD)',
    fieldPricePoints: '양도 가격 (포인트)',
    fieldProof: '예약 확인서 (필수)',
    fieldTitle: '제목',
    fieldDescription: '상세 설명',
    fieldExpiry: '마감일',
    regionAuto: '지역: {region}',
    proofRequired: '예약 확인서를 업로드해 주세요.',
    proofUploadFail: '증빙 업로드에 실패했습니다.',
    proofCount: '{count}개 업로드됨',
    legalRequired: '법적 고지에 동의해 주세요.',
    next: '다음',
    back: '이전',
    submit: '등록',
    writeSuccess: '양도가 등록되었습니다.',
    writeFail: '등록에 실패했습니다.',
    defaultTitle: '예약 양도',
    notFound: '양도를 찾을 수 없습니다.',
    proofView: '예약 확인서',
    disputeDefault: '분쟁 신고',
    disclaimer: '본 플랫폼은 거래의 당사자가 아닙니다. 직접 확인 후 거래하세요.',
    type: {
      hotel: '호텔',
      golf: '골프',
      restaurant: '레스토랑',
      pool_villa: '풀빌라',
      spa: '스파',
      activity: '액티비티',
      other: '기타',
    },
    escrow: {
      lock: '포인트로 구매',
      release: '거래 완료',
      dispute: '분쟁 신고',
      lockSuccess: '에스크로가 잠겼습니다.',
      lockFail: '에스크로 처리에 실패했습니다.',
      disputeSuccess: '분쟁이 접수되었습니다.',
      disputeFail: '분쟁 접수에 실패했습니다.',
    },
  },
  succession: {
    title: '승계 거래',
    write: '승계 올리기',
    writeTitle: '승계 거래 등록',
    detailTitle: '승계 거래 상세',
    filterAll: '전체',
    empty: '등록된 승계가 없습니다',
    emptyHint: '첫 승계 매물을 올려 보세요.',
    deposit: '보증금/권리금',
    remainingMonths: '잔여 {months}개월',
    fieldType: '승계 타입',
    fieldTitle: '제목',
    fieldRegion: '지역',
    fieldDeposit: '보증금/권리금',
    fieldMonthly: '월세',
    fieldRemaining: '남은 계약 (개월)',
    fieldProof: '계약서 (필수)',
    landlordConsent: '건물주 동의 완료',
    proofRequired: '계약서를 업로드해 주세요.',
    proofUploadFail: '증빙 업로드에 실패했습니다.',
    legalRequired: '법적 고지에 동의해 주세요.',
    legalAck: '위 내용을 확인했습니다',
    verificationHint: '판매자 인증 레벨이 높을수록 신뢰도가 올라갑니다.',
    writeSuccess: '승계가 등록되었습니다.',
    writeFail: '등록에 실패했습니다.',
    notFound: '승계를 찾을 수 없습니다.',
    disclaimer: '본 플랫폼은 계약의 당사자가 아닙니다. 건물주 동의 및 대면 확인을 거치십시오.',
    type: {
      house: '집/방',
      business: '사업체',
      membership: '멤버십',
      vehicle: '차량',
      other: '기타',
    },
  },
  businessRegisterHub: {
    title: '업체 등록',
    lead: '어떤 업종으로 등록하시겠어요?',
    searchPlaceholder: '카테고리 검색',
    searchAria: '카테고리 검색',
    emptyCta: '검색 결과가 없습니다. 일반 등록하기',
    inquiryLink: '등록 관련 문의',
    items: {
      food_mart: { label: '맛집/마트', desc: '음식점, 카페, 마트, 배달' },
      life: { label: '생활서비스', desc: '청소, 세탁, 이사, 심부름' },
      travel: { label: '여행/숙소', desc: '호텔, 투어, 액티비티' },
      realestate: { label: '부동산', desc: '월세, 매매, 상가' },
      freelance: { label: '프리랜서·레슨', desc: '과외, 디자인, 번역' },
      interior: { label: '인테리어', desc: '시공, 가구, 설치' },
      repair: { label: '수리·서비스', desc: '가전, 차량, 출장수리' },
      jobs: { label: '구인구직', desc: '채용공고, 구직프로필' },
      sports: { label: '운동·취미·모임', desc: '골프, 헬스, 모임' },
      business: { label: '비즈니스·행정', desc: '비자, 법률, 세무' },
      medical: { label: '의료·건강', desc: '병원, 치과, 약국' },
      education: { label: '교육·육아', desc: '학원, 과외, 육아' },
      vehicles: { label: '차량', desc: '매매, 렌트, 정비' },
      finance: { label: '금융', desc: '환전, 송금, 보험' },
      class: { label: '클래스·체험', desc: '원데이클래스, 문화체험' },
      creator: { label: '크리에이터/미디어', desc: '라이브, 웹툰, 쇼츠' },
      pet: { label: '반려동물', desc: '펫샵, 미용, 병원' },
      wedding: { label: '웨딩·이벤트', desc: '웨딩, 이벤트 플래너' },
    },
  },
  businessRegister: {
    majorTitle: '대분류',
    majorHint: '가장 가까운 분류를 선택해 주세요.',
    businessTypeTitle: '업체 유형',
    businessTypeGeneral: '일반 업체',
    businessTypeWholesale: '도매 업체',
    businessTypeManufacturer: '제조사',
    manufacturerGuidePlaceholder: '생산 공정 및 납품 실적을 중심으로 작성해 주세요.',
    wholesaleGuidePlaceholder: '취급 품목 및 단가 가이드를 중심으로 작성해 주세요.',
    moq: '최소 주문 수량(MOQ)',
    moqPlaceholder: '예: 100',
    companyProfilePdfUrl: '회사소개서 PDF URL',
    companyProfilePdfUrlPlaceholder: 'https://.../company-profile.pdf',
    certificationImageUrls: '인증서 이미지 URL',
    certificationImageUrlsPlaceholder: '여러 개는 쉼표(,)로 구분',
    productionCapacity: '생산 가능량',
    productionCapacityPlaceholder: '예: 월 20,000개 / 라인 3개',
    b2bTargetCategories: '우선 타겟 업종',
    b2bTargetCategoriesPlaceholder: '예: cafe, bakery, restaurant',
    subTitle: '소분류',
    subHint: '해당되는 항목을 모두 선택할 수 있어요.',
    needMajor: '대분류를 선택해 주세요.',
    needSub: '소분류를 한 개 이상 선택해 주세요.',
    hospitalBanner: '병원·의료 업체는 내 정보 → 업체 대시보드에서 등록·관리할 수 있어요.',
    hospitalCta: '업체 대시보드로',
  },
  quickRegister: {
    title: '업체 빠른 등록',
    lead: '5가지만 입력하면 30초 안에 등록돼요',
    fieldName: '업체명 *',
    namePlaceholder: '업체명을 입력하세요',
    fieldMajor: '대분류 *',
    fieldSub: '업종 (복수 선택)',
    subHint: '해당하는 업종을 모두 선택하세요. 첫 선택이 대표 업종입니다.',
    subLoading: '업종 불러오는 중…',
    tagsHint: '제공 체험·종류 (선택, 최대 8개) — 없으면 직접 입력',
    fieldContact: '연락처 *',
    contactPlaceholder: '전화번호, 카카오ID, 인스타 등',
    fieldPhoto: '대표사진',
    submit: '등록하기',
    submitting: '등록 중…',
    successToast: '등록 완료! 프로필을 채우면 더 많이 노출돼요.',
    claimBannerText: '이미 등록된 우리 가게가 있나요? 찾아보기',
  },
  businessClaim: {
    title: '내 가게 찾기',
    lead: '이미 밍고에 예시로 등록되어 있는 가게라면, 검색해서 내 가게로 신청할 수 있어요. 관리자 확인 후 사장님 계정으로 연결돼요.',
    searchPlaceholder: '가게 이름으로 검색',
    searchBtn: '검색',
    searching: '검색 중…',
    noResults: '일치하는 가게를 찾지 못했어요.',
    goRegisterNew: '새 업체로 등록하기',
    thisIsMine: '내 가게예요',
    myRequestsTitle: '내 신청 내역',
    confirmTitle: '이 가게가 맞나요?',
    contactLabel: '연락처',
    contactPlaceholder: '전화번호, 카카오ID 등',
    noteLabel: '메모 (선택)',
    notePlaceholder: '사업자 정보, 확인 가능한 방법 등을 남겨주세요',
    reviewHint: '관리자 확인 후 승인되면 사장님 계정으로 연결돼요.',
    submit: '신청하기',
    submitting: '신청 중…',
    requestSent: '신청했어요. 관리자 확인 후 연결될 예정이에요.',
    requestFailed: '신청에 실패했어요. 다시 시도해주세요.',
    status: {
      pending: '승인 대기중',
      approved: '승인됨',
      rejected: '거절됨',
      cancelled: '취소됨',
    },
  },
  delivery: {
    won: '원',
    comingSoonTitle: '배달 서비스 준비중입니다',
    comingSoonDesc: '장바구니·주문은 오픈 시 이용할 수 있어요. 오픈 알림을 받아보세요.',
    waitlistCta: '오픈 알림 신청',
    needLoginNotify: '로그인 후 알림을 신청할 수 있어요.',
    waitlistOk: '알림 신청이 접수됐어요.',
    cartTitle: '장바구니',
    cartEmpty: '담은 메뉴가 없어요.',
    storeName: '가게',
    deliveryFee: '배달비',
    pickupSelected: '픽업 — 이 주문에 배달비는 없어요.',
    serviceType: '이용 방식',
    serviceDelivery: '배달',
    servicePickup: '픽업',
    orderNote: '가게에 요청',
    orderNotePh: '예: 대파 빼주세요',
    subtotal: '상품 합계',
    grandTotal: '결제 예정',
    placeOrder: '주문하기',
    orderSoon: '지금은 주문 접수를 준비 중이에요. 조금만 기다려 주세요.',
    clearCart: '장바구니 비우기',
    clearCartOtherStore: '다른 가게 메뉴가 담겨 있어요. 비우고 이 메뉴를 담을까요?',
    addedToCart: '장바구니에 담았어요.',
    addToCart: '담기',
    optionsTitle: '옵션',
    optRequired: '필수',
    optSingle: '단일',
    optMulti: '다중',
    fee: '배달비',
    zoneOff: '꺼짐',
    ordersTitle: '주문 내역',
    noOrders: '주문 내역이 없어요.',
    activeOrders: '진행 중',
    pastOrders: '지난 주문',
    reorder: '재주문',
    writeReview: '리뷰 작성',
    reorderEmpty: '다시 담을 메뉴가 없어요.',
    reorderDone: '장바구니에 담았어요.',
    reviewSoon: '리뷰는 곧 쓸 수 있어요.',
    stReceived: '주문 접수',
    stPreparing: '준비 중',
    stDelivering: '배달 중',
    stDone: '완료',
    stRejected: '취소',
    dashTitle: '업체 대시보드',
    dashNoBiz: '등록한 업체가 아직 없어요.',
    dashSelectBiz: '업체',
    dashNew: '새 주문',
    dashRevenue: '오늘 매출',
    dashInbox: '접수함',
    dashAccept: '수락',
    dashReject: '거절',
    dashPipeline: '처리 중인 주문',
    dashSoldout: '빠른 품절',
    dashZones: '배달 구역',
    orderAccepted: '수락했어요.',
    orderRejected: '거절했어요.',
    statusUpdated: '상태를 바꿨어요.',
  },
  notifications: {
    title: '알림 설정',
    groupCommunity: '커뮤니티',
    groupTrade: '거래',
    groupBusiness: '업체',
    groupLocal: '생활정보',
    groupMarketing: '마케팅',
    groupSystem: '시스템',
    rowChat: '채팅 메시지',
    descChat: '새 채팅 메시지가 도착할 때',
    rowComment: '댓글 알림',
    descComment: '내 글에 댓글이 달릴 때',
    rowLike: '댓글 좋아요',
    descLike: '내 댓글에 좋아요가 달릴 때',
    rowPostLike: '게시글 좋아요',
    descPostLike: '내 게시글에 좋아요가 달릴 때',
    rowFollow: '팔로워 알림',
    descFollow: '새 팔로워가 생길 때',
    rowNewPost: '지역 새 글',
    descNewPost: '내 지역에 새 게시글이 올라올 때',
    rowTradeInquiry: '거래 문의',
    descTradeInquiry: '내 상품에 문의가 올 때',
    rowTradeDone: '거래 완료',
    descTradeDone: '거래가 완료될 때',
    rowPriceChange: '가격 변동',
    descPriceChange: '찜한 상품의 가격이 변경될 때',
    rowBizApproval: '업체 승인/반려',
    descBizApproval: '등록한 업체의 심사 결과를 받을 때',
    rowBizInquiry: '업체 문의',
    descBizInquiry: '업체에 새 문의가 올 때',
    rowBizReview: '새 리뷰',
    descBizReview: '업체에 리뷰가 달릴 때',
    rowBizBooking: '예약 알림',
    descBizBooking: '새 예약이 들어올 때',
    rowExchangeAlert: '환율 알림',
    descExchangeAlert: '설정한 환율에 도달할 때',
    rowExpiryAlert: '만료 일정 알림',
    descExpiryAlert: '기간만료 알림의 일정이 임박했을 때',
    rowLocalNew: '생활정보 새 업체',
    descLocalNew: '내 지역에 새 업체가 등록될 때',
    rowEmergency: '긴급 공지',
    descEmergency: '재난·안전 관련 긴급 공지',
    rowVisa: '비자/행정 알림',
    descVisa: '비자 관련 새 정보가 있을 때',
    rowScam: '사기 주의 알림',
    descScam: '지역 사기 주의 정보가 등록될 때',
    rowAd: '이벤트/프로모션',
    descAd: '밍고 이벤트 및 업체 프로모션 정보',
    rowAds: '광고 관련 알림',
    rowNoShowWarn: '노쇼 경고',
    descNoShowWarn: '노쇼 누적 시 경고 알림',
    rowSecurity: '계정 보안',
    descSecurity: '로그인·비밀번호 변경 알림',
    rowAnnouncement: '서비스 공지',
    descAnnouncement: '점검·업데이트 공지',
    pushTitle: '브라우저 푸시 알림',
    pushAllow: '알림 허용하기',
    pushOn: '알림 활성화됨',
    pushDenied: '브라우저 설정에서 이 사이트의 알림을 허용해 주세요.',
    pushUnsupported: '이 브라우저에서는 푸시 알림을 지원하지 않아요.',
    pushDeniedHint: '설정에서 알림을 허용하면 푸시를 받을 수 있어요.',
  },
  exchange: {
    title: '환율 계산기',
    hint: '선택한 지역을 참고해 기본 화폐를 골랐어요. 금액을 바꾸면 다른 통화로 자동 환산돼요.',
    base: '기준 통화',
    amount: '금액',
    refresh: '환율 새로고침',
    updated: '마지막 업데이트: {time}',
    loadError: '환율을 불러오지 못했어요. 잠시 후 다시 시도해 주세요.',
    fallbackHint: '참고용 고정 환율로 표시 중입니다.',
  },
  remittance: {
    heroTitle: '해외 송금 서비스',
    heroDesc: '한국↔베트남 송금\n최저 수수료 · 빠른 이체',
    registerDesc: '송금 서비스를 등록하시겠어요?',
    registerBtn: '송금 서비스 등록',
    registerTitle: '송금 서비스 등록',
    stepBasic: '서비스 정보',
    provider: '서비스명',
    providerPlaceholder: '예: 하나머니',
    desc: '서비스 소개',
    descPlaceholder: '서비스 특징, 장점을 소개해주세요',
    currencyPair: '송금 통화',
    from: '보내는 통화',
    to: '받는 통화',
    exchangeRate: '환율',
    feeFixed: '고정 수수료',
    feePercent: '% 수수료',
    minMax: '최소/최대 금액',
    min: '최소',
    max: '최대',
    languages: '지원 언어',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    affiliateLink: '서비스 링크 (선택)',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '환율/수수료는 실시간으로 업데이트 해주세요',
    registerSuccess: '송금 서비스가 등록됐습니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
    calcTitle: '송금 금액 입력',
    amountPlaceholder: '금액을 입력하세요',
    youReceive: '받는 금액',
    fee: '수수료',
    transferTime: '소요시간',
    goToService: '서비스 이동',
    redirecting: '서비스 페이지로 이동합니다',
    liveData: '실시간',
    pairKrwVnd: '원 → 동',
    pairKrwUsd: '원 → 달러',
    pairUsdVnd: '달러 → 동',
    pairVndKrw: '동 → 원',
  },
  medicine: {
    title: '약품 정보',
    detailTitle: '약품 상세',
    searchPlaceholder: '한국 약품명 또는 성분명 검색',
    notice: '이 정보는 참고용입니다. 복용 전 약사·의사와 상담하세요',
    empty: '검색 결과가 없습니다',
    notFound: '약품 정보를 찾을 수 없습니다',
    localName: '현지 약품명',
    ingredients: '주요 성분',
    effects: '효능·효과',
    dosage: '복용법',
    warnings: '주의사항',
    rxRequired: '처방전 필요',
    findPharmacy: '근처 병원·약국 찾기',
    nameKo: '한국 약품명',
    catAll: '전체',
    catPainFever: '해열·진통',
    catCold: '감기',
    catDigestive: '소화·위장',
    catSkin: '피부',
    catVitamin: '비타민·영양',
    catAllergy: '알레르기',
    catDental: '구강',
    catEyeEar: '눈·귀',
    catChronic: '만성질환',
    catOther: '기타',
  },
  myTrades: {
    title: '내 거래내역',
    tabs: { selling: '판매중', reserved: '예약중', done: '거래완료' },
    empty: '해당 상태의 상품이 없어요.',
    markReserved: '예약중으로',
    backToSelling: '판매중으로',
    markDone: '완료 처리',
  },
  myFavorites: {
    title: '찜 목록',
    empty: '찜한 항목이 없습니다',
    properties: '매물',
    products: '상품',
    posts: '게시글',
  },
  appSettings: {
    title: '앱 설정',
    exchange: '환율 계산',
    language: '언어 변경',
    region: '지역 변경',
    notifications: '알림 설정',
    privacy: '개인정보 처리방침',
    terms: '서비스 이용약관',
    version: '앱 버전',
    logout: '로그아웃',
    withdraw: '회원 탈퇴',
    loggedOut: '로그아웃했어요.',
    withdrawConfirm: '정말 탈퇴할까요? 저장된 설정이 삭제됩니다.',
    withdrawModalTitle: '회원 탈퇴',
    withdrawModalBody: '탈퇴 시 기기에 저장된 설정이 삭제되고 로그아웃됩니다. 계속할까요?',
    withdrawModalBodyV2:
      'DB에 저장된 내 데이터는 가능한 범위에서 삭제되며 로그아웃됩니다. 인증(이메일) 계정은 별도 절차로 완전 삭제될 수 있어요. 계속할까요?',
    withdrawConfirmBtn: '탈퇴하기',
    withdrawDone: '탈퇴 처리했어요.',
    withdrawFail: '서버 데이터 삭제를 끝내지 못했을 수 있어요. 기기에서 로그아웃은 됐어요.',
  },
  editProfile: {
    title: '계정설정',
    photoSection: '프로필 사진',
    changePhoto: '프로필 사진 변경',
    camera: '카메라',
    gallery: '갤러리',
    defaultAvatars: '기본 아바타',
    basicSection: '기본 정보',
    nickname: '닉네임',
    name: '이름',
    namePlaceholder: '실명 (선택)',
    birthDate: '생년월일',
    genderLabel: '성별',
    genderSelect: '선택 안 함',
    genderMale: '남성',
    genderFemale: '여성',
    bio: '자기소개',
    bioPlaceholder: '한 줄 소개 (50자)',
    contactSection: '연락처',
    kakao: '카카오톡 ID',
    zalo: 'Zalo ID',
    telegram: '텔레그램 ID',
    whatsapp: '왓츠앱 번호',
    phone: '전화번호 (선택)',
    requestVerify: '인증 요청',
    verifyRequested: '인증 요청이 접수됐습니다',
    emailReadonly: '이메일',
    residenceSection: '거주 정보',
    residenceCountry: '거주 국가',
    residenceCity: '거주 도시·지역',
    expatSince: '교민 시작일 (선택)',
    dateFormatHint: '연도-월-일',
    nationalitySection: '국적',
    selectNationality: '국적 선택',
    languagesSection: '사용 언어',
    spokenLang: {
      ko: '한국어',
      en: 'English',
      vi: 'Tiếng Việt',
      ru: 'Русский',
      ja: '日本語',
      zh: '中文',
      hi: 'हिन्दी',
    },
    visaSection: '비자 정보',
    save: '저장하기',
    saved: '저장했어요.',
    loadFail: '프로필을 불러오지 못했어요.',
    nicknameRequired: '닉네임을 한 글자 이상 입력해 주세요.',
    photoUpdated: '프로필 사진을 바꿨어요.',
    photoSaveFail: '사진은 올렸지만 프로필에 반영되지 않았어요. 다시 시도해 주세요.',
    avatarUpdated: '아바타를 적용했어요.',
    visaDday: 'D-{n}',
    visaExpired: '만료',
    privateHint: '아래 정보는 본인만 볼 수 있으며, 커뮤니티 프로필에 자동으로 노출되지 않아요.',
    profileGearCue: '오른쪽 ⚙️에서 내정보로 이동할 수 있어요. 내프로필 아래에서 알림·기간 만료·언어·지역을 바로 설정하세요.',
    editTabsAria: '프로필 수정 구역',
    tabProfile: '프로필',
    tabImportant: '중요 정보',
    tabMyInfo: '내정보',
    tabMyInfoHint:
      '연락처·거주 국가/도시·교민 시작일·국적·내 회원권·계정(로그아웃/회원탈퇴)을 여기에서 관리하세요.',
    openMyInfoAria: '내정보 편집',
    closeMyInfoAria: '프로필 편집으로 돌아가기',
    settingsShortcuts: '알림 · 만료 · 언어 · 지역',
    openNotifications: '알림 설정 (만료 등)',
    openLanguage: '앱 표시 언어',
    openRegions: '관심 지역',
    openAppSettings: '전체 앱 설정',
    emailSection: '로그인 이메일',
    deadlinesAlertCue: '여권·비자·계약 만료 등 알림과 연결할 수 있어요.',
    openMyBusiness: '내 업체 관리',
    regionUnset: '선택된 지역 없음',
    cancel: '취소',
    reverted: '변경을 되돌렸어요.',
    discardConfirm: '저장하지 않은 변경이 있어요. 나갈까요?',
    nationalityCode: '국적·출신 (간단히)',
    nationalityPlaceholder: '예: KR, 한국',
    visaTypeField: '비자·체류 유형',
    visaExpiryField: '비자·체류 만료일',
    deadlinesSection: '기간·만기 메모',
    deadlinesHelp: '여권·국제면허·집 계약 만료·월세 납부일 등 날짜를 적어 두면 나중에 알림과 연결할 수 있어요. 월세는 아래 “매월 반복일”도 함께 쓸 수 있어요.',
    deadlinesNeedAccount: '로그인 후 서버에 저장되는 항목이에요. 계정이 연결되면 추가할 수 있어요.',
    addDeadline: '+ 일정 추가',
    removeDeadline: '삭제',
    deadlineKindLabel: '종류',
    deadlineTitle: '제목',
    deadlineDue: '기준일',
    remindDaysBefore: '며칠 전에 알림 (0~365)',
    repeatRentDay: '매월 반복일 (월세 등, 1~28·선택)',
    deadlineNeedDate: '제목이 있는 일정에는 기준일을 넣어 주세요.',
    accountSection: '계정',
    deadlineKind: {
      passport: '여권',
      drivers_license: '운전·국제면허',
      visa: '비자·체류',
      residence: '외국인등록·거소',
      lease: '집(주거) 계약 기간',
      rent: '월세·관리비 납부일',
      contract: '기타 계약',
      insurance: '보험',
      flight: '항공·이동',
      school: '학교·수업',
      other: '기타',
    },
  },
  legal: {
    placeholderBody: '[LEGAL_PLACEHOLDER — 문서 본문은 외부에서 주입됩니다]',
    privacyTitle: '개인정보 처리방침',
    termsTitle: '서비스 이용약관',
    privacyBody:
      '밍고는 서비스 제공을 위해 필요한 최소한의 정보를 수집합니다. 자세한 항목은 추후 정책 페이지에서 공개됩니다. 문의는 고객센터를 이용해 주세요.',
    termsBody:
      '본 서비스는 베타 단계이며, 약관은 지속적으로 업데이트될 수 있습니다. 안전거래와 커뮤니티 가이드를 준수해 주세요.',
  },
  adInquiry: {
    title: '광고 문의',
    lead: '노출 지역과 연락 가능한 정보를 남겨 주시면 담당자가 연락드립니다.',
    scope: '광고 종류',
    scopeNeighborhood: '동네',
    scopeCity: '도시',
    scopeCountry: '국가',
    scopeGlobal: '글로벌',
    businessName: '업체명',
    contact: '연락처',
    message: '문의 내용',
    notice: '영업일 기준 1~2일 내 연락드립니다.',
    submit: '제출하기',
    sending: '전송 중…',
    done: '문의가 접수되었습니다.',
    needFields: '연락처와 문의 내용(3자 이상)을 입력해 주세요.',
    adPaymentNav: '광고비 온라인 결제 바로가기',
    chatConsult: '채팅으로 상담하기',
    chatConsultUnavailable: '아직 준비 중이에요. 잠시 후 다시 시도해 주세요.',
    pointsRequired: '등록에 필요한 포인트: {pts} P',
    pointsBalanceLine: '현재 보유: {bal} P',
    pointsShortHint: '포인트가 부족합니다. 적립 또는 결제 안내를 확인해 주세요.',
    loginRequired: '로그인 후 포인트 결제로 등록할 수 있어요.',
    submitPayPoints: '포인트 차감 후 제출',
    submitFail: '제출에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    earnPointsLink: '포인트 적립',
    b2bTargetPreview: '이 업종 타겟 기준 예상 도달 사장님: 약 {n}명',
    previewGalleryTitle: '우리 광고, 어디에 이렇게 보여요',
    previewFeedCaption: '채팅·커뮤니티 등 화면 피드에 이렇게 노출돼요',
  },
  tradeReview: {
    title: '거래 후기',
    subtitle: '상대방의 신뢰도에 반영돼요.',
    starsAria: '별점',
    comment: '후기',
    placeholder: '거래 경험을 간단히 적어 주세요.',
    submit: '후기 남기기',
  },
  sos: {
    title: '긴급 도움 요청',
    medical: '의료 도움',
    fraud: '사기/범죄',
    legal: '법률 도움',
    lost: '길 잃음',
    accident: '사고',
    description: '상황 설명',
    location: '현재 위치',
    contact: '연락처',
    send: '도움 요청하기',
    resolved: '해결됨',
    tabSos: 'SOS 요청',
    tabContacts: '긴급연락처',
    locationPlaceholder: 'GPS 또는 수동 입력',
    helpersTitle: '주변 도움 가능한 교민',
    demoHelper1Name: '다낭 교민 안전팀',
    demoHelper1Help: '의료/분실 대응',
    demoHelper1Dist: '1.2km',
    demoHelper2Name: '밍고 긴급 서포터',
    demoHelper2Help: '통역/법률 연결',
    demoHelper2Dist: '2.1km',
    emergencyCallTitle: '긴급 전화',
    emergencyCallLine: '경찰 113 · 구급대 115',
    casesTitle: '해결됨 SOS 사례',
    demoCase1: '여권 분실 SOS -> 35분 내 임시조치 완료',
    demoCase2: '응급실 동행 요청 -> 통역 지원으로 진료 완료',
    activeSosTitle: '현재 활성 SOS',
  },
  referral: {
    myCode: '내 초대 코드',
    copy: '복사하기',
    copied: '복사됨!',
    share: '공유하기',
    invited: '초대한 친구',
    reward: '받은 밍고',
    invite: '친구 초대하고 밍고 받기',
    inviterReward: '초대시 1,000밍고',
    inviteeReward: '가입시 500밍고',
  },
  coupon: {
    title: '쿠폰',
    enter: '쿠폰 코드 입력',
    apply: '적용',
    invalid: '유효하지 않은 쿠폰',
    used: '이미 사용한 쿠폰',
    expired: '만료된 쿠폰',
  },
  academy: {
    title: '학원/교육',
    typeLanguage: '어학원',
    typeMusic: '음악학원',
    typeArt: '미술학원',
    typeSports: '스포츠',
    typeTutor: '과외/튜터',
    typeCooking: '요리교실',
    typeCoding: '코딩/IT',
    typeDance: '댄스',
    typeYoga: '요가/필라테스',
    typeExam: '입시/보습',
    typeCert: '자격증',
    typeOther: '기타',
    targetKids: '어린이',
    targetElementary: '초등학생',
    targetTeen: '중고생',
    targetAdult: '성인',
    targetSenior: '시니어',
    targetForeigner: '외국인',
    classPrivate: '1:1 개인레슨',
    classGroup: '그룹수업',
    classOnline: '온라인',
    classVisit: '방문수업',
    valueEmpty: '—',
    perHour: '시간당',
    perMonth: '월정액',
    trial: '체험수업',
    curriculum: '커리큘럼',
    teachers: '강사',
    schedule: '수업일정',
    applyClass: '수업신청',
    selectSubject: '과목 선택',
    selectType: '수업형태 선택',
    selectSchedule: '희망 일정',
    purposeLabel: '수강 목적/현재 수준',
    ratingTeacher: '강사 수준',
    ratingCurriculum: '커리큘럼',
    ratingFacility: '시설/환경',
    ratingValue: '가격 대비',
    registerCta: '학원 등록',
    noAcademies: '등록된 학원이 없어요',
    applicationSent: '수업 신청이 완료되었습니다!',
    searchPlaceholder: '학원명, 과목 검색',
    chipKorean: '한국어가능',
    chipOnline: '온라인가능',
    chipVerified: '인증',
    onlineShort: '온라인',
    newShort: '신규',
    verified: '인증',
    reviewCount: '리뷰 {n}건',
    favorited: '찜했어요',
    unfavorited: '찜을 해제했어요',
    favorite: '찜',
    demoFavorite: '데모 학원은 찜할 수 없어요',
    inquiryShort: '문의하기',
    classInfo: '수업 정보',
    languages: '수업언어',
    targets: '대상연령',
    formats: '수업형태',
    hours: '수업시간',
    teacherCount: '강사수',
    pricing: '가격',
    location: '위치/시설',
    hoursSection: '운영시간',
    weekday: '평일',
    weekend: '주말',
    registerFlowTitle: '학원 등록',
    stepLabel: '{cur} / {total} 단계',
    courseName: '과목명',
    levelBeginner: '초급',
    levelMid: '중급',
    levelAdv: '고급',
    levelAll: '전체',
    durationMin: '수업시간(분)',
    priceHour: '시간당 가격(USD)',
    addCourse: '과목 추가',
    namePlaceholder: '학원명',
    descPlaceholder: '학원 소개',
    country: '국가 코드',
    city: '도시',
    address: '주소',
    teacherName: '강사 이름',
    teacherSubjects: '전문과목(쉼표로 구분)',
    teacherExp: '경력',
    teacherLangs: '지원언어(쉼표로 구분)',
    teacherPhotoUrl: '프로필 사진 URL',
    addTeacher: '강사 추가',
    trialOffer: '체험수업 제공',
    photoUrl: '사진 URL {n}',
    exposureTier: '노출 등급',
    tierStandard: '스탠다드',
    tierPlus: '플러스',
    registerOk: '학원이 등록되었어요',
    registerDemoOk: '데모 모드: 등록이 시뮬레이션되었어요',
    langKo: '🇰🇷 한국어',
    langEn: '🇺🇸 영어',
    langVi: '🇻🇳 베트남어',
    langRu: '🇷🇺 러시아어',
    langJa: '🇯🇵 일본어',
    register: {
      typeArt: '미술학원',
      typeSports: '체육',
      typeMath: '수학',
      typeScience: '과학',
      typeCoding: '코딩',
      typeTutoring: '과외',
      stepCurriculum: '커리큘럼',
      stepTuition: '수강료',
      stepInstructor: '강사소개',
      onlineAvailable: '온라인 수업 가능',
    },
  },
  education: {
    title: '자녀 교육 정보',
    tabSchool: '학교',
    tabAcademy: '학원',
    tabTutoring: '과외',
    tabInfo: '교육 정보',
    schoolDesc: '다낭·하노이·호치민 지역 학교 목록을 확인하세요',
    academyDesc: '한국어·영어·수학 등 다양한 학원을 찾아보세요',
    tutoringDesc: '1:1 개인 과외 선생님을 찾아보세요',
    goToSchoolList: '학교 목록 보기',
    goToAcademy: '학원 목록 보기',
    goToTutoring: '과외 선생님 찾기',
    typeInternational: '국제학교',
    typeKorean: '한국학교',
    typeLocal: '현지학교',
    typeHomeschool: '홈스쿨',
    infoAdmission: '입학 시즌 안내',
    infoAdmissionDesc: '국제학교 입학 시즌과 준비 사항',
    infoTuition: '학비 안내',
    infoTuitionDesc: '학교 유형별 평균 학비 범위',
    infoCurriculum: '커리큘럼 비교',
    infoCurriculumDesc: 'IB·AP·한국·베트남 교육과정 비교',
    infoConsult: '학원 상담',
    infoConsultDesc: '학원 등록 및 과외 연결',
  },
  villa: {
    title: '풀빌라',
    heroTitle: '프라이빗 풀빌라',
    heroDesc: '교민 특가 풀빌라 · 직거래 · 수수료 없음',
    searchPlaceholder: '빌라명, 위치 검색',
    guests: '인원',
    guestsUnit: '명',
    typeAll: '전체',
    typePrivate: '프라이빗',
    typeShared: '공유형',
    typeBeach: '해변',
    typeMountain: '산뷰',
    sortRecommended: '추천순',
    sortPriceAsc: '가격 낮은순',
    sortRating: '별점순',
    count: '빌라 {n}개',
    empty: '조건에 맞는 풀빌라가 없습니다',
    verified: '인증',
    bedrooms: '침실',
    maxGuests: '최대 {n}명',
    perNight: '박',
    notFound: '풀빌라를 찾을 수 없습니다',
    reviews: '후기',
    bathrooms: '욕실',
    poolSize: '풀 크기',
    pricePerNight: '1박 요금',
    pricePerWeek: '주간 요금',
    checkInOut: '체크인/아웃',
    checkIn: '체크인',
    checkOut: '체크아웃',
    minStay: '최소 {n}박 이상',
    amenities: '편의시설',
    description: '소개',
    ownerMenu: '관리',
    editVilla: '빌라 정보 수정',
    inquirySent: '문의 채팅을 시작합니다',
    inquiryBtn: '문의하기',
    registerTitle: '풀빌라 등록',
    stepType: '어떤 빌라인가요?',
    stepBasic: '기본 정보',
    stepPrice: '가격 및 운영',
    stepContact: '연락처 및 확인',
    villaName: '빌라 이름',
    villaNamePlaceholder: '예: 미케비치 프라이빗 풀빌라',
    location: '위치',
    locationPlaceholder: '예: 다낭 미케비치 근처',
    address: '상세 주소',
    addressPlaceholder: '상세 주소 (선택)',
    maxGuestsLabel: '최대 인원',
    poolType: '풀 종류',
    descriptionPlaceholder: '빌라 특징, 주변 환경, 특이사항 등을 적어주세요',
    minStayLabel: '최소 숙박',
    nights: '박',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    contactZalo: 'Zalo',
    registerNoticeTitle: '등록 전 확인사항',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '허위 정보 등록 시 계정이 제한될 수 있습니다',
    registerNotice3: '문의는 채팅을 통해 직접 연결됩니다',
    registerSuccess: '풀빌라가 등록됐습니다. 검토 후 승인됩니다',
    registerFail: '등록에 실패했습니다',
    registerSubmit: '등록 신청하기',
    registerDesc: '풀빌라를 운영하세요?',
    registerBtn: '업체 등록하기',
  },
  interior: {
    registerTitle: '인테리어 업체 등록',
    stepWorkType: '어떤 시공을 하시나요?',
    stepWorkTypeDesc: '복수 선택 가능합니다',
    specialties: '전문 분야',
    stepBasic: '업체 기본 정보',
    bizName: '업체명',
    bizNamePlaceholder: '예: 다낭 인테리어 전문',
    contact: '연락처',
    address: '주소',
    addressPlaceholder: '사무실 또는 작업 지역',
    hours: '운영 시간',
    languages: '상담 가능 언어',
    description: '업체 소개',
    descriptionPlaceholder: '경력, 시공 사례, 강점 등을 소개해주세요',
    stepScope: '시공 규모 및 가격대',
    areaRange: '시공 가능 규모',
    priceRange: '가격대',
    responseRate: '응답률',
    stepConfirm: '등록 확인',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '허위 정보 등록 시 계정이 제한됩니다',
    registerNotice3: '승인 후 인테리어 목록에 노출됩니다',
    registerSuccess: '등록 신청이 완료됐습니다. 검토 후 승인됩니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
  },
  restaurant: {
    title: '맛집/식당',
    typeKorean: '🍜 한식',
    typeJapanese: '🍣 일식',
    typeChinese: '🥢 중식',
    typeWestern: '🍝 양식',
    typeVietnamese: '🍜 베트남식',
    typeItalian: '🍕 이탈리안',
    typeMexican: '🌮 멕시칸',
    typeIndian: '🍛 인도식',
    typeFusion: '🍱 퓨전',
    typeCafe: '☕ 카페',
    typeBar: '🍺 바/펍',
    typeBakery: '🥐 베이커리',
    typeFastFood: '🍔 패스트푸드',
    typeOther: '🍽️ 기타',
    priceBudget: '저렴',
    priceMedium: '보통',
    priceExpensive: '비싼',
    priceLuxury: '럭셔리',
    priceCard_budget: '💚 저렴 (1인 $5 이하)',
    priceCard_medium: '💛 보통 (1인 $5~15)',
    priceCard_expensive: '🧡 비싼 (1인 $15~30)',
    priceCard_luxury: '❤️ 럭셔리 (1인 $30+)',
    delivery: '배달가능',
    reservation: '예약가능',
    parking: '주차가능',
    koreanFriendly: '한국어 가능',
    verified: '인증',
    ratingTaste: '맛',
    ratingService: '서비스',
    ratingPrice: '가격',
    ratingAtmosphere: '분위기',
    menu: '메뉴',
    popularMenu: '인기메뉴',
    reserveNow: '예약하기',
    selectDate: '날짜 선택',
    selectTime: '시간 선택',
    partySize: '인원',
    requests: '요청사항',
    registerCta: '식당 등록',
    noRestaurants: '등록된 식당이 없어요',
    reservationConfirmed: '예약이 완료되었습니다!',
    searchPlaceholder: '식당명, 음식 종류 검색',
    openNow: '영업중',
    closedNow: '영업종료',
    reviewCount: '리뷰 {n}건',
    menuPreview: '대표 메뉴',
    priceFilter: '가격대',
    favorited: '찜했어요',
    unfavorited: '찜 해제했어요',
    favorite: '찜하기',
    favoriteShort: '찜',
    demoFavorite: '데모 식당은 찜만 표시돼요',
    galleryAll: '전체보기 {n}장',
    galleryTitle: '사진 전체',
    keyInfo: '핵심 정보',
    hours: '영업시간',
    location: '위치',
    phone: '전화',
    languages: '언어지원',
    payment: '결제방법',
    locationSection: '위치',
    mapPreview: '지도 미리보기',
    hoursSection: '운영시간',
    closedDays: '휴무',
    todayStatus: '오늘',
    confirmReservation: '예약 확정',
    fillDateTime: '날짜와 시간을 선택해 주세요',
    yes: '가능',
    no: '불가',
    registerFlowTitle: '식당 등록',
    stepLabel: '{cur} / {total} 단계',
    register: {
      stepLabel: '단계',
      typeKorean: '한식',
      typeJapanese: '일식',
      typeChinese: '중식',
      typeWestern: '양식',
      typeVietnamese: '베트남식',
      typeItalian: '이탈리안',
      typeMexican: '멕시칸',
      typeIndian: '인도식',
      typeFusion: '퓨전',
      typeCafe: '카페',
      typeBar: '바/펍',
      typeBakery: '베이커리',
      typeFastFood: '패스트푸드',
      typeOther: '기타',
      priceLow: '저렴',
      priceMid: '보통',
      priceHigh: '고급',
      priceLuxury: '럭셔리',
    },
    registerOk: '식당이 등록되었어요',
    registerDemoOk: '데모 모드: 등록이 시뮬레이션되었어요',
    nameLabel: '식당명',
    descLabel: '소개글',
    menuTagsLabel: '대표 메뉴/태그',
    menuTagsPh: '예: 불고기, 쌀국수',
    open24: '24시간 영업',
    closedDaysLabel: '휴무일',
    amenityCard: '카드결제',
    amenityGroup: '단체석',
    amenityAlcohol: '주류판매',
    amenityNonsmoke: '금연구역',
    langKo: '🇰🇷 한국어',
    langEn: '🇺🇸 영어',
    langVi: '🇻🇳 베트남어',
    langRu: '🇷🇺 러시아어',
    langJa: '🇯🇵 일본어',
    menuName: '메뉴명',
    menuPrice: '가격(USD)',
    menuDesc: '설명',
    menuImageUrl: '이미지 URL',
    addMenu: '메뉴 추가',
    photoExterior: '외관 사진 URL',
    photoInterior: '내부/인테리어 URL',
    photoFood: '음식 사진 URL',
    photoMenuBoard: '메뉴판 URL',
    phoneLabel: '전화번호',
    kakaoLabel: '카카오톡 ID',
    instaLabel: '인스타그램',
    webLabel: '웹사이트',
  },
  businessInbox: {
    title: '문의 수신함',
    all: '전체',
    unread: '미읽음',
    booking: '예약문의',
    general: '일반문의',
    done: '완료',
    empty: '아직 문의가 없어요',
    emptyDesc: '업체 정보를 업데이트하면 더 많은 문의를 받을 수 있어요!',
    replyChat: '채팅으로 답변',
    replyCall: '전화하기',
    markDone: '완료 처리',
    newInquiry: '새 문의가 왔어요!',
    inquiryType: '문의 유형',
    typeBooking: '예약문의',
    typeGeneral: '일반문의',
    typeQuote: '견적문의',
    filter: '필터',
    filterByBusiness: '업체로 필터',
    allBusinesses: '전체 업체',
    detailTitle: '문의 상세',
    sentAt: '접수 시각',
    message: '문의 내용',
    statusPending: '대기중',
    statusRead: '읽음',
    statusClosed: '답변완료',
    noPhone: '등록된 전화번호가 없습니다.',
    send: '전송',
    viewAll: '전체 문의 보기',
    guideNoOwner: '가이드 연동 전에는 문의를 보낼 수 없어요.',
    inquirySent: '문의를 보냈어요.',
    hotelNoBusiness: '호스트 업체가 연결되어 있지 않아 문의를 보낼 수 없어요.',
    visaTab: '🛂 비자문의',
    visaInquiryPreview: '문의',
    visaReply: '답변하기',
    academyTab: '🎓 수업신청',
    academySubject: '수업과목',
    academyFormat: '수업형태',
    academySchedule: '희망일정',
    academyConfirm: '확정',
    academyReject: '거절',
    academyStatusPending: '대기',
    academyStatusConfirmed: '확정됨',
    academyStatusRejected: '거절됨',
    restaurantTab: '🍜 예약관리',
    restaurantConfirm: '확정',
    restaurantReject: '거절',
    restaurantStatusPending: '대기',
    restaurantStatusConfirmed: '확정됨',
    restaurantStatusRejected: '거절됨',
    restaurantParty: '인원',
    restaurantNotes: '요청사항',
    restaurantWhen: '예약일시',
  },
  biz: {
    tabOverview: '현황',
    tabManage: '관리',
    tabAds: '광고',
    tabShorts: 'AI쇼츠',
    tabPlan: '플랜',
    planFree: '무료',
    planBasic: '베이직',
    planPremium: '프리미엄',
    planFreePrice: '무료',
    perMonth: '월',
    planFreeF1: '업체 프로필 등록',
    planFreeF2: '기본 노출',
    planFreeF3: '채팅 문의 수신',
    planBasicF1: '무료 기능 전체',
    planBasicF2: '통계 대시보드',
    planBasicF3: '리뷰 관리',
    planBasicF4: '사진 무제한 업로드',
    planPremiumF1: '베이직 기능 전체',
    planPremiumF2: 'AI 쇼츠 자동 생성 월 4회',
    planPremiumF3: '검색 상단 노출',
    planPremiumF4: '밍고스토리 자동 업로드',
    planPremiumF5: '월간 성과 리포트',
    planTitle: '구독 플랜',
    currentPlan: '현재 플랜',
    planExpires: '만료일',
    planRecommended: '추천',
    planUpgrade: '업그레이드',
    planDowngrade: '다운그레이드',
    planCurrent: '현재 플랜',
    planUpgraded: '플랜이 변경됐습니다',
    planShortsLine: 'AI 쇼츠 월 {n}회',
    shortsLockedTitle: 'AI 쇼츠는 프리미엄 전용입니다',
    shortsLockedDesc:
      '매월 4개의 AI 쇼츠를 자동으로 생성해드립니다. 업체 사진과 텍스트만 제공하면 밍고가 대신 만들어드려요.',
    upgradeToPremium: '프리미엄으로 업그레이드',
    shortsUsage: '이번 달 사용',
    shortsPerMonth: '회/월',
    requestShorts: '쇼츠 생성 요청',
    shortsEmpty: '아직 생성된 쇼츠가 없습니다',
    shortsPending: '대기 중',
    shortsProcessing: '생성 중',
    shortsCompleted: '완료',
    shortsFailed: '실패',
    requestShortsTitle: 'AI 쇼츠 생성 요청',
    shortsText: '업체 소개 / 홍보 문구',
    shortsTextPlaceholder: '업체 특징, 이벤트, 홍보하고 싶은 내용을 입력하세요',
    shortsRequested: 'AI 쇼츠 생성이 요청됐습니다. 완료 시 알림을 드립니다',
    requestShortsSubmit: '요청하기',
    myAdsSummary: '내 광고 현황',
    totalImpressions: '총 노출',
    totalClicks: '총 클릭',
    activeAds: '활성 광고',
    noAds: '등록된 광고가 없습니다',
    adActive: '게재 중',
    adPending: '검토 중',
    adInactive: '중단',
  },
  dashboard: {
    title: '업체 대시보드',
    myBusinesses: '내 업체',
    manage: '관리하기',
    managePanel: '업체 관리',
    noBusiness: '등록된 업체가 없습니다',
    stats: '통계',
    statsSummary: '요약 통계',
    periodStats: '기간별 실적',
    statsViewsToday: '오늘 조회수',
    statsViews7d: '7일 조회수',
    statsViews30d: '30일 조회수',
    statsInquiry: '문의수',
    statsFavorite: '찜수',
    statsReview: '리뷰',
    reviews: '리뷰 관리',
    reviewsUnifiedHint: '통합 업체 리뷰(public.reviews)만 표시됩니다. 병원·맛집 등 도메인 전용 리뷰는 해당 상세 페이지에서 확인하세요.',
    reviewsEmpty: '아직 리뷰가 없습니다',
    ownerReply: '사장님 답글',
    writeReply: '답글 작성',
    reportReview: '신고',
    replyPlaceholder: '답글을 입력하세요',
    businessName: '업체명',
    category: '카테고리',
    nameChangeHint: '업체명 변경은 재심사가 필요합니다',
    categoryChangeHint: '카테고리 변경은 재심사가 필요합니다',
    photos: '대표사진',
    photosPlaceholder: '이미지 URL을 한 줄에 하나씩 입력',
    hours: '영업시간',
    description: '소개글',
    contact: '연락처',
    editInfo: '기본정보 수정',
    today: '오늘',
    week: '이번 주',
    month: '이번 달',
    views: '조회수',
    orders: '주문',
    revenue: '매출',
    rating: '평점',
    ads: '광고 관리',
    newAd: '광고 만들기',
    impressions: '노출수',
    clicks: '클릭수',
    ctr: '클릭률',
    notifications: '알림',
    inquirySection: '문의 현황',
    inquiryUnread: '미읽은 문의',
    inquiryRecent: '최근 문의',
    inquiryViewAll: '전체 문의 보기',
    bookings: '예약 현황',
    noShow: '노쇼 신고',
  },
  subscription: {
    title: '구독 플랜',
    current: '현재 플랜',
    upgrade: '업그레이드',
    expires: '만료일',
    free: '무료',
    silver: '실버',
    gold: '골드',
    business: '비즈니스',
    commission: '수수료',
    commissionHistory: '수수료 내역',
    adCredit: '광고 크레딧',
    convertPoints: '포인트로 크레딧 충전',
    adPromote: '내 업체를 광고해보세요!',
    adPromoteBtn: '광고 시작하기',
  },
  guide: {
    title: '교민 가이드',
    verified: '인증 가이드',
    book: '예약하기',
    chat: '채팅하기',
    halfDay: '반일',
    fullDay: '종일',
    custom: '맞춤',
    reviews: '리뷰',
    rating: '평점',
    languages: '가능 언어',
    regions: '활동 지역',
    priceFrom: '부터',
    noGuides: '등록된 가이드가 없어요',
    emptyListTitle: '현재 등록된 가이드가 없습니다',
    emptyListDescription: '가이드 입점을 준비 중입니다. 곧 만나요!',
    filterAllRegions: '전체',
    filterAllLangs: '언어 전체',
    filterAllTours: '투어 전체',
    regionDaNang: '다낭',
    regionHoiAn: '호이안',
    regionHue: '후에',
    langKorean: '한국어',
    langEnglish: '영어',
    langRussian: '러시아어',
    langVietnamese: '베트남어',
    emptyFilterHint: '지역/언어 필터를 바꿔보세요.',
    verifiedPill: '✓ 인증가이드',
    expertiseRegion: '전문 지역: {region}',
    priceHalfFull: '반일 {half} / 종일 {full}',
    demoGuide1Name: '김민수',
    demoGuide1Intro: '다낭 로컬 맛집/야시장/시내 코스를 전문으로 안내합니다.',
    demoGuide2Name: '이나타샤',
    demoGuide2Intro: '호이안 올드타운/야경/사진 스팟 투어를 제공합니다.',
    demoGuide3Name: 'Tran Van Nam',
    demoGuide3Intro: '후에 왕궁/역사 문화 투어를 맞춤 일정으로 진행합니다.',
    register: {
      title: '가이드 등록',
      stepServiceType: '서비스 유형',
      stepBasicInfo: '기본정보',
      stepRegion: '활동 지역',
      stepLanguage: '언어',
      stepService: '서비스 소개',
      stepPricing: '요금',
      stepCareer: '경력/자격',
      stepPhotos: '프로필 사진',
      stepConfirm: '최종확인',
      namePlaceholder: '이름을 입력하세요',
      nationalityPlaceholder: '국적을 입력하세요',
      regionPlaceholder: '활동 지역을 입력하세요',
      descriptionPlaceholder: '서비스를 소개해주세요',
      careerPlaceholder: '경력과 자격을 입력하세요',
      submit: '등록하기',
      typeTour: '투어가이드',
      typeInterpreter: '통역',
      typeAirport: '공항픽업',
      typeCompanion: '동행서비스',
      typeOther: '기타',
      priceHourly: '시간당',
      priceHalfDay: '반일',
      priceFullDay: '일일',
      lang: {
        korean: '한국어',
        english: '영어',
        vietnamese: '베트남어',
        russian: '러시아어',
        japanese: '일본어',
        chinese: '중국어',
        other: '기타',
      },
    },
  },
  property: {
    inquirySentToast: '문의가 전송되었습니다.',
    footerWish: '찜',
    wishlisted: '찜 목록에 저장했어요',
    unwishlisted: '찜을 해제했어요',
    footerCall: '전화하기',
    footerChat: '채팅문의',
    noPhone: '등록된 전화번호가 없습니다.',
    dashTitle: '매물 관리',
    dashRegister: '매물 등록',
    dashStatusFilter: '매물 상태',
    dashStatusAll: '전체',
    dashEmpty: '아직 등록된 매물이 없어요',
    dashEmptySub: '매물을 등록하면 /real-estate 목록에 노출돼요',
    dashEmptySubPersonal: '집주인·세입자(승계·양도) 매물을 등록하면 /real-estate에 노출돼요',
    myListingsSub: '집주인·세입자·업체로 등록한 매물을 한곳에서 관리해요',
    dashLoadFailed: '매물 목록을 불러오지 못했어요.',
    dashFirstRegister: '첫 매물 등록',
    dashFilterEmpty: '선택한 조건의 매물이 없어요',
    dashShowAll: '전체 보기',
    dashOwnerBarTitle: '내 매물 관리',
    dashEdit: '수정',
    dashView: '보기',
    dashDelete: '삭제',
    dashTradeComplete: '거래완료',
    dashDeleteConfirm: '이 매물을 삭제할까요? 목록에서 숨겨집니다.',
    dashDeleteDone: '매물을 삭제했어요.',
    dashDeleteFailed: '삭제하지 못했어요.',
    dashTradeConfirmTitle: '거래를 완료할까요?',
    dashTradeConfirmBody: '완료 후 공개 목록에서 내려가고 거래완료로 표시됩니다.',
    dashTradeDone: '거래완료로 표시했어요.',
    dashBoost7: '7일 부스트 ({price}P)',
    dashBoost14: '14일 부스트 ({price}P)',
    dashBoostActive: '부스트 중 ({date}까지)',
    dashBoostSuccess: '매물을 상단으로 부스트했어요.',
    dashBoostFail: '부스트에 실패했어요.',
    dashBoostInsufficientCredit: '광고 크레딧이 부족해요.',
    statusPublished: '노출중',
    statusPendingReview: '검토중',
    statusHidden: '숨김',
    statusDraft: '비공개',
    statusCompleted: '거래완료',
    dealCompletedNote: '이 매물은 거래가 완료되었습니다.',
    detailTitle: '매물 상세',
    optionsSelectedOnly: '등록 시 선택한 옵션만 표시됩니다.',
    hubListingsTitle: '등록 매물',
    hubListingsSub: '업체가 아닌 개인·업체 매물은 여기와 /real-estate 에 노출됩니다',
    hubBrowseAll: '전체 보기',
    hubListingsEmpty: '아직 공개된 매물이 없어요. 첫 매물을 등록해 보세요.',
    footerInquiryShort: '✉️ 문의',
    inquiryModalTitle: '매물 문의',
    inquiryTypeLabel: '문의 유형',
    inquiryTypeRent: '🔑 임대 문의',
    inquiryTypeVisit: '📅 방문 예약',
    inquiryTypeGeneral: '💬 일반 문의',
    inquiryMoveInLabel: '희망 입주일',
    inquiryMessageLabel: '메시지',
    inquiryMessagePlaceholder: '문의 내용을 입력해 주세요.',
    inquiryCancel: '취소',
    inquirySending: '전송 중…',
    inquirySend: '전송',
    availabilityButton: '아직 있나요?',
    availabilityCount: '확인 요청 {n}회',
    availabilitySentToast: '확인 요청을 보냈어요. 임대인이 답변하면 알려드릴게요.',
    availabilityInquiryMessage: '아직 거래 가능한 매물인지 확인 부탁드립니다.',
  },
  serviceMenu: {
    profileFallback: '내 프로필',
    ariaProfile: '내정보',
    followCounts: '팔로잉 {following} · 팔로워 {followers}',
    loginSignup: '로그인 / 회원가입',
  },
  listings: {
    hubTitle: '서비스 카테고리',
    hubIntro:
      '카테고리를 선택한 뒤에만 해당 리스트를 불러옵니다. 카탈로그는 기기에 잠시 저장되어 같은 날 다시 열면 서버 호출이 줄어듭니다.',
    loadError: '목록을 불러오지 못했습니다.',
    emptyCategories: '표시할 카테고리가 없습니다',
    emptyCategoriesHint: 'Supabase의 categories 테이블에 active=true인 행을 추가해 주세요.',
    emptyLifeNavHint:
      '마이그레이션 20260613을 적용해 type=life_nav 카테고리를 넣거나, Supabase에서 active=true로 켜 주세요.',
    noListingCategories: '통합 리스트로 볼 카테고리가 없습니다',
    addLifeNavHint: 'listings와 연결할 life_nav 행을 추가하세요(/listings 항목 제외).',
    categoryTitle: '리스팅',
    emptyList: '등록된 글이 없습니다',
    emptyListHint: 'listings 테이블에 공개 글이 있으면 여기에 표시됩니다.',
    verified: '검증',
    badCategory: '잘못된 링크입니다',
    badCategoryHint: '생활정보 화면에서 카테고리를 다시 선택해 주세요.',
    notFound: '글을 찾을 수 없습니다',
    notFoundHint: '삭제되었거나 비공개 처리된 글일 수 있습니다.',
    backToCategory: '이 카테고리 목록으로',
  },
  expatInfo: {
    title: '교민 필수 정보',
    heroTitle: '교민 필수 정보',
    heroDesc: '비자·의료·법률·정착까지\n해외 생활의 모든 정보',
    essentialTitle: '교민 필수 바로가기',
    searchPlaceholder: '비자, 의료, 법률 등 검색',
    noResults: '검색 결과가 없습니다',
    urgentTitle: '긴급/필수 정보',
    urgentDesc: '긴급 상황 발생 시 즉시 확인하세요',
    categoriesTitle: '카테고리별 정보',
    featuredTitle: '꼭 알아야 할 정보',
    empty: '등록된 정보가 없습니다',
    emptyHint: '곧 더 많은 정보가 추가될 예정입니다',
    guideCount: '가이드 {n}개',
    notFound: '정보를 찾을 수 없습니다',
    urgent: '긴급',
    lastVerified: '최신화',
    outdatedWarning: '오래된 정보일 수 있습니다',
    linkCopied: '링크가 복사됐습니다',
    bookmark: '북마크',
    bookmarkAdded: '북마크에 추가됐습니다',
    bookmarkRemoved: '북마크가 해제됐습니다',
    reportOutdated: '정보가 오래됐나요? 신고하기',
    reportSent: '신고가 접수됐습니다',
    relatedFeatures: '관련 기능',
    relatedLinks: '관련 링크',
    quick: {
      passportLoss: '여권분실',
      accident: '교통사고',
      medical: '의료',
      visa: '비자',
      legal: '법률',
      settle: '정착',
      fraud: '사기피해',
    },
    cat: {
      visa: '비자/체류',
      emergency: '긴급/안전',
      medical: '의료/건강',
      legal: '법/행정',
      family: '가족/신분',
      settle: '정착 가이드',
      finance: '재정/세금',
      embassy: '대사관',
    },
    essential: {
      visaStay: {
        title: '비자/체류',
        desc: '비자, 체류 규정, 연장 절차',
      },
      legalAdmin: {
        title: '법/행정',
        desc: '행정 신고, 법률 기본 안내',
      },
      schoolInfo: {
        title: '학교정보',
        desc: '국제학교, 학원, 등록 정보',
      },
      medicineInfo: {
        title: '약품정보',
        desc: '약국, 일반의약품, 복용 주의',
      },
      repatriateInfo: {
        title: '귀국정보',
        desc: '귀국 준비, 서류, 정착 체크리스트',
      },
    },
    legalAdminPage: {
      title: '법/행정 필수 정보',
      subtitle: '교민 생활에서 자주 필요한 행정/법률 체크 항목',
      coreTasksTitle: '자주 쓰는 업무 바로가기',
      cards: {
        visa: {
          title: '비자/체류 확인',
          desc: '체류 상태, 비자 유형, 최신 안내 확인',
        },
        expiry: {
          title: '기간 만료 알림',
          desc: '비자, 여권 등 만료 전 일정 관리',
        },
        privacy: {
          title: '개인정보/이용약관',
          desc: '서비스 이용 관련 기본 법적 문서 확인',
        },
        sos: {
          title: '긴급 도움 요청',
          desc: '위급 상황 시 즉시 도움 요청',
        },
      },
    },
    schoolInfoPage: {
      title: '학교 기본 정보',
      subtitle: '한인학교, 국제학교, 현지학교 선택 가이드',
      typesTitle: '학교 유형별 핵심 안내',
      types: {
        korean: {
          icon: '🇰🇷',
          title: '한인학교',
          desc: '한국 학제/교과 기반으로 적응이 빠른 편',
          point1: '귀국/재입국 시 학제 연계가 비교적 수월',
          point2: '지역별 개설 여부와 대기 인원 확인 필요',
        },
        international: {
          icon: '🌍',
          title: '국제학교',
          desc: '영어 중심 커리큘럼(IB/AP 등) 선택 가능',
          point1: '학비/입학 테스트/영어 기준 확인 필요',
          point2: '대학 진학 트랙과 과외 활동 비교 권장',
        },
        local: {
          icon: '🇻🇳',
          title: '현지학교',
          desc: '현지 언어/문화 적응에 유리하고 비용 부담이 낮음',
          point1: '수업 언어 적응 계획을 먼저 세우는 것이 중요',
          point2: '통학 거리와 학사 일정 차이 확인 필요',
        },
      },
      checklistTitle: '입학 전 체크리스트',
      checklist: {
        admission: {
          title: '입학 일정',
          item1: '학기 시작일/원서 마감일/시험 일정을 확인하세요',
          item2: '중간 전학 가능 여부와 결원 규정을 확인하세요',
        },
        documents: {
          title: '준비 서류',
          item1: '여권, 비자, 예방접종 기록, 성적표를 준비하세요',
          item2: '공증/번역이 필요한 서류를 사전에 점검하세요',
        },
      },
      openSchoolList: '학교 리스트 보기',
    },
  },

  local: {
    title: '생활정보',
    subtitle: '해외 생활의 모든 것',
    allServices: '전체 서비스',
    catTrade: '거래/쇼핑',
    catLife: '생활/서비스',
    catSports: '스포츠/레저',
    catBooking: '예약/티켓',
    catMedical: '의료/교육',
    catFreelance: '프리랜서/재능',
    catBusiness: '비즈니스/전문',
    catCreator: '크리에이터',
    catCommunity: '커뮤니티',
    emergencySection: '🆘 긴급/안전',
    sectionEmergency: '🆘 긴급/안전',
    sectionBusiness: '📋 현지 업체 찾기',
    businessSection: '🏪 현지 업체 찾기',
    sectionInfo: '📖 교민 정보',
    sectionCommunity: '👥 교민 생활',
    communitySection: '👥 교민 생활',
    listingsHub: 'DB 통합 리스팅',
    lostFound: '분실물',
    medicine: '약품 정보',
    hospital: '병원/약국',
    food: '맛집',
    visa: '비자/행정',
    beauty: '미용/마사지',
    move: '청소/이사',
    realestate: '부동산',
    repatriate: '귀국정보',
    rental: '렌탈',
    academy: '학원/교육',
    supermarket: '슈퍼마켓/마트',
    dental: '치과',
    laundry: '세탁소',
    repair: '에어컨/가전수리',
    babysitter: '베이비시터/육아',
    translation: '통역/번역',
    guideMarket: '가이드 마켓',
    sos: 'SOS 요청',
    emergency: '긴급연락처',
    emergencyContacts: '긴급연락처',
    expiry: '기간 만료',
    expatInfo: '교민정보',
    expatInfoTitle: '교민 필수 정보',
    schools: '자녀 교육',
    remittance: '송금 비교',
    visaGuide: '비자 가이드',
    mentoring: '멘토링',
    news: '교민 뉴스',
    deals: '공동구매/딜',
    cooking: '레시피',
    visaRun: '비자런 모집',
    businessTransfer: '업체 승계',
    groupDelivery: '한국 직구 공동배송',
    interpreter: '통역 서비스',
    golf: '골프/회원권',
    poolVilla: '풀빌라',
    activity: '액티비티',
    tours: '투어',
    fitness: '피트니스',
    visaAgency: '비자 대행',
    pet: '반려동물',
    petLabel: '펫서비스',
    categoryExperience: '체험',
    categoryMedical: '의료',
    categoryFitnessSport: '운동',
    categoryTravel: '여행',
    categoryAdmin: '행정',
    interior: '인테리어',
    interiorSearchPlaceholder: '업체명, 전문분야 검색',
    interiorCount: '업체 {n}개',
    interiorEmpty: '등록된 인테리어 업체가 없습니다',
    interiorRegisterDesc: '인테리어 업체를 운영하세요?',
    interiorRegisterBtn: '업체 등록하기',
    businessSearchPlaceholder: '업체 검색',
    searchNoResultsTitle: '검색 결과가 없어요',
    callPhone: '전화하기',
    listLanguageExp: '언어 {language} · 경력 {exp}',
    repairOnsiteLine: '출장 {status}',
    onsiteAvailable: '가능',
    onsiteUnavailable: '불가',
    translationPairLine: '언어쌍 {pair}',
  },
  localInfo: {
    lostFound: '분실물',
    medicine: '약품 정보',
  },
  expansion: {
    weatherAria: '날씨 및 알림',
    weatherLoading: '날씨 불러오는 중…',
    weatherError: '날씨를 불러올 수 없습니다. 홈에서 당겨서 다시 시도하세요.',
    weatherLocation: '다낭 지역',
    weatherToday: '오늘',
    weatherTomorrow: '내일',
    weatherRefresh: '새로고침',
    weatherSource: '예보: Open-Meteo(무담보).',
    sosFab: '긴급 SOS',
    sosSheetTitle: '어떤 도움이 필요하신가요?',
    sosHint: '생명이 위급하면 먼저 현지 긴급번호에 연락하세요.',
    sosToast: 'SOS: {type} — 긴급 연락처로 이동합니다.',
    sosType: {
      medical: '의료',
      scam: '사기·사기 도움',
      legal: '법률',
      lost: '분실',
    },
    airportTitle: '공항 픽업',
    airportIntro: '일부 업체에서 한국어 가능 기사를 제공합니다.',
    carpoolTitle: '카풀',
    carpoolIntro: '도시·공항 간 동승을 나눕니다. 결제는 추후 오픈 예정입니다.',
    carpoolPostSoon: '동승 글 올리기(준비 중)',
    carpoolSeats: '남은 좌석 {n}석',
    carpoolJoin: '동승 신청',
    carpoolJoinSoon: '예약은 이후 업데이트에서 열립니다.',
    insuranceTitle: '보험',
    insuranceIntro: '파트너 링크를 누르면 신청 시 Mingo에 수수료가 발생할 수 있습니다(제휴).',
    insuranceType: { travel: '여행보험', health: '건강보험', property: '주택·가재' },
    compareApply: '견적 받기(외부)',
    affiliateToast: '파트너 열기: {name}',
    remittanceTitle: '송금 비교',
    remittanceIntro: '경로와 수수료를 비교합니다. 링크는 제휴 배치입니다.',
    remittanceRate: '참고 환율',
    remittanceFee: '수수료',
    remittanceSpeed: '소요',
    remittanceOpen: '제공사 사이트 열기',
    dealsTitle: '특가/딜',
    dealsIntro: '파트너 한정 혜택 — 카운트다운은 참고용입니다.',
    dealsEnds: '마감까지',
    dealsSold: '{sold} / {total} 참여',
    dealBuy: '구매·예약',
    dealBuySoon: '결제는 이후 업데이트에서 열립니다.',
    settlementTitle: '정착 패키지',
    settlementIntro: '검증 코디네이터의 입주·이주 번들입니다.',
    settlementDays: '일 프로그램',
    settlementIncludes: '포함 사항',
    schoolListTitle: '학교 목록',
    schoolTypeLabel: '학교 유형',
    schoolFilterCurr: '교육과정',
    schoolFilterLang: '수업 언어',
    schoolMaxTuition: '연 최대 학비(USD): {max}',
    schoolComparePick: '{n}개 선택(최대 3)',
    schoolCompareGo: '비교',
    schoolCompareAdd: '비교',
    schoolDetailTitle: '학교 상세',
    schoolCurriculum: '교육과정',
    schoolGrades: '학년·연령',
    schoolWebsite: '웹사이트',
    schoolTuitionTable: '학비 및 비용',
    schoolGradeCol: '단계',
    schoolAnnual: '연 학비',
    schoolEnrollment: '입학·기타',
    schoolParentReviews: '학부모 리뷰',
    schoolNoReviews: '아직 리뷰가 없습니다.',
    schoolRatingsBreakdown: '학업 {a} · 시설 {f} · 교사 {te} · 가성비 {v}',
    schoolPros: '장점',
    schoolCons: '단점',
    schoolAnon: '익명 학부모',
    schoolNamed: '학부모',
    schoolInquiry: '입학 문의',
    schoolChildAge: '자녀 나이',
    schoolChildGrade: '현재/희망 학년',
    schoolDesiredStart: '희망 입학 시기',
    schoolInquirySoon: '문의 보내기(준비 중)',
    schoolSimilar: '비슷한 학교',
    schoolCompareTitle: '학교 비교',
    schoolCompareNeedTwo: '목록에서 학교를 두 곳 이상 고른 뒤 비교를 여세요.',
    schoolCompareCol: '항목',
    schoolTuitionRange: '학비 범위',
    schoolType: {
      all: '전체',
      kindergarten: '유치원',
      elementary: '초등',
      middle: '중등',
      high: '고등',
      international: '국제학교',
      alternative: '대안·주말',
      academy: '학원',
      tutoring: '과외·STEM',
    },
    currFilter: { all: '전체 교육과정', IB: 'IB', AP: 'AP', US: '미국식', KR: '한국 과정', VN: '베트남' },
    eduConsultTitle: '교육 상담',
    eduConsultIntro: '후보 학교, 에세이, 면접을 1:1로 안내합니다.',
    eduConsultSchools: '학교 전문 분야',
    eduConsultPerSession: '/ 회',
    eduConsultApplySoon: '세션 예약(준비 중)',
    fitnessTitle: '피트니스',
    fitnessTab: { all: '전체', gym: '헬스장', yoga: '요가', pool: '수영·풀' },
    fitnessMonthly: '월 회원',
    fitnessDay: '일일 입장',
    fitnessDetailSoon: '시설 상세 페이지는 곧 제공됩니다.',
    homeDealsTitle: '오늘의 딜',
    homeRecTitle: '추천 업체',
  },
  extendedDetail: {
    revenueAria: '신뢰 및 수익화',
    premiumPinned: '상단 노출',
    verifiedBiz: '밍고 인증 업체',
    notifyCta: '예약 오픈 시 알림받기',
    notifyOn: '알림이 설정됐습니다',
    notifySaved: '저장됐습니다. 알려드릴게요.',
    reviewCta: '리뷰 작성하고 포인트 받기',
    reviewPointsHint: '리뷰는 다른 교민에게 도움이 되고 포인트를 받을 수 있습니다.',
    comingSoon: '준비 중',
  },
  exchangeAlert: {
    title: '환율 알림',
    lead: '목표 환율에 도달하면 앱 내 알림을 받으세요.',
    current: '현재 환율 (참고)',
    target: '목표 환율',
    above: '목표 이상일 때 알림 (해제 시 이하)',
    premiumUnlimited: '무료: 알림 1개. 프리미엄: 무제한 (멤버십 출시 예정).',
    add: '알림 저장',
    saved: '알림이 저장됐습니다.',
    limitFree: '무료 계정은 활성 알림 1개까지 가능합니다.',
    mine: '내 알림',
    empty: '설정된 알림이 없습니다.',
    remove: '삭제',
    notified: '알림 완료',
    inAppNote: '앱 실행 시 환율을 확인합니다. 최적의 경험을 위해 알림 설정에서 푸시 알림을 허용해주세요.',
    loginHint: '알림 설정은 로그인 후 이용 가능합니다.',
  },
  currencyExchange: {
    title: '환전소',
    writeTitle: '환전 글쓰기',
    writeHint: '환전 조건을 자세히 적으면 더 빨리 매칭됩니다.',
    needTitle: '환전 요청',
    have: '보유 통화',
    want: '원하는 통화',
    rateOptional: '환율 (선택)',
    amountMin: '최소 금액',
    amountMax: '최대 금액',
    locationLabel: '만날 장소',
    rate: '환율',
    views: '조회',
    doneN: '완료',
    badgeTop: '상단',
    badgeUrgent: '긴급',
    badgeVerified: '인증',
    untitled: '제목 없음',
    reportThis: '신고',
    reportToast: '신고가 접수됐습니다.',
    reportCta: '신고하기',
    tab_all: '전체',
    tab_popular: '인기',
    tab_urgent: '긴급',
    tab_done: '완료',
    filterVerified: '인증만',
    filterRating: '평점순',
    filterAmtMin: '최소 금액',
    filterAmtMax: '최대 금액',
    empty: '등록된 환전 글이 없습니다.',
    safetyTitle: '안전 거래 안내',
    safety1: '공공장소에서 만나세요.',
    safety2: '소액으로 먼저 테스트하세요.',
    safety3: '거래 후 영수증을 보관하세요.',
    partnersTitle: '공식 파트너',
    partnersLead: '인증된 환전 파트너입니다.',
    partnersCta: '파트너 문의',
    bannerSponsor: '{name}으로 더 저렴하게 보내기',
    bannerSub: '저렴한 해외 송금 — 파트너 링크',
    writeCta: '환전 글쓰기',
    alertsCta: '환율 알림 설정',
    premiumBlock: '프리미엄 기능',
    optTop: '상단 노출',
    optUrgent: '긴급 표시',
    optVerify: '인증 신청',
    premiumNote: '프리미엄 옵션은 멤버십 출시 후 이용 가능합니다.',
    detailTitle: '환전 상세',
    completeCta: '거래 완료',
    ownerNote: '작성자 안내',
    reviewLogin: '리뷰는 로그인 후 작성 가능합니다.',
    reviewDialog: '리뷰 작성',
    reviewLead: '거래 경험을 공유해주세요.',
    reviewText: '리뷰 내용',
    reviewThanks: '리뷰 감사합니다!',
    posterDefault: '교민',
    legalNoticeTitle: '법적 안내',
    legalNoticeBody: '본 서비스는 개인 간 환전 중개 플랫폼입니다. 밍고는 거래 당사자 간 분쟁에 책임이 없습니다.',
    writeRiskAgree: '위험 고지를 확인했습니다.',
    needRiskAgree: '요청 위험 고지를 확인했습니다.',
    writeAmountHint: '실제 보유 금액 범위를 입력하세요.',
    writeMeetHint: '만날 장소를 구체적으로 적어주세요.',
    reportAdminNote: '관리자 검토 후 처리됩니다.',
  },
  pet: {
    title: '펫 서비스',
    detailTitle: '펫 서비스 상세',
    registerTitle: '펫 서비스 등록',
    stepType: '어떤 서비스를 제공하시나요?',
    petTypes: '케어 가능 반려동물',
    stepService: '서비스 정보',
    serviceName: '서비스명',
    serviceNamePlaceholder: '예: 프리미엄 반려견 미용',
    serviceDesc: '서비스 소개',
    serviceDescPlaceholder: '서비스 내용, 경력, 특징을 소개해주세요',
    price: '가격',
    duration: '소요 시간',
    address: '위치/주소',
    addressPlaceholder: '서비스 제공 지역 또는 주소',
    languages: '상담 가능 언어',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    contactZalo: 'Zalo',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '승인 후 펫 서비스 목록에 노출됩니다',
    registerSuccess: '펫 서비스 등록이 완료됐습니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
    registerDesc: '펫 서비스를 제공하시나요?',
    registerBtn: '서비스 등록하기',
    cat: {
      all: '전체',
      vet: '동물병원',
      sitter: '펫시터',
      groom: '미용',
      train: '훈련',
      shop: '펫샵',
      adopt: '입양',
    },
    svcCat: {
      vet: '동물병원',
      sitter: '펫시터',
      groom: '미용',
      train: '훈련',
      shop: '펫샵',
    },
    species: {
      dog: '강아지',
      cat: '고양이',
    },
    male: '수컷',
    female: '암컷',
    vaccinated: '접종 완료',
    neutered: '중성화 완료',
    adoptionFee: '입양비',
    owner: '등록자',
    chatSeller: '등록자와 채팅',
    adoptionSection: '입양',
    animals: '반려동물 종류',
  },
  exp: {
    title: '체험/예약/티켓',
    heroTitle: '다낭 교민 추천 체험',
    heroDesc: '쿠킹클래스·서핑·투어·공연까지\n한국어로 즐기는 베트남',
    searchPlaceholder: '체험명, 카테고리 검색',
    catAll: '전체',
    catCooking: '쿠킹',
    catCraft: '공예',
    catSports: '스포츠',
    catTour: '투어',
    catWellness: '웰니스',
    catFood: '음식투어',
    catShow: '공연/쇼',
    catClass: '클래스',
    sortRating: '별점순',
    sortNewest: '최신순',
    sortPrice: '가격순',
    count: '{n}개',
    empty: '등록된 체험이 없습니다',
    registerFirst: '첫 번째로 등록하기',
    registerDesc: '체험/클래스를 운영하시나요?',
    registerBtn: '체험 등록하기',
    perPerson: '인',
    hours: '시간',
    maxGuests: '최대 {n}명',
    reviews: '후기',
    registerTitle: '체험 등록',
    stepCategory: '어떤 체험인가요?',
    stepBasic: '체험 정보',
    expTitle: '체험 제목',
    titlePlaceholder: '예: 다낭 쿠킹클래스 - 베트남 전통 요리',
    expDesc: '체험 소개',
    descPlaceholder: '체험 내용, 일정, 특징을 소개해주세요',
    price: '1인 가격',
    duration: '소요 시간',
    includes: '포함 사항',
    excludes: '불포함 사항',
    excludesPlaceholder: '예: 점심, 추가 음료 (쉼표로 구분)',
    stepLocation: '장소 및 언어',
    meetingPoint: '집합 장소',
    meetingPointPlaceholder: '예: 한시장 입구, 호텔 픽업',
    language: '진행 언어',
    stepContact: '연락처 및 확인',
    contactPhone: '전화번호',
    contactKakao: '카카오 오픈채팅',
    registerNoticeTitle: '등록 안내',
    registerNotice1: '등록 후 밍고 어드민 검토 후 승인됩니다',
    registerNotice2: '승인 후 체험 목록에 노출됩니다',
    registerNotice3: '허위 정보 등록 시 계정이 제한됩니다',
    registerSuccess: '체험이 등록됐습니다. 검토 후 승인됩니다',
    registerFail: '등록에 실패했습니다. 다시 시도해주세요',
    registerSubmit: '등록 신청하기',
  },
  valueAdd: {
    nlPageTitle: '뉴스레터·프리미엄',
    nlPageIntro: '신뢰 크리에이터의 심층 콘텐츠. 유료 티어로 아카이브가 열립니다.',
    nlSubscribe: '구독',
    nlSubSoon: '구독·결제는 이후 빌링 업데이트에서 열립니다.',
    nlPaid: '유료',
    nlFree: '무료',
    nlSubs: '구독자 {n}명',
    nlAuthor1: 'DN Weekly 편집부',
    nlAuthor2: '비즈 데스크',
    nlAuthor3: 'Mingo Tips',
    nlTitle1: '다낭 부동산 위클리',
    nlDesc1: '매물, 월세 추세, 용도지역 참고(법률 자문 아님).',
    nlCatRe: '부동산',
    nlTitle2: '베트남 비즈 인사이트',
    nlDesc2: '세금 알림, 법인 형태, SME 채용 기초.',
    nlCatBiz: '비즈니스',
    nlTitle3: '교민 생활 꿀팁',
    nlDesc3: '장보기, 학교, 주말 여행 — 커뮤니티 소스.',
    nlCatLife: '라이프',
    consultSection: '상담 슬롯 예약',
    consultPickDate: '날짜 선택',
    consultPickTime: '시간대 선택',
    consultMethod: '어떻게 만날까요?',
    consultVideo: '영상 통화',
    consultVoice: '음성 통화',
    consultInPerson: '대면(다낭)',
    consultConfirm: '예약 확정',
    consultConfirmSoon: '결제 연동 후 캘린더 예약이 동기화됩니다.',
    paPageTitle: '중고 경매',
    paPageIntro: '마켓플레이스 경매 — 에스크로·배송 규칙은 이후.',
    paEndsIn: '마감까지',
    paHigh: '현재 최고가',
    paOpen: '시작가',
    paBids: '입찰 {n}건',
    paBidSoon: '입찰(준비 중)',
    paBuyNowSoon: '즉시 구매(준비 중)',
    paBuyNowHint: '등록 중 약 {p} USD 즉시가.',
    paBidList: '최근 입찰',
    paTitle1: 'iPhone 15 Pro — 미개봉',
    riderTitle: '배달 라이더 허브',
    riderIntro: 'Mingo 배달 파트너 — 유연한 근무.',
    riderRegister: '라이더 되기',
    riderRegisterHint: '신원·장비 체크리스트는 온보딩 v2에 추가됩니다.',
    riderCta: '라이더 가입 시작',
    riderRegisterSoon: '곧 오픈 — 관심 목록에 등록됐습니다.',
    riderCalc: '수입 계산기(데모)',
    riderHours: '활동 시간/일',
    riderDrops: '완료 배송/일',
    riderPerDrop: '건당 평균 지급(₫)',
    riderEst: '예상 일 수입',
    riderEstNote: '(플랫폼 수수료 전, 참고용)',
    riderStatus: '실시간 배달 지도',
    riderStatusSoon: '라이브 지도 — 곧',
    petHotelSection: '펫호텔·위탁',
    petHotelPerNight: '/박부터',
    petHotelBookSoon: '숙박 예약(준비 중)',
    ph1Name: 'Paw Beach Resort',
    ph2Name: 'Son Tra Pet Lodge',
    ph3Name: 'An Thuong Cat Hotel',
    petDog: '강아지',
    petCat: '고양이',
    petSmall: '소형 반려동물',
    finTitle: '재무 플래너',
    finIntro: '비공개 초안 — 클라우드 동기 전까지 기기에만 저장.',
    finCashflow: '월 현금흐름',
    finIncome: '수입',
    finExpense: '지출',
    finSurplus: '잉여',
    finGoal: '저축 목표',
    finGoalMonthly: '월 목표 저축',
    finGoalOk: '월 저축 목표를 충족했습니다.',
    finGoalGap: '월 저축 목표 대비 약 {gap} USD 부족합니다.',
    finAssets: '자산',
    finAssetsTotal: '자산 합계',
    finFx: '환율 스냅샷',
    finFxHint: 'Open Exchange Rates(USD 기준). 결정 전 은행과 확인하세요.',
    finConvAssets: 'VND 환산 자산(참고)',
    pmTitle: '포인트 마켓',
    pmIntro: '포인트로 혜택 교환 — 재고는 리워드와 동기화.',
    pmRedeem: '교환',
    pmRedeemSoon: '결제 오픈 시 포인트가 차감됩니다.',
    pmCoffee: '카페 쿠폰(파트너)',
    pmDelivery: '배달비 면제',
    pmCredit: '광고 크레딧(소)',
    pmPremium: '프리미엄 주간 패스',
    botFab: 'Mingo 어시스턴트 열기',
    botTitle: 'Mingo 어시스턴트',
    botLead: 'Mingo, 비자, 어떤 메뉴를 열지 궁금하신가요?',
    botChipVisa: '베트남 관광비자 연장 설명',
    botChipServices: '다낭 신규 입국자에게 맞는 서비스 추천',
    botChipSafety: 'Mingo가 사기를 피하는 데 어떻게 도우나요?',
    botPh: '무엇이든 물어보세요…',
    botSend: '보내기',
    botTyping: '생각 중…',
    botNoKey: 'AI 채팅은 로그인과 서버 ANTHROPIC_API_KEY가 필요합니다. 그동안: 생활정보→비자, 또는 커뮤니티.',
    botErr: 'AI에 연결하지 못했습니다. 다시 시도하거나 FAQ 칩을 사용하세요.',
    botDisclaimer: 'AI 답변은 정보용이며 법률 자문이 아닙니다. 공식 출처를 확인하세요.',
    botFaq1q: 'Mingo란?',
    botFaq1a: '교민 안전·생활 정보 앱: 검증 목록, 커뮤니티, 다낭 등 지역 서비스.',
    botFaq2q: '비자 알림은 어디서?',
    botFaq2a: '프로필→비자 만료일, 또는 메뉴의 비자·행정 가이드.',
    botFaq3q: '사기 매물은 어떻게 신고?',
    botFaq3a: '매물 열기→신고, 또는 SOS→사기/사기 도움.',
  },
  finalExp: {
    tourListTitle: '투어·패키지',
    tourListIntro: '다낭·중부 베트남 큐레이션. 예약은 곧 — 오늘은 가이드와 채팅해 보세요.',
    tourDetailTitle: '투어',
    catAll: '전체',
    tourCatHalf: '반나절',
    tourCatDay: '1일',
    tourCatMulti: '2일 이상',
    tourCatCulture: '문화',
    tourCatNature: '자연',
    tourCatFood: '맛집',
    tourCatGolf: '골프',
    tourDays: '{n}일',
    tourHours: '{n}시간',
    tourDayTrip: '당일 투어',
    tourPax: '{min}–{max}명',
    departure: '출발',
    priceFrom: '부터',
    includes: '포함',
    excludes: '불포함',
    itinerary: '일정',
    meeting: '집합 장소',
    guide: '가이드',
    bookSoon: '예약(준비 중)',
    reviews: '리뷰',
    backToTours: '전체 투어',
    tourDnHalfTitle: '다낭 반나절 하이라이트',
    tourHoiTitle: '호이안 올드타운 종일 산책',
    tourBanaTitle: '바나힐 & 골든브릿지',
    tourMysonTitle: '미선 유적 오전',
    tourHueTitle: '후에 왕궁(2일)',
    tourDnHalfDesc: '오행산, 해변 도로, 한국어 가능 가이드와 로컬 카페.',
    tourHoiDesc: '올드타운 골목, 보트, 랜턴 거리와 여유로운 사진.',
    tourBanaDesc: '케이블카, 프랑스 마을, 정원 — 더위·혼잡을 피해 이른 출발.',
    tourMysonDesc: 'UNESCO 참 탑 역사 해설, 점심 전 복귀.',
    tourHueDesc: '왕궁, 능, 향수 강 크루즈와 후에 1박.',
    tourMeetingDn: '다낭 시내(해변 쪽) 호텔 로비 — 전날 확정.',
    inc1: '에어컨 밴·면허 기사',
    inc2: '영어 가이드',
    incWater: '생수',
    incVan: '왕복 이동',
    incBoat: '보트 티켓(해당 시)',
    incCable: '바나 케이블카 티켓',
    incHotel: '후에 1박(트윈)',
    excLunch: '점심(자유 또는 추가)',
    excTips: '개인 쇼핑·팁',
    excPersonal: '싱글룸 업그레이드(선택)',
    itPick: '픽업',
    itPickDn: '해변 호텔 / 안쭝 일대',
    itPickHotel: '호텔 로비',
    itPickEarly: '더 서늘한 유적 방문을 위한 이른 출발',
    itMarble: '오행산',
    itMarbleDesc: '엘리베이터 또는 계단 — 파노라마.',
    itLunch: '점심',
    itLunchFree: '쌀국수 또는 한국어 가능 카페.',
    itBeach: '미케 해변 드라이브',
    itBeachDesc: '포토 스탑과 바닷바람.',
    itHoi: '호이안 올드타운',
    itHoiDesc: '일본 다리, 회관, 공예 거리.',
    itLantern: '랜턴 거리',
    itLanternDesc: '노을과 랜턴(선택).',
    itCable: '바나 케이블카',
    itCableDesc: '산악 기후 — 가벼운 겉옷.',
    itGarden: '르 자르댕 다무르',
    itGardenDesc: '정원 산책과 자유 시간.',
    itMyson: '미선 유적',
    itMysonDesc: '참 건축과 정글.',
    itDepart: '후행 이동',
    itDepartHue: '휴게소 포함 고속 이동.',
    itCitadel: '후에 왕궁',
    itCitadelDesc: '황궁 문과 궁전 유적.',
    itDinner: '로컬 디너',
    itDinnerHue: '궁중 스타일 소접시(데모 메뉴).',
    guideKim: '김 가이드 — 다낭 6년, 한/영.',
    guideLee: '이 가이드 — 호이안 전문, 한/영.',
    guidePark: '박 가이드 — 산악 루트, 한/영/베.',
    guideTran: '현지 전문가 Tran — 영/베, 역사.',
    guideHueTeam: '2일 팀: 김 + 후에 역사학자.',
    rev1: '시간 잘 지키고 즐거움 — 아이가 해변 스탑을 좋아했어요.',
    rev2: '설명이 명확하고 소그룹이 VIP 같았어요.',
    rev3: '사진·음식 페이싱이 완벽했어요.',
    rev4: '바나는 겉옷 챙기세요 — 가이드가 미리 알려줘서 다행이었어요.',
    rev5: '이른 기상 가치 있음; 유적 한산.',
    rev6: '후에 호텔 깨끗하고 기사님이 안전했어요.',
    interiorTitle: '인테리어·리모델',
    interiorIntro: '검증 시공사 전후 포트폴리오. 견적 플로우 곧 오픈.',
    intTypeFull: '풀 패키지',
    intTypePartial: '부분 시공',
    intTypeFurniture: '가구',
    intTypePaint: '페인트·벽',
    before: '전',
    after: '후',
    durationDays: '약 {n}일',
    priceRange: '최저–최고',
    quoteCta: '견적 요청',
    quoteSoon: '견적은 곧 — 관심은 저장했습니다.',
    int1Name: '아파트 풀 리모델(안쭝)',
    int1Desc: '오픈 키친, 수납, LED.',
    int2Name: '욕실·습식 존 리프레시',
    int2Desc: '방수, 레인 샤워, 세면대 교체.',
    int3Name: '가구 패키지 — 투룸 익스팻',
    int3Desc: '소파, 침대, 책상 — 1주 설치.',
    talentTitle: '재능 마켓',
    talentIntro: '번역, 디자인, 레슨 등 커뮤니티 프리랜스.',
    talCatTranslate: '번역',
    talCatDesign: '디자인',
    talCatDev: '개발',
    talCatLesson: '레슨',
    talCatWriting: '글쓰기',
    talCatVideo: '영상',
    talCatOther: '기타',
    deliveryIn: '{n}일 내 배송',
    orders: '주문 {n}건',
    orderSoon: '주문(준비 중)',
    tal1Title: '한↔베 문서 번역',
    tal1Desc: '계약, 주거, 병원 서류 — 필요 시 공증 파트너.',
    tal2Title: '소상공 로고·브랜드 키트',
    tal2Desc: '컨셉 3종, 벡터, 팔레트 가이드.',
    tal3Title: '한국어 회화(온라인)',
    tal3Desc: '50분, 초·중급.',
    tal4Title: '베트남 생존 회화',
    tal4Desc: '시장, 택시, 집주인 대화.',
    tal5Title: '숏폼 영상 편집',
    tal5Desc: '릴스/틱톡 자막·색보정.',
    tal6Title: 'SNS 마케팅 월 패키지',
    tal6Desc: '게시 4 + 스토리 8 + 카피.',
    tal7Title: '랜딩 페이지(React 인수인계)',
    tal7Desc: '모바일 우선, 문의 폼, 분석 훅.',
    tal8Title: '한국어 블로그·뉴스레터 대필',
    tal8Desc: '톤 맞춤 기사.',
    subTitle: '구독 박스',
    subIntro: '한국 간식·웰니스 — 판매자에게 반복 매출, 이용자에게 편의.',
    subIncludes: '대표 구성',
    subMonthly: '월 정액',
    subSoon: '구독(준비 중)',
    subNotify: '결제 오픈 시 알려드립니다.',
    subKfoodName: '한국 식료 박스',
    subKfoodDesc: '간식, 라면, 소스 — 매월 큐레이션.',
    subItemSnacks: '간식팩 2',
    subItemRamen: '라면 4종',
    subItemSauce: '프리미엄 소스 1',
    subBeautyName: '뷰티·웰니스 박스',
    subBeautyDesc: '시트팩, 비타민, 허브티.',
    subItemMask: '시트팩 5',
    subItemVit: '비타민 번들 1',
    subItemTea: '웰니스 티 세트',
    groupsTitle: '그룹 채팅',
    groupsIntro: '다낭 주제방 — 메시징은 이후 업데이트.',
    grpCatRegion: '지역',
    grpCatInterest: '관심사',
    grpCatJob: '구인',
    grpCatParent: '육아',
    grpCatRe: '부동산',
    grpCatInvest: '투자',
    members: '멤버',
    join: '참여',
    joinSoon: '참여 요청 저장 — 채팅 곧.',
    grp1Name: '다낭 한인(일반)',
    grp1Desc: '공지, Q&A, 모임.',
    grp2Name: '다낭 맛탐방',
    grp2Desc: '신상, 브런치, 배달 팁.',
    grp3Name: '다낭 부동산 데스크',
    grp3Desc: '월세·매매 — 직접 검증하세요.',
    grp4Name: '다낭 육아',
    grp4Desc: '학교, 소아과, 놀이.',
    grp5Name: '다낭 골프 크루',
    grp5Desc: '주말 티업·동승.',
    luxuryTitle: '중고 명품',
    luxuryIntro: '표기된 인증 — 결제 전 채팅으로 확인.',
    brandChanel: 'Chanel',
    brandLv: 'Louis Vuitton',
    brandGucci: 'Gucci',
    brandHermes: 'Hermès',
    authBadge: '인증',
    lux1Name: '클래식 플랩 미디엄(블랙)',
    lux2Name: '스피디 30 모노그램',
    lux3Name: '에이스 스니커즈(EU 42)',
    lux4Name: '실크 스카프 90×90',
    lux5Name: '이니셜 양면 벨트',
    condExc: '최상',
    condVgood: '상',
    condGood: '양호',
    condNew: '거의 새것',
    flightTitle: '항공권 검색',
    flightIntro: 'Skyscanner로 요금 비교 — 링크 예약 시 Mingo에 파트너 수수료가 발생할 수 있습니다.',
    flightFrom: '출발(IATA)',
    flightTo: '도착(IATA)',
    flightDepart: '출발일',
    flightReturn: '귀국(선택)',
    flightPax: '승객',
    flightClass: '좌석 등급',
    flightSearch: 'Skyscanner에서 검색',
    flightNeedDate: '먼저 출발일을 선택하세요.',
    flightOpened: '새 탭에서 Skyscanner를 엽니다.',
    flightAffiliateHint: '요금·규정은 항공사·OTA가 정합니다. 수하물·비자를 다시 확인하세요.',
    cabinEco: '이코노미',
    cabinPremEco: '프리미엄 이코노미',
    cabinBiz: '비즈니스',
    cabinFirst: '퍼스트',
  },
  fffExp: {
    liveTitle: '라이브 커머스',
    liveIntro: '라이브 중 쇼핑 — 결제는 이후 버전에서 연결.',
    liveTabLive: '라이브 중',
    liveTabUp: '예정',
    liveTabPast: '지난 방송',
    liveEnter: '방 입장',
    liveEnterSoon: '라이브 플레이어 준비 중.',
    liveViewers: '{n}명 시청',
    liveStarts: '{d} 시작',
    livePeak: '피크 {n}명',
    liveEnded: '다시보기·하이라이트 곧',
    liveKfoodTitle: '한국 식료 라이브 — 간식·라면',
    liveReTitle: '다낭 부동산 워크스루',
    liveLocalFoodTitle: '야시장 로컬 푸드 투어',
    catGrocery: '식료',
    catRealEstate: '부동산',
    catFood: '음식',
    hostKim: '호스트 Kim',
    hostLan: '호스트 Lan',
    hostPark: '호스트 Park',
    cfTitle: '크라우드펀딩',
    cfIntro: '교민 주도 프로젝트 후원 — 결제 에스크로는 이후.',
    cfEnds: '{d} 마감',
    cfBack: '프로젝트 후원',
    cfBackSoon: '후원 결제 준비 중.',
    cf1Title: '다낭 한식당 오픈',
    cfCatRestaurant: '식당',
    cf2Title: '한국 식품 수입 소규모',
    cfCatImport: '수입·소매',
    cf3Title: 'Mingo 앱 기능 확장',
    cfCatTech: '제품·기술',
    cwTitle: '코워킹·공유 오피스',
    cwIntro: '핫데스크·회의실.',
    cw1Name: 'Beach Hub Coworking',
    cw2Name: 'An Thuong Work Lounge',
    cw3Name: 'Han River Studio',
    cwCap: '수용 약 {n}명',
    cwBookSoon: '데스크 예약(준비 중)',
    amWifi: 'Wi‑Fi',
    amCoffee: '커피',
    amMeeting: '회의실',
    amPrint: '프린터',
    am24: '24/7 출입',
    amPhone: '폰부스',
    recipeTitle: '레시피·요리',
    recipeIntro: '커뮤니티 레시피와 다낭 오프라인 클래스.',
    catAll: '전체',
    recipeKorean: '한식',
    recipeViet: '베트남',
    recipeSnack: '간식',
    recipeTime: '{n}분',
    recipeServings: '{n}인분',
    recipeIngredients: '재료',
    recipeSteps: '만드는 법',
    recipeLike: '좋아요',
    recipeSave: '저장',
    recipeLikeToast: '좋아요 저장(데모).',
    recipeSaveToast: '목록에 저장(데모).',
    rpPhoTitle: '집에서 끓이는 쌀국수 육수',
    rpPhoDesc: '향신료 풍부한 소고기 육수 — 주말 프로젝트.',
    rpKimchiTitle: '김치찌개',
    rpKimchiDesc: '숙성 김치로 든든하게.',
    rpBanhmiTitle: '집에서 반미',
    rpBanhmiDesc: '바삭한 바게트, 피클, 속재료.',
    rpTteokTitle: '빠른 떡볶이',
    rpTteokDesc: '길거리 스타일 매콤한 떡.',
    rpSpringTitle: '신선한 스프링롤',
    rpSpringDesc: '땅콩 소스와 고이쿤.',
    diffEasy: '쉬움',
    diffMed: '보통',
    ccSection: '요리 클래스',
    cc1Title: '바인쎄오 바삭하게',
    cc1Desc: '반죽, 속, 소스까지.',
    cc1When: '토 10:00 · 미케 일대',
    cc2Title: '한식 반찬 기초',
    cc2Desc: '반찬 3종 + 밥 페어링 팁.',
    cc2When: '일 14:00 · 시내 키친랩',
    ccMax: '최대 {n}명',
    ccBookSoon: '예약(준비 중)',
    aucTitle: '부동산 경매',
    aucIntro: '선별 매물 투명 입찰 — 권리·세금은 반드시 확인.',
    aucEndsIn: '남은 시간',
    aucCurrent: '현재가',
    aucStart: '시작가',
    aucBuyout: '즉시 구매',
    aucBids: '입찰 {n}건',
    aucBidSoon: '입찰(준비 중)',
    aucHistory: '입찰 내역',
    auc1Title: '미케 전망 콘도',
    aucRegion: '다낭 · 썬짜',
    bidderA: '입찰자 A',
    bidderB: '입찰자 B',
    bidderC: '입찰자 C',
    rewTitle: '리워드·연속 출석',
    rewCheckin: '일일 출석',
    rewStreakLine: '연속 {n}일',
    rewCheckinBtn: '오늘 출석',
    rewDoneToday: '오늘 출석 완료',
    rewAlready: '오늘은 이미 출석했습니다.',
    rewCheckinOk: '+{pts} P(데모). 연속을 이어가세요!',
    rewMissions: '미션',
    rewBadges: '뱃지',
    rewLeader: '리더보드(데모)',
    rewPointsHint: '포인트 내역',
    mis1: '커뮤니티에 검증된 안전 팁 올리기',
    mis2: '비자 만료 알림 완료하기',
    mis3: '즐겨찾기 업체 3곳 저장',
    badgeSafe: 'SafePath 서포터',
    badgeFirstTrade: '첫 거래 완료',
    badgeStreak: '7일 연속',
    mapTitle: '지도 검색',
    mapIntro: '지도에서 주변 서비스를 탐색합니다. API 키 설정 시 Kakao/Google 지도로 대체 가능.',
    mapFrameTitle: '다낭 지도 미리보기',
    mapSdkHint: 'Kakao/Google Maps SDK: env에 키를 넣으면 길찾기·마커가 풍부해집니다.',
    mapNearby: '주변(데모)',
    mapSelected: '선택: {name}',
    mapP1: '한식 골목(안쭝)',
    mapP2: '가족 클리닉(영어 데스크)',
    mapP3: '스페셜티 카페·워크스페이스',
    mapCatFood: '음식',
    mapCatHospital: '클리닉',
    mapCatCafe: '카페',
  },
  groups: {
    title: '모임',
    myGroups: {
      pendingSection: '승인 대기',
      pendingBadge: '대기 중',
      organizerBadge: '운영자',
    },
    searchPlaceholder: '모임 검색',
    create: '+ 만들기',
    loadFailed: '모임 목록을 불러오지 못했습니다.',
    empty: '이 지역에 표시할 모임이 없습니다.',
    loginToJoin: '로그인 후 가입할 수 있습니다.',
    btn: {
      manage: '관리',
      enter: '입장',
      join: '가입하기',
      apply: '가입 신청',
      leave: '탈퇴',
      disband: '모임 해체',
      disbandConfirm: '해체하기',
      inAppChat: '인앱채팅',
      externalChat: '외부채팅',
    },
    chatRoomError: '채팅방을 열 수 없습니다',
    join: '가입하기',
    joining: '처리 중…',
    joinSuccess: '모임에 가입했습니다.',
    joinFailed: '가입에 실패했습니다.',
    alreadyMember: '이미 가입한 모임입니다.',
    groupFull: '정원이 가득 찼습니다.',
    leave: '탈퇴',
    leaveSuccess: '모임에서 탈퇴했습니다.',
    leaveFailed: '탈퇴에 실패했습니다.',
    deleteConfirmMessage: '모임을 해체하면 되돌릴 수 없어요. 정말 해체하시겠어요?',
    deleteSuccess: '모임이 해체됐어요',
    deleteError: '해체 처리에 실패했어요',
    deleting: '처리 중...',
    notFound: '모임을 찾을 수 없습니다.',
    regionUnset: '지역 미설정',
    memberCount: '멤버 {count}명',
    maxMembers: '최대 {max}명',
    filterAll: '전체',
    filterFree: '무료',
    filterPaid: '유료',
    paidFilterLabel: '무료·유료 필터',
    cat: {
      all: '전체',
      sports: '운동/스포츠',
      learning: '언어교환',
      food: '맛집',
      support: '종교/신앙',
      general: '일반',
      jobs: '비즈니스',
      parenting: '육아',
      gaming: '게임',
      culture: '문화/예술',
    },
    type: {
      general: '일반',
      sports: '운동/스포츠',
      learning: '스터디/학습',
      culture: '문화/예술',
      support: '종교/신앙',
      jobs: '구인구직',
      parenting: '육아/가족',
      buy_sell: '공동구매',
      gaming: '게임',
      flash: '번개',
    },
    privacy: {
      public: '공개',
      private: '비공개',
      secret: '비밀',
    },
    badge: {
      free: '무료',
      paid: '유료',
      diamond: '다이아',
      gold: '골드',
      silver: '실버',
      bronze: '브론즈',
    },
    escrowNotice: '가입비는 플랫폼이 보관하며, 첫 모임 이벤트 완료 후 운영자에게 정산됩니다.',
    joinFeeConfirm: '가입비를 포인트로 결제합니다.',
    joinFeeLabel: '가입비',
    myPoints: '내 보유 포인트',
    chargePoints: '포인트 충전하기',
    insufficientPoints: '포인트가 부족합니다. 충전 후 가입해 주세요.',
    pendingApproval: '승인 대기 중',
    kickMember: '강퇴',
    kickConfirm: '이 멤버를 강퇴할까요?',
    kickSuccess: '멤버를 강퇴했습니다.',
    promoteMember: '운영자 지정',
    promoteSuccess: '운영자로 지정했습니다.',
    approve: '승인',
    reject: '거절',
    approveSuccess: '가입을 승인했습니다.',
    rejectSuccess: '가입을 거절했습니다.',
    actionFailed: '처리에 실패했습니다.',
    pendingSection: '가입 대기',
    recurringEvent: '정기 모임',
    sponsoredBusiness: '제휴 업체',
    sponsoredPlaceholder: '제휴 업체 정보가 곧 연결됩니다.',
    translatePost: '번역하기',
    tab: {
      board: '게시판',
      members: '멤버',
      events: '이벤트',
      info: '정보',
      revenue: '수익',
    },
    postPlaceholder: '모임에 글 남기기',
    post: '게시',
    posting: '등록 중…',
    postSuccess: '게시했습니다.',
    postFailed: '게시에 실패했습니다.',
    boardMembersOnly: '게시판은 멤버만 이용할 수 있습니다. 가입 후 이용해 주세요.',
    notice: '공지',
    memberFallback: '회원',
    noPosts: '게시글이 없습니다.',
    createEvent: '번개 만들기',
    upcomingEvents: '다가오는 번개',
    pastEvents: '지난 번개',
    noUpcomingEvents: '예정된 번개가 없습니다.',
    noPastEvents: '지난 번개가 없습니다.',
    eventTitlePh: '번개 제목 (예: 오늘 저녁 치맥)',
    selectDate: '날짜 선택',
    eventLocationPh: '장소',
    eventMaxParticipantsPh: '인원 제한 (선택)',
    eventMaxParticipantsShort: '인원',
    eventMoreFields: '설명·비용 추가',
    eventDescriptionPh: '설명 / 준비물 (선택)',
    eventFeePh: '참가비 포인트 (선택)',
    eventSubmit: '번개 만들기',
    eventCreated: '번개가 등록됐어요',
    eventCreateError: '번개 등록에 실패했어요',
    eventRequiredFields: '제목과 일시는 필수예요',
    eventJoin: '참가하기',
    eventLeave: '참가 취소',
    eventParticipantsSuffix: '명 참가',
    eventFeeLabel: '참가비 {points}P',
    eventFeePrefix: '참가비',
    manageTitle: '모임 관리',
    searchMembers: '멤버 검색',
    membersUnit: '명',
    noMembersFound: '검색 결과가 없습니다.',
    manageForbidden: '모임 관리 권한이 없습니다.',
    eventViewParticipants: '참가자 보기',
    eventChat: '번개 채팅',
    eventChatError: '채팅방을 열 수 없어요',
    moreOptions: '더보기',
    eventJoinErrorGeneric: '참가 처리에 실패했어요',
    creating: '등록 중…',
    eventJoinError: {
      event_full: '정원이 가득 찼어요',
      not_a_group_member: '모임 멤버만 참가할 수 있어요',
    },
    noDescription: '소개가 없습니다.',
    rules: '모임 규칙',
    schedule: '정기 일정',
    createdAt: '개설일',
    revenueTotal: '총 수입 (운영자 몫)',
    revenueMonth: '이번 달',
    requestPayout: '정산 신청',
    payoutSoon: '정산 신청은 준비 중입니다.',
    noRevenue: '수익 내역이 없습니다.',
    mna: {
      title: '모임 M&A',
      desc: '다른 모임과 합병하거나 운영권을 양도할 수 있습니다.',
      merge: '다른 모임과 합병하기',
      transfer: '운영권 양도 (판매)',
      minMembersNotice: '현재 {{count}}명 · M&A는 {{required}}명 이상만 가능합니다',
      voteTitle: '합병 투표',
      voteDesc: '우리 모임이 합병을 진행합니다. 동의하십니까?',
      voteYes: '찬성',
      voteNo: '반대',
      voteWarning: '합병 확정 후 새 모임 참여 여부를 직접 선택할 수 있습니다.',
      voteDeadline: '투표 마감 D-{{days}}일',
      voteStats: '찬성 {{yes}}% · 반대 {{no}}%',
      escrowNotice: '거래 대금은 14일간 에스크로 보관 후 정산됩니다',
      adminReview: '고액 거래는 어드민 검토 후 진행됩니다 (50,000P 이상)',
      feePct: '플랫폼 수수료 15%',
      paidOnly: '유료 모임만 합병/양도 가능합니다',
      paidDurationNotice: '유료 유지 {{remaining}}개월 후 양도 가능합니다',
      insufficientManagers: '매니저 {{count}}명 · 3명 이상 임명 후 신청 가능',
      managerApprovalTitle: '운영진 사전 동의',
      managerApprovalDesc: '{{name}} 모임의 합병/양도 신청에 동의하시겠습니까?',
      managerApprovalExpiry: '{{days}}일 내 응답 필요',
      managerApproved: '동의하기',
      managerRejected: '거절하기',
      managerRejectHint: '거절 시 신청이 즉시 취소됩니다',
      submit: '신청하기',
      submitSuccess: 'M&A 신청이 접수되었습니다. 운영진 동의를 기다립니다.',
      submitFailed: '신청에 실패했습니다.',
      eligible: '신청 자격을 충족합니다',
      targetGroup: '합병 대상 모임',
      pickTarget: '대상 모임 선택',
      newNameOptional: '합병 후 모임명 (선택)',
      priceLabel: '양도 가격 (포인트)',
      buyerIdOptional: '구매자 ID (선택)',
      votingInProgress: '합병 투표가 진행 중입니다',
      voteRecorded: '투표가 반영되었습니다',
      voteFailed: '투표에 실패했습니다',
      mergeChoiceTitle: '합병이 확정되었습니다',
      mergeChoiceDesc: '새 모임에 계속 참여하시겠습니까?',
      mergeChoiceStay: '새 모임 유지',
      mergeChoiceLeave: '탈퇴하기',
      mergeChoiceExpiry: '{{days}}일 내 선택하지 않으면 자동으로 새 모임에 유지됩니다.',
    },
  },
  myReservations: {
    title: '예약 내역',
    loading: '불러오는 중...',
    empty: '예약 내역이 없습니다',
    browseServices: '서비스 둘러보기',
    businessNameFallback: '업체명',
    partySize: '{n}명',
    noShowLimited: '노쇼 {count}회 — 예약 기능이 제한됩니다',
    noShowWarning: '노쇼 {count}회 — 3회 이상 시 예약이 제한됩니다',
    noShowContact: '고객센터에 문의하여 제한을 해제하세요.',
    cancelBtn: '예약 취소',
    cancelConfirm: '예약을 취소하시겠습니까?',
    cancelSuccess: '예약이 취소되었습니다.',
    cancelFail: '취소에 실패했어요.',
    status: {
      pending: '대기중',
      holding: '결제확인중',
      confirmed: '확정',
      in_progress: '진행중',
      cancelled: '취소',
      failed: '실패',
      completed: '완료',
    },
  },
};

export default deepMerge(ko, phaseMyPageDashboardKo, phaseE1Ko, phaseE2Ko, phaseE3Ko, phaseE4Ko, phaseGroupsCreateKo, phaseGroupsListDetailKo, phaseGroupCategoriesKo, phaseTradeChatKo, phaseHandleH0Ko, phaseP0DashKo, phaseP0CatalogKo, phaseManageWidgetsKo, phaseFoodOrderFlowKo, phaseBrandCatalogKo, phaseMenuFeedKo, phaseBrandPageKo, phaseLocationSetupKo, phaseUserAddressBookKo, phaseHomeWeatherHourlyKo, phaseLostFoundResolveKo, phaseAdminCoreKo, phaseBusinessRegInquiryKo, phaseJobsHireGateKo, phaseSearchSurfaceKo, phaseHubEmptyKo, phaseBizNotifKo, phaseCatalogBookingKo, phaseCreatorCommissionKo, phaseTravelerFormKo, phaseRestaurantRegisterKo, phaseLocalRegisterChipsKo, phaseMentorBusinessRegisterKo, phaseLocalRegisterChips2Ko, phaseWriteChipsKo, phaseLiveHangulKo, getShellUiOverlay('ko'), getScreenUiOverlay('ko'));
